import { defineComponent as Y, openBlock as v, createElementBlock as w, normalizeClass as m, createElementVNode as g, useSlots as et, computed as I, useCssModule as he, createBlock as L, resolveDynamicComponent as We, unref as c, withCtx as ee, Fragment as ae, renderSlot as H, createCommentVNode as E, ref as ie, withModifiers as Je, createTextVNode as Q, toDisplayString as z, createVNode as j, renderList as ue, createSlots as ct, normalizeProps as Me, guardReactiveProps as Te, withDirectives as it, mergeDefaults as Ke, vModelDynamic as Ei, vModelText as xi, createStaticVNode as Nn, h as Sn, nextTick as pt, mergeProps as De, resolveDirective as Ii, toHandlers as aa, vShow as sn, Transition as Li, watch as Ct, onUnmounted as $t, markRaw as ia, onMounted as sa, resolveComponent as la, normalizeStyle as dt, useCssVars as ua, useAttrs as Bi, mergeModels as Vi, useModel as Pi } from "vue";
import { RouterLink as Xr } from "vue-router";
import { VueFinalModal as ca } from "vue-final-modal";
import { useDebounceFn as ji, useResizeObserver as Ni, onClickOutside as Fn, objectOmit as da, useIntersectionObserver as Fi } from "@vueuse/core";
import fa from "vuedraggable";
import { useVuelidate as pa } from "@vuelidate/core";
import { helpers as dr, required as fr } from "@vuelidate/validators";
import { Chrome as Ri } from "@lk77/vue3-color";
var An = /* @__PURE__ */ ((t) => (t.BUTTON = "button", t.LINK = "a", t))(An || {}), En = /* @__PURE__ */ ((t) => (t.PRIMARY = "primary", t.PRIMARY_OUTLINE = "primary-outline", t.SECONDARY_OUTLINE = "secondary-outline", t.ACTION = "action", t.BASIC = "basic", t.ICON = "icon", t))(En || {}), Hi = /* @__PURE__ */ ((t) => (t.SUBMIT = "submit", t.RESET = "reset", t.CANCEL = "cancel", t.SUCCESS = "success", t))(Hi || {}), pr = /* @__PURE__ */ ((t) => (t.EXTRA_SMALL = "xs", t.SMALL = "sm", t.MEDIUM = "md", t))(pr || {}), Pt = /* @__PURE__ */ ((t) => (t.SMALL = "small", t.MEDIUM = "medium", t.LARGE = "large", t))(Pt || {}), $r = /* @__PURE__ */ ((t) => (t.PRIMARY = "primary", t.SECONDARY = "secondary", t))($r || {});
const zi = /* @__PURE__ */ g("div", null, null, -1), Yi = /* @__PURE__ */ g("div", null, null, -1), Ui = /* @__PURE__ */ g("div", null, null, -1), qi = /* @__PURE__ */ g("div", null, null, -1), Wi = [
  zi,
  Yi,
  Ui,
  qi
], Ki = /* @__PURE__ */ Y({
  __name: "VSpinner",
  props: {
    size: { default: Pt.MEDIUM },
    variant: { default: $r.PRIMARY }
  },
  setup(t) {
    return (n, e) => (v(), w("div", {
      class: m([
        n.$style["v-spinner"],
        n.$style[`v-spinner--${n.variant}`],
        n.$style[`v-spinner--${n.size}`]
      ])
    }, Wi, 2));
  }
}), Gi = {
  "v-spinner": "_v-spinner_4ds4o_1",
  "v-spinner-animation": "_v-spinner-animation_4ds4o_1",
  "v-spinner--large": "_v-spinner--large_4ds4o_23",
  "v-spinner--medium": "_v-spinner--medium_4ds4o_33",
  "v-spinner--small": "_v-spinner--small_4ds4o_43",
  "v-spinner--primary": "_v-spinner--primary_4ds4o_53",
  "v-spinner--secondary": "_v-spinner--secondary_4ds4o_57"
}, V = (t, n) => {
  const e = t.__vccOpts || t;
  for (const [r, o] of n)
    e[r] = o;
  return e;
}, Zi = {
  $style: Gi
}, kr = /* @__PURE__ */ V(Ki, [["__cssModules", Zi]]), Ji = /* @__PURE__ */ Y({
  __name: "VButton",
  props: {
    variant: { default: En.PRIMARY },
    size: { default: pr.MEDIUM },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    tag: { default: An.BUTTON },
    rel: { default: null },
    active: { type: Boolean, default: !1 },
    fixedWidth: { type: Boolean, default: !0 },
    href: { default: null },
    target: {},
    type: { default: null },
    fill: { type: Boolean, default: !1 },
    iconRight: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = et(), a = I(() => pr.EXTRA_SMALL === e.size ? Pt.SMALL : Pt.MEDIUM), s = I(() => !!o.icon), i = I(() => e.loading || e.disabled), l = he();
    return (d, p) => (v(), L(We(d.tag), {
      class: m([
        c(l)["v-button"],
        c(l)[`v-button--${d.variant}`],
        c(l)[`v-button--${d.size}`],
        c(l)[`v-button--${d.type}`],
        {
          [c(l)["v-button--has-icon"]]: !d.loading && s.value,
          [c(l)["v-button--fill"]]: d.fill,
          [c(l)["v-button--active"]]: d.active,
          [c(l)["v-button--not-fixed-width"]]: !d.fixedWidth
        }
      ]),
      rel: d.rel,
      href: d.href,
      type: d.type || "button",
      target: d.target,
      disabled: i.value || null,
      onClick: p[0] || (p[0] = (_) => r("click"))
    }, {
      default: ee(() => [
        d.loading ? (v(), L(c(kr), {
          key: 0,
          size: a.value,
          variant: c($r).SECONDARY
        }, null, 8, ["size", "variant"])) : (v(), w(ae, { key: 1 }, [
          d.iconRight ? E("", !0) : H(d.$slots, "icon", { key: 0 }),
          H(d.$slots, "default"),
          d.iconRight ? H(d.$slots, "icon", { key: 1 }) : E("", !0)
        ], 64))
      ]),
      _: 3
    }, 8, ["class", "rel", "href", "type", "target", "disabled"]));
  }
}), Xi = {
  "v-button": "_v-button_11ohb_1",
  "v-button--fill": "_v-button--fill_11ohb_23",
  "v-button--xs": "_v-button--xs_11ohb_29",
  "v-button--not-fixed-width": "_v-button--not-fixed-width_11ohb_36",
  "v-button--md": "_v-button--md_11ohb_39",
  "v-button--has-icon": "_v-button--has-icon_11ohb_43",
  "v-button--primary": "_v-button--primary_11ohb_49",
  "v-button--primary-outline": "_v-button--primary-outline_11ohb_65",
  "v-button--secondary-outline": "_v-button--secondary-outline_11ohb_83",
  "v-button--basic": "_v-button--basic_11ohb_101",
  "v-button--icon": "_v-button--icon_11ohb_117",
  "v-button--action": "_v-button--action_11ohb_132",
  "v-button--active": "_v-button--active_11ohb_142",
  "v-button--cancel": "_v-button--cancel_11ohb_150",
  "v-button--success": "_v-button--success_11ohb_154",
  "v-button--sm": "_v-button--sm_11ohb_173"
}, Qi = {
  $style: Xi
}, xn = /* @__PURE__ */ V(Ji, [["__cssModules", Qi]]), es = {}, ts = {
  width: "6",
  height: "10",
  viewBox: "0 0 6 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ns = /* @__PURE__ */ g("path", {
  d: "M1 9L5 5L1 1",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), rs = [
  ns
];
function os(t, n) {
  return v(), w("svg", ts, rs);
}
const vt = /* @__PURE__ */ V(es, [["render", os]]), as = /* @__PURE__ */ Y({
  __name: "VNavItem",
  props: {
    collapsed: { type: Boolean },
    icon: { default: null },
    title: { default: "" },
    to: { default: "" },
    action: {},
    active: { type: Boolean },
    subRoutes: { default: () => [] },
    openOnClick: { type: Boolean, default: !1 }
  },
  setup(t) {
    const n = t, e = ie(!1), r = I(() => {
      var i;
      return !!((i = n.subRoutes) != null && i.length);
    }), o = I(() => n.to ? Xr : "div"), a = () => {
      n.action && n.action();
    }, s = he();
    return (i, l) => {
      var d;
      return v(), L(We(o.value), {
        class: m([
          c(s)["v-nav-item"],
          {
            [c(s)["v-nav-item--active"]]: i.active,
            [c(s)["v-nav-item--collapsed"]]: i.collapsed,
            [c(s)["v-nav-item--open-on-click"]]: i.openOnClick && ((d = i.subRoutes) == null ? void 0 : d.length)
          }
        ]),
        to: i.to,
        onClick: l[3] || (l[3] = Je((p) => a(), ["self"]))
      }, {
        default: ee(() => {
          var p;
          return [
            (v(), L(We(i.icon || "div"), {
              class: m(c(s)["v-nav-item__icon"]),
              onClick: l[0] || (l[0] = Je((_) => a(), ["self"]))
            }, null, 8, ["class"])),
            i.collapsed ? E("", !0) : (v(), w(ae, { key: 0 }, [
              Q(z(i.title), 1)
            ], 64)),
            i.openOnClick && ((p = i.subRoutes) != null && p.length) ? (v(), w("div", {
              key: 1,
              class: m([
                c(s)["v-nav-item__toggle"],
                {
                  [c(s)["v-nav-item__toggle--open"]]: e.value
                }
              ]),
              onClick: l[1] || (l[1] = Je((_) => e.value = !e.value, ["prevent"]))
            }, [
              j(vt)
            ], 2)) : E("", !0),
            i.collapsed ? (v(), w("div", {
              key: 2,
              class: m([
                c(s)["v-nav-item__collapsed-tooltip"],
                {
                  [c(s)["v-nav-item__collapsed-tooltip--active"]]: i.active,
                  [c(s)["v-nav-item__collapsed-tooltip--with-sub-routes"]]: r.value
                }
              ]),
              onClick: l[2] || (l[2] = Je((_) => a(), ["self"]))
            }, z(i.title), 3)) : E("", !0),
            r.value ? (v(), w("div", {
              key: 3,
              class: m([
                c(s)["v-nav-item__sub-routes"],
                {
                  [c(s)["v-nav-item__sub-routes--append-left"]]: i.openOnClick,
                  [c(s)["v-nav-item__sub-routes--visible"]]: e.value
                }
              ])
            }, [
              g("div", {
                class: m([
                  c(s)["v-nav-item__sub-routes-wrapper"],
                  {
                    [c(s)["v-nav-item__sub-routes-wrapper--collapsed"]]: i.collapsed
                  }
                ])
              }, [
                (v(!0), w(ae, null, ue(i.subRoutes, (_, h) => (v(), L(c(Xr), {
                  key: h,
                  to: _.to || "",
                  class: m([
                    c(s)["v-nav-item__sub-route"],
                    {
                      [c(s)["v-nav-item__sub-route--active"]]: _.active
                    }
                  ])
                }, {
                  default: ee(() => [
                    Q(z(_.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class"]))), 128))
              ], 2)
            ], 2)) : E("", !0)
          ];
        }),
        _: 1
      }, 8, ["class", "to"]);
    };
  }
}), is = {
  "v-nav-item": "_v-nav-item_6sx0z_1",
  "v-nav-item--active": "_v-nav-item--active_6sx0z_18",
  "v-nav-item__sub-routes--append-left": "_v-nav-item__sub-routes--append-left_6sx0z_25",
  "v-nav-item__sub-routes": "_v-nav-item__sub-routes_6sx0z_25",
  "v-nav-item--collapsed": "_v-nav-item--collapsed_6sx0z_32",
  "v-nav-item__collapsed-tooltip": "_v-nav-item__collapsed-tooltip_6sx0z_35",
  "v-nav-item__collapsed-tooltip--active": "_v-nav-item__collapsed-tooltip--active_6sx0z_35",
  "v-nav-item__toggle": "_v-nav-item__toggle_6sx0z_62",
  "v-nav-item__toggle--open": "_v-nav-item__toggle--open_6sx0z_78",
  "v-nav-item__icon": "_v-nav-item__icon_6sx0z_82",
  "v-nav-item__sub-routes-wrapper": "_v-nav-item__sub-routes-wrapper_6sx0z_107",
  "v-nav-item__sub-route": "_v-nav-item__sub-route_6sx0z_25",
  "v-nav-item__sub-routes--visible": "_v-nav-item__sub-routes--visible_6sx0z_114",
  "v-nav-item__collapsed-tooltip--with-sub-routes": "_v-nav-item__collapsed-tooltip--with-sub-routes_6sx0z_144",
  "v-nav-item__sub-route--active": "_v-nav-item__sub-route--active_6sx0z_174",
  "v-nav-item__sub-routes-wrapper--collapsed": "_v-nav-item__sub-routes-wrapper--collapsed_6sx0z_215"
}, ss = {
  $style: is
}, va = /* @__PURE__ */ V(as, [["__cssModules", ss]]), ls = ["src"], us = /* @__PURE__ */ Y({
  __name: "VSidebar",
  props: {
    collapsed: { type: Boolean, default: !1 },
    logoImage: { default: "" },
    routesGroups: { default: () => [] }
  },
  emits: ["update:collapsed"],
  setup(t, { emit: n }) {
    const e = n;
    return (r, o) => (v(), w("aside", {
      class: m([
        r.$style["v-sidebar"],
        {
          [r.$style["v-sidebar--collapsed"]]: r.collapsed
        }
      ])
    }, [
      g("div", {
        class: m([
          r.$style["v-sidebar__toggle"],
          { [r.$style["v-sidebar__toggle--collapsed"]]: r.collapsed }
        ]),
        onClick: o[0] || (o[0] = (a) => e("update:collapsed", !r.collapsed))
      }, [
        j(vt)
      ], 2),
      g("div", {
        class: m(r.$style["v-sidebar__logo-wrapper"])
      }, [
        g("img", {
          src: r.logoImage,
          alt: "Logo"
        }, null, 8, ls)
      ], 2),
      g("div", {
        class: m(r.$style["v-sidebar__routes-wrapper"])
      }, [
        (v(!0), w(ae, null, ue(r.routesGroups, (a, s) => (v(), w("div", { key: s }, [
          g("nav", {
            class: m(r.$style["v-sidebar__routes-group"])
          }, [
            g("div", {
              class: m(r.$style["v-sidebar__rotes-group-wrapper"])
            }, [
              (v(!0), w(ae, null, ue(a, (i, l) => (v(), L(c(va), {
                key: l,
                collapsed: r.collapsed,
                to: i.to,
                title: i.title,
                icon: i.icon,
                active: i.active,
                action: i.action,
                "sub-routes": i.subRoutes
              }, null, 8, ["collapsed", "to", "title", "icon", "active", "action", "sub-routes"]))), 128))
            ], 2)
          ], 2)
        ]))), 128))
      ], 2)
    ], 2));
  }
}), cs = {
  "v-sidebar": "_v-sidebar_149da_1",
  "v-sidebar__toggle": "_v-sidebar__toggle_149da_16",
  "v-sidebar--collapsed": "_v-sidebar--collapsed_149da_20",
  "v-sidebar__logo-wrapper": "_v-sidebar__logo-wrapper_149da_23",
  "v-sidebar__routes-group": "_v-sidebar__routes-group_149da_41",
  "v-sidebar__toggle--collapsed": "_v-sidebar__toggle--collapsed_149da_76"
}, ds = {
  $style: cs
}, H3 = /* @__PURE__ */ V(us, [["__cssModules", ds]]);
var Rn = /* @__PURE__ */ ((t) => (t.SMALL = "small", t.MEDIUM = "medium", t.LARGE = "large", t))(Rn || {});
const fs = {}, ps = {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vs = /* @__PURE__ */ g("path", {
  d: "M13 1L4.75 9L1 5.36364",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), hs = [
  vs
];
function _s(t, n) {
  return v(), w("svg", ps, hs);
}
const Hn = /* @__PURE__ */ V(fs, [["render", _s]]), ms = /* @__PURE__ */ Y({
  __name: "CheckboxComponent",
  props: {
    modelValue: { type: Boolean },
    label: { default: null },
    size: { default: Rn.SMALL },
    disabled: { type: Boolean, default: !0 },
    rounded: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I({
      get() {
        return e.modelValue;
      },
      set(l) {
        e.disabled || r("update:modelValue", l);
      }
    }), a = () => {
      e.disabled || (o.value = !o.value);
    }, s = et(), i = he();
    return (l, d) => (v(), w("div", {
      class: m([
        c(i)["v-checkbox"],
        {
          [c(i)["v-checkbox--with-label"]]: l.label || c(s).label
        }
      ])
    }, [
      g("div", {
        class: m([
          c(i)["v-checkbox--button"],
          c(i)[`v-checkbox--button-${l.size}`],
          {
            [c(i)["v-checkbox--button-checked"]]: o.value,
            [c(i)["v-checkbox--button--rounded"]]: l.rounded,
            [c(i)["v-checkbox--button--disabled"]]: l.disabled
          }
        ]),
        onClick: d[0] || (d[0] = (p) => a())
      }, [
        o.value ? (v(), L(Hn, {
          key: 0,
          class: m(c(i)["v-checkbox--button-checked-icon"])
        }, null, 8, ["class"])) : E("", !0)
      ], 2),
      l.label || c(s).label ? (v(), w("label", {
        key: 0,
        class: m([
          c(i)["v-checkbox--label"],
          {
            [c(i)["v-checkbox--label--disabled"]]: l.disabled
          }
        ]),
        onClick: d[1] || (d[1] = (p) => a())
      }, [
        H(l.$slots, "label", {}, () => [
          Q(z(l.label), 1)
        ])
      ], 2)) : E("", !0)
    ], 2));
  }
}), gs = {
  "v-checkbox": "_v-checkbox_1krqx_1",
  "v-checkbox--with-label": "_v-checkbox--with-label_1krqx_14",
  "v-checkbox--button": "_v-checkbox--button_1krqx_18",
  "v-checkbox--button--rounded": "_v-checkbox--button--rounded_1krqx_36",
  "v-checkbox--label": "_v-checkbox--label_1krqx_40",
  "v-checkbox--button--disabled": "_v-checkbox--button--disabled_1krqx_44",
  "v-checkbox--label--disabled": "_v-checkbox--label--disabled_1krqx_44",
  "v-checkbox--button-checked": "_v-checkbox--button-checked_1krqx_52",
  "v-checkbox--button-checked-icon": "_v-checkbox--button-checked-icon_1krqx_58",
  "v-checkbox--button-large": "_v-checkbox--button-large_1krqx_62",
  "v-checkbox--button-medium": "_v-checkbox--button-medium_1krqx_71",
  "v-checkbox--button-small": "_v-checkbox--button-small_1krqx_80"
}, bs = {
  $style: gs
}, ys = /* @__PURE__ */ V(ms, [["__cssModules", bs]]);
var ut = /* @__PURE__ */ ((t) => (t.EXTRA_SMALL = "extra-small", t.SMALL = "small", t.MEDIUM = "medium", t.MEDIUM_SMALL = "medium-small", t.LARGE = "large", t))(ut || {}), ha = /* @__PURE__ */ ((t) => (t.LEFT = "left", t.RIGHT = "right", t))(ha || {}), _a = /* @__PURE__ */ ((t) => (t.MEDIUM = "medium", t.LARGE = "large", t))(_a || {}), Mr = /* @__PURE__ */ ((t) => (t.PRIMARY = "primary", t.SECONDARY = "secondary", t))(Mr || {});
const ws = /* @__PURE__ */ Y({
  __name: "SwitchComponent",
  props: {
    modelValue: { type: Boolean },
    label: { default: null },
    size: { default: Rn.SMALL },
    disabled: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I({
      get() {
        return e.modelValue;
      },
      set(l) {
        r("update:modelValue", l);
      }
    }), a = () => {
      e.disabled || (o.value = !o.value);
    }, s = et(), i = he();
    return (l, d) => (v(), w("div", {
      class: m(c(i)["v-switch"])
    }, [
      g("div", {
        class: m([
          c(i)["v-switch__switch"],
          c(i)[`v-switch__switch--${l.size}`],
          {
            [c(i)["v-switch__switch--checked"]]: o.value,
            [c(i)["v-switch__switch--disabled"]]: l.disabled
          }
        ]),
        onClick: d[0] || (d[0] = (p) => a())
      }, [
        g("div", {
          class: m(c(i)["v-switch__switch-point"])
        }, null, 2)
      ], 2),
      l.label || c(s).label ? (v(), w("label", {
        key: 0,
        class: m([
          c(i)["v-switch__label"],
          {
            [c(i)["v-switch__label--disabled"]]: l.disabled
          }
        ]),
        onClick: d[1] || (d[1] = (p) => a())
      }, [
        H(l.$slots, "label", {}, () => [
          Q(z(l.label), 1)
        ])
      ], 2)) : E("", !0)
    ], 2));
  }
}), Cs = {
  "v-switch": "_v-switch_xv4f6_1",
  "v-switch__switch": "_v-switch__switch_xv4f6_14",
  "v-switch__switch--checked": "_v-switch__switch--checked_xv4f6_22",
  "v-switch__switch-point": "_v-switch__switch-point_xv4f6_22",
  "v-switch__switch--small": "_v-switch__switch--small_xv4f6_33",
  "v-switch__switch--medium": "_v-switch__switch--medium_xv4f6_55",
  "v-switch__switch--large": "_v-switch__switch--large_xv4f6_71",
  "v-switch__label": "_v-switch__label_xv4f6_87",
  "v-switch__switch--disabled": "_v-switch__switch--disabled_xv4f6_91",
  "v-switch__label--disabled": "_v-switch__label--disabled_xv4f6_91"
}, $s = {
  $style: Cs
}, ks = /* @__PURE__ */ V(ws, [["__cssModules", $s]]), Ms = /* @__PURE__ */ Y({
  __name: "VCheckbox",
  props: {
    value: { type: Boolean },
    label: { default: null },
    size: { default: Rn.SMALL },
    disabled: { type: Boolean, default: !1 },
    rounded: { type: Boolean, default: !1 },
    switch: { type: Boolean, default: !1 }
  },
  emits: ["update:value"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I({
      get() {
        return e.value;
      },
      set(s) {
        r("update:value", s);
      }
    }), a = et();
    return (s, i) => e.switch ? (v(), L(ks, {
      key: 0,
      modelValue: o.value,
      "onUpdate:modelValue": i[0] || (i[0] = (l) => o.value = l),
      label: s.label,
      disabled: s.disabled,
      size: s.size
    }, ct({ _: 2 }, [
      ue(c(a), (l, d) => ({
        name: d,
        fn: ee((p) => [
          H(s.$slots, d, Me(Te(p)))
        ])
      }))
    ]), 1032, ["modelValue", "label", "disabled", "size"])) : (v(), L(ys, {
      key: 1,
      modelValue: o.value,
      "onUpdate:modelValue": i[1] || (i[1] = (l) => o.value = l),
      label: s.label,
      disabled: s.disabled,
      rounded: s.rounded,
      size: s.size
    }, ct({ _: 2 }, [
      ue(c(a), (l, d) => ({
        name: d,
        fn: ee((p) => [
          H(s.$slots, d, Me(Te(p)))
        ])
      }))
    ]), 1032, ["modelValue", "label", "disabled", "rounded", "size"]));
  }
}), Ds = {
  "v-checkbox": "_v-checkbox_5pui1_1",
  "v-checkbox--button": "_v-checkbox--button_5pui1_14",
  "v-checkbox--button--rounded": "_v-checkbox--button--rounded_5pui1_32",
  "v-checkbox--button--disabled": "_v-checkbox--button--disabled_5pui1_36",
  "v-checkbox--button-checked": "_v-checkbox--button-checked_5pui1_40",
  "v-checkbox--button-checked-icon": "_v-checkbox--button-checked-icon_5pui1_46",
  "v-checkbox--button-large": "_v-checkbox--button-large_5pui1_50",
  "v-checkbox--button-medium": "_v-checkbox--button-medium_5pui1_59",
  "v-checkbox--button-small": "_v-checkbox--button-small_5pui1_68"
}, Ss = {
  $style: Ds
}, z3 = /* @__PURE__ */ V(Ms, [["__cssModules", Ss]]), Os = /* @__PURE__ */ Y({
  __name: "VLabel",
  props: {
    withSpaceBottom: { type: Boolean, default: !0 },
    showRequiredStar: { type: Boolean, default: !1 },
    size: { default: "medium" },
    color: { default: "gray" }
  },
  setup(t) {
    const n = et(), e = I(() => !!n["label-right"]);
    return (r, o) => (v(), w("div", {
      class: m([
        r.$style["v-label"],
        r.$style[`v-label--${r.size}`],
        r.$style[`v-label--${r.color}`],
        {
          [r.$style["v-label--space-bottom"]]: r.withSpaceBottom,
          [r.$style["v-label--with-left"]]: e.value
        }
      ])
    }, [
      g("div", null, [
        r.showRequiredStar ? (v(), w("span", {
          key: 0,
          class: m(r.$style["v-label__required-star"])
        }, " * ", 2)) : E("", !0),
        H(r.$slots, "default")
      ]),
      H(r.$slots, "label-right")
    ], 2));
  }
}), Ts = {
  "v-label": "_v-label_hwxzm_1",
  "v-label--gray": "_v-label--gray_hwxzm_9",
  "v-label--black": "_v-label--black_hwxzm_13",
  "v-label--small": "_v-label--small_hwxzm_17",
  "v-label--medium": "_v-label--medium_hwxzm_21",
  "v-label--large": "_v-label--large_hwxzm_25",
  "v-label--with-left": "_v-label--with-left_hwxzm_29",
  "v-label--space-bottom": "_v-label--space-bottom_hwxzm_34",
  "v-label__required-star": "_v-label__required-star_hwxzm_38"
}, As = {
  $style: Ts
}, ma = /* @__PURE__ */ V(Os, [["__cssModules", As]]), Qr = (t, n) => {
  n.value ? t.style.opacity = "0" : t.style.opacity = "1";
}, Es = {
  beforeMount: (t, n, e, r) => Qr(t, n),
  updated: (t, n, e) => Qr(t, n)
}, xs = /* @__PURE__ */ Y({
  __name: "VError",
  props: {
    error: { default: "" }
  },
  setup(t) {
    const n = Es, e = he();
    return (r, o) => it((v(), w("div", {
      class: m(c(e)["v-error"])
    }, [
      Q(z(r.error), 1)
    ], 2)), [
      [c(n), !r.error]
    ]);
  }
}), Is = {
  "v-error": "_v-error_1mfpc_1"
}, Ls = {
  $style: Is
}, ga = /* @__PURE__ */ V(xs, [["__cssModules", Ls]]), Ge = Object.freeze({
  label: "",
  showRequiredStar: !1,
  withError: !1,
  error: "",
  borderless: !0,
  placeholder: "",
  disabled: !1
}), Bs = /* @__PURE__ */ Y({
  __name: "VBaseField",
  props: /* @__PURE__ */ Ke({
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    borderless: { type: Boolean },
    placeholder: {},
    disabled: { type: Boolean }
  }, Ge),
  setup(t) {
    const n = t, e = I(() => !!n.label), r = he();
    return (o, a) => (v(), w("div", null, [
      e.value ? (v(), L(c(ma), {
        key: 0,
        "show-required-star": o.showRequiredStar,
        class: m(c(r)["v-base-field__label"])
      }, {
        "label-right": ee(() => [
          H(o.$slots, "label-right")
        ]),
        default: ee(() => [
          Q(z(o.label) + " ", 1)
        ]),
        _: 3
      }, 8, ["show-required-star", "class"])) : E("", !0),
      H(o.$slots, "default"),
      o.withError ? (v(), L(c(ga), {
        key: 1,
        error: o.error
      }, null, 8, ["error"])) : E("", !0)
    ]));
  }
}), Vs = {
  "v-base-field__label": "_v-base-field__label_bx6cu_1"
}, Ps = {
  $style: Vs
}, zn = /* @__PURE__ */ V(Bs, [["__cssModules", Ps]]), js = ["type", "disabled", "placeholder"], Ns = /* @__PURE__ */ Y({
  __name: "VInput",
  props: /* @__PURE__ */ Ke({
    modelValue: {},
    placeholder: {},
    prefixIcon: {},
    suffixIcon: {},
    foreground: { type: Boolean },
    type: {},
    disabled: { type: Boolean },
    isNumber: { type: Boolean },
    borderless: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {}
  }, {
    prefixIcon: null,
    suffixIcon: null,
    foreground: !1,
    borderless: !0,
    type: "",
    isNumber: !1,
    ...Ge
  }),
  emits: ["update:model-value", "focus", "blur"],
  setup(t, { expose: n, emit: e }) {
    const r = t, o = e, a = I({
      get() {
        return r.modelValue;
      },
      set(h) {
        o("update:model-value", h);
      }
    }), s = I(() => r.prefixIcon !== null), i = I(() => r.suffixIcon !== null), l = he(), d = ie(null), p = (h) => {
      if (r.isNumber && (h.key.match(/[^0-9.-]/g) || h.key === "Backspace" || h.key === "." && (r.modelValue.includes(".") || !r.modelValue.length) || h.key === "-" && h.target.selectionStart))
        return h.preventDefault();
    }, _ = () => {
      d.value && d.value.focus();
    };
    return n({
      inputField: d
    }), (h, y) => (v(), L(c(zn), {
      class: m([
        c(l)["v-input"],
        {
          [c(l)["v-input--borderless"]]: h.borderless
        }
      ]),
      error: h.error,
      label: h.label,
      "show-required-star": h.showRequiredStar,
      "with-error": h.withError
    }, {
      "label-right": ee(() => [
        H(h.$slots, "label-right")
      ]),
      default: ee(() => [
        g("div", {
          class: m(c(l)["v-input__input-wrapper"])
        }, [
          s.value ? (v(), w("div", {
            key: 0,
            class: m([
              c(l)["v-input__icon"],
              c(l)["v-input__icon--prefix"]
            ]),
            onClick: _
          }, [
            s.value ? (v(), L(We(h.prefixIcon), {
              key: 0,
              height: "16px",
              width: "16px"
            })) : E("", !0)
          ], 2)) : E("", !0),
          it(g("input", {
            ref_key: "inputField",
            ref: d,
            "onUpdate:modelValue": y[0] || (y[0] = ($) => a.value = $),
            type: h.type,
            class: m([
              c(l)["v-input__input"],
              {
                [c(l)["v-input__input--foreground"]]: h.foreground,
                [c(l)["v-input__input--with-suffix-icon"]]: i.value,
                [c(l)["v-input__input--with-prefix-icon"]]: s.value
              }
            ]),
            disabled: h.disabled,
            placeholder: h.placeholder,
            onFocus: y[1] || (y[1] = ($) => o("focus")),
            onBlur: y[2] || (y[2] = ($) => o("blur")),
            onKeypress: y[3] || (y[3] = ($) => p($))
          }, null, 42, js), [
            [Ei, a.value]
          ]),
          i.value ? (v(), w("div", {
            key: 1,
            class: m([
              c(l)["v-input__icon"],
              c(l)["v-input__icon--suffix"]
            ]),
            onClick: _
          }, [
            (v(), L(We(h.suffixIcon), {
              height: "16px",
              width: "16px"
            }))
          ], 2)) : E("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "error", "label", "show-required-star", "with-error"]));
  }
}), Fs = {
  "v-input": "_v-input_1wwor_1",
  "v-input__input-wrapper": "_v-input__input-wrapper_1wwor_5",
  "v-input__input": "_v-input__input_1wwor_5",
  "v-input--borderless": "_v-input--borderless_1wwor_38",
  "v-input__icon--prefix": "_v-input__icon--prefix_1wwor_44",
  "v-input__icon--suffix": "_v-input__icon--suffix_1wwor_48",
  "v-input__input--with-prefix-icon": "_v-input__input--with-prefix-icon_1wwor_52",
  "v-input__input--with-suffix-icon": "_v-input__input--with-suffix-icon_1wwor_55",
  "v-input__input--foreground": "_v-input__input--foreground_1wwor_67",
  "v-input__icon": "_v-input__icon_1wwor_44"
}, Rs = {
  $style: Fs
}, Yn = /* @__PURE__ */ V(Ns, [["__cssModules", Rs]]), Hs = ["placeholder", "rows"], zs = /* @__PURE__ */ Y({
  __name: "VTextarea",
  props: /* @__PURE__ */ Ke({
    modelValue: {},
    foreground: { type: Boolean },
    placeholder: {},
    rows: {},
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    borderless: { type: Boolean },
    disabled: { type: Boolean }
  }, {
    modelValue: "",
    foreground: !1,
    rows: 5,
    ...Ge
  }),
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const e = t, r = I({
      get() {
        return e.modelValue;
      },
      set(s) {
        o("update:modelValue", s);
      }
    }), o = n, a = he();
    return (s, i) => (v(), L(c(zn), {
      class: m(c(a)["v-textarea"]),
      error: s.error,
      label: s.label,
      "show-required-star": s.showRequiredStar,
      "with-error": s.withError
    }, {
      default: ee(() => [
        it(g("textarea", {
          "onUpdate:modelValue": i[0] || (i[0] = (l) => r.value = l),
          class: m([
            c(a)["v-textarea__textarea"],
            {
              [c(a)["v-textarea__textarea--foreground"]]: s.foreground
            }
          ]),
          placeholder: s.placeholder,
          rows: s.rows
        }, null, 10, Hs), [
          [xi, r.value]
        ])
      ]),
      _: 1
    }, 8, ["class", "error", "label", "show-required-star", "with-error"]));
  }
}), Ys = {
  "v-textarea__textarea": "_v-textarea__textarea_7hv2z_1",
  "v-textarea__textarea--foreground": "_v-textarea__textarea--foreground_7hv2z_21"
}, Us = {
  $style: Ys
}, Y3 = /* @__PURE__ */ V(zs, [["__cssModules", Us]]), qs = {}, Ws = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  width: "16",
  viewBox: "0 0 16 16"
}, Ks = /* @__PURE__ */ Nn('<g stroke-width="1" fill="currentColor" stroke="currentColor" class="nc-icon-wrapper"><line data-color="color-2" x1="0.5" y1="5.5" x2="15.5" y2="5.5" fill="none" stroke-linecap="round" stroke-linejoin="round"></line><path d="M14,2.5H2A1.5,1.5,0,0,0,.5,4v9A1.5,1.5,0,0,0,2,14.5H14A1.5,1.5,0,0,0,15.5,13V4A1.5,1.5,0,0,0,14,2.5Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><line x1="4.5" y1="0.5" x2="4.5" y2="2.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line><line x1="11.5" y1="0.5" x2="11.5" y2="2.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line></g>', 1), Gs = [
  Ks
];
function Zs(t, n) {
  return v(), w("svg", Ws, Gs);
}
const Js = /* @__PURE__ */ V(qs, [["render", Zs]]);
var rr = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], Bt = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: function(t) {
    return typeof console < "u" && console.warn(t);
  },
  getWeek: function(t) {
    var n = new Date(t.getTime());
    n.setHours(0, 0, 0, 0), n.setDate(n.getDate() + 3 - (n.getDay() + 6) % 7);
    var e = new Date(n.getFullYear(), 0, 4);
    return 1 + Math.round(((n.getTime() - e.getTime()) / 864e5 - 3 + (e.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, ln = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(t) {
    var n = t % 100;
    if (n > 3 && n < 21)
      return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, Be = function(t, n) {
  return n === void 0 && (n = 2), ("000" + t).slice(n * -1);
}, ze = function(t) {
  return t === !0 ? 1 : 0;
};
function eo(t, n) {
  var e;
  return function() {
    var r = this, o = arguments;
    clearTimeout(e), e = setTimeout(function() {
      return t.apply(r, o);
    }, n);
  };
}
var or = function(t) {
  return t instanceof Array ? t : [t];
};
function Le(t, n, e) {
  if (e === !0)
    return t.classList.add(n);
  t.classList.remove(n);
}
function ce(t, n, e) {
  var r = window.document.createElement(t);
  return n = n || "", e = e || "", r.className = n, e !== void 0 && (r.textContent = e), r;
}
function $n(t) {
  for (; t.firstChild; )
    t.removeChild(t.firstChild);
}
function ba(t, n) {
  if (n(t))
    return t;
  if (t.parentNode)
    return ba(t.parentNode, n);
}
function kn(t, n) {
  var e = ce("div", "numInputWrapper"), r = ce("input", "numInput " + t), o = ce("span", "arrowUp"), a = ce("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? r.type = "number" : (r.type = "text", r.pattern = "\\d*"), n !== void 0)
    for (var s in n)
      r.setAttribute(s, n[s]);
  return e.appendChild(r), e.appendChild(o), e.appendChild(a), e;
}
function Ne(t) {
  try {
    if (typeof t.composedPath == "function") {
      var n = t.composedPath();
      return n[0];
    }
    return t.target;
  } catch {
    return t.target;
  }
}
var ar = function() {
}, In = function(t, n, e) {
  return e.months[n ? "shorthand" : "longhand"][t];
}, Xs = {
  D: ar,
  F: function(t, n, e) {
    t.setMonth(e.months.longhand.indexOf(n));
  },
  G: function(t, n) {
    t.setHours((t.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  H: function(t, n) {
    t.setHours(parseFloat(n));
  },
  J: function(t, n) {
    t.setDate(parseFloat(n));
  },
  K: function(t, n, e) {
    t.setHours(t.getHours() % 12 + 12 * ze(new RegExp(e.amPM[1], "i").test(n)));
  },
  M: function(t, n, e) {
    t.setMonth(e.months.shorthand.indexOf(n));
  },
  S: function(t, n) {
    t.setSeconds(parseFloat(n));
  },
  U: function(t, n) {
    return new Date(parseFloat(n) * 1e3);
  },
  W: function(t, n, e) {
    var r = parseInt(n), o = new Date(t.getFullYear(), 0, 2 + (r - 1) * 7, 0, 0, 0, 0);
    return o.setDate(o.getDate() - o.getDay() + e.firstDayOfWeek), o;
  },
  Y: function(t, n) {
    t.setFullYear(parseFloat(n));
  },
  Z: function(t, n) {
    return new Date(n);
  },
  d: function(t, n) {
    t.setDate(parseFloat(n));
  },
  h: function(t, n) {
    t.setHours((t.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  i: function(t, n) {
    t.setMinutes(parseFloat(n));
  },
  j: function(t, n) {
    t.setDate(parseFloat(n));
  },
  l: ar,
  m: function(t, n) {
    t.setMonth(parseFloat(n) - 1);
  },
  n: function(t, n) {
    t.setMonth(parseFloat(n) - 1);
  },
  s: function(t, n) {
    t.setSeconds(parseFloat(n));
  },
  u: function(t, n) {
    return new Date(parseFloat(n));
  },
  w: ar,
  y: function(t, n) {
    t.setFullYear(2e3 + parseFloat(n));
  }
}, gt = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, nn = {
  Z: function(t) {
    return t.toISOString();
  },
  D: function(t, n, e) {
    return n.weekdays.shorthand[nn.w(t, n, e)];
  },
  F: function(t, n, e) {
    return In(nn.n(t, n, e) - 1, !1, n);
  },
  G: function(t, n, e) {
    return Be(nn.h(t, n, e));
  },
  H: function(t) {
    return Be(t.getHours());
  },
  J: function(t, n) {
    return n.ordinal !== void 0 ? t.getDate() + n.ordinal(t.getDate()) : t.getDate();
  },
  K: function(t, n) {
    return n.amPM[ze(t.getHours() > 11)];
  },
  M: function(t, n) {
    return In(t.getMonth(), !0, n);
  },
  S: function(t) {
    return Be(t.getSeconds());
  },
  U: function(t) {
    return t.getTime() / 1e3;
  },
  W: function(t, n, e) {
    return e.getWeek(t);
  },
  Y: function(t) {
    return Be(t.getFullYear(), 4);
  },
  d: function(t) {
    return Be(t.getDate());
  },
  h: function(t) {
    return t.getHours() % 12 ? t.getHours() % 12 : 12;
  },
  i: function(t) {
    return Be(t.getMinutes());
  },
  j: function(t) {
    return t.getDate();
  },
  l: function(t, n) {
    return n.weekdays.longhand[t.getDay()];
  },
  m: function(t) {
    return Be(t.getMonth() + 1);
  },
  n: function(t) {
    return t.getMonth() + 1;
  },
  s: function(t) {
    return t.getSeconds();
  },
  u: function(t) {
    return t.getTime();
  },
  w: function(t) {
    return t.getDay();
  },
  y: function(t) {
    return String(t.getFullYear()).substring(2);
  }
}, ya = function(t) {
  var n = t.config, e = n === void 0 ? Bt : n, r = t.l10n, o = r === void 0 ? ln : r, a = t.isMobile, s = a === void 0 ? !1 : a;
  return function(i, l, d) {
    var p = d || o;
    return e.formatDate !== void 0 && !s ? e.formatDate(i, l, p) : l.split("").map(function(_, h, y) {
      return nn[_] && y[h - 1] !== "\\" ? nn[_](i, p, e) : _ !== "\\" ? _ : "";
    }).join("");
  };
}, vr = function(t) {
  var n = t.config, e = n === void 0 ? Bt : n, r = t.l10n, o = r === void 0 ? ln : r;
  return function(a, s, i, l) {
    if (!(a !== 0 && !a)) {
      var d = l || o, p, _ = a;
      if (a instanceof Date)
        p = new Date(a.getTime());
      else if (typeof a != "string" && a.toFixed !== void 0)
        p = new Date(a);
      else if (typeof a == "string") {
        var h = s || (e || Bt).dateFormat, y = String(a).trim();
        if (y === "today")
          p = /* @__PURE__ */ new Date(), i = !0;
        else if (e && e.parseDate)
          p = e.parseDate(a, h);
        else if (/Z$/.test(y) || /GMT$/.test(y))
          p = new Date(a);
        else {
          for (var $ = void 0, k = [], M = 0, P = 0, D = ""; M < h.length; M++) {
            var U = h[M], F = U === "\\", G = h[M - 1] === "\\" || F;
            if (gt[U] && !G) {
              D += gt[U];
              var Z = new RegExp(D).exec(a);
              Z && ($ = !0) && k[U !== "Y" ? "push" : "unshift"]({
                fn: Xs[U],
                val: Z[++P]
              });
            } else
              F || (D += ".");
          }
          p = !e || !e.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)), k.forEach(function(se) {
            var ne = se.fn, fe = se.val;
            return p = ne(p, fe, d) || p;
          }), p = $ ? p : void 0;
        }
      }
      if (!(p instanceof Date && !isNaN(p.getTime()))) {
        e.errorHandler(new Error("Invalid date provided: " + _));
        return;
      }
      return i === !0 && p.setHours(0, 0, 0, 0), p;
    }
  };
};
function Fe(t, n, e) {
  return e === void 0 && (e = !0), e !== !1 ? new Date(t.getTime()).setHours(0, 0, 0, 0) - new Date(n.getTime()).setHours(0, 0, 0, 0) : t.getTime() - n.getTime();
}
var Qs = function(t, n, e) {
  return t > Math.min(n, e) && t < Math.max(n, e);
}, ir = function(t, n, e) {
  return t * 3600 + n * 60 + e;
}, el = function(t) {
  var n = Math.floor(t / 3600), e = (t - n * 3600) / 60;
  return [n, e, t - n * 3600 - e * 60];
}, tl = {
  DAY: 864e5
};
function sr(t) {
  var n = t.defaultHour, e = t.defaultMinute, r = t.defaultSeconds;
  if (t.minDate !== void 0) {
    var o = t.minDate.getHours(), a = t.minDate.getMinutes(), s = t.minDate.getSeconds();
    n < o && (n = o), n === o && e < a && (e = a), n === o && e === a && r < s && (r = t.minDate.getSeconds());
  }
  if (t.maxDate !== void 0) {
    var i = t.maxDate.getHours(), l = t.maxDate.getMinutes();
    n = Math.min(n, i), n === i && (e = Math.min(l, e)), n === i && e === l && (r = t.maxDate.getSeconds());
  }
  return { hours: n, minutes: e, seconds: r };
}
typeof Object.assign != "function" && (Object.assign = function(t) {
  for (var n = [], e = 1; e < arguments.length; e++)
    n[e - 1] = arguments[e];
  if (!t)
    throw TypeError("Cannot convert undefined or null to object");
  for (var r = function(i) {
    i && Object.keys(i).forEach(function(l) {
      return t[l] = i[l];
    });
  }, o = 0, a = n; o < a.length; o++) {
    var s = a[o];
    r(s);
  }
  return t;
});
var xe = globalThis && globalThis.__assign || function() {
  return xe = Object.assign || function(t) {
    for (var n, e = 1, r = arguments.length; e < r; e++) {
      n = arguments[e];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, xe.apply(this, arguments);
}, to = globalThis && globalThis.__spreadArrays || function() {
  for (var t = 0, n = 0, e = arguments.length; n < e; n++)
    t += arguments[n].length;
  for (var r = Array(t), o = 0, n = 0; n < e; n++)
    for (var a = arguments[n], s = 0, i = a.length; s < i; s++, o++)
      r[o] = a[s];
  return r;
}, nl = 300;
function rl(t, n) {
  var e = {
    config: xe(xe({}, Bt), ke.defaultConfig),
    l10n: ln
  };
  e.parseDate = vr({ config: e.config, l10n: e.l10n }), e._handlers = [], e.pluginElements = [], e.loadedPlugins = [], e._bind = k, e._setHoursFromDate = h, e._positionCalendar = Tt, e.changeMonth = le, e.changeYear = Oe, e.clear = de, e.close = ge, e.onMouseOver = He, e._createElement = ce, e.createDay = Z, e.destroy = be, e.isEnabled = $e, e.jumpToDate = D, e.updateValue = ot, e.open = Xn, e.redraw = Zt, e.set = yn, e.setDate = wn, e.toggle = gi;
  function r() {
    e.utils = {
      getDaysInMonth: function(u, f) {
        return u === void 0 && (u = e.currentMonth), f === void 0 && (f = e.currentYear), u === 1 && (f % 4 === 0 && f % 100 !== 0 || f % 400 === 0) ? 29 : e.l10n.daysInMonth[u];
      }
    };
  }
  function o() {
    e.element = e.input = t, e.isOpen = !1, gn(), bn(), _i(), hi(), r(), e.isMobile || G(), P(), (e.selectedDates.length || e.config.noCalendar) && (e.config.enableTime && h(e.config.noCalendar ? e.latestSelectedDateObj : void 0), ot(!1)), i();
    var u = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !e.isMobile && u && Tt(), we("onReady");
  }
  function a() {
    var u;
    return ((u = e.calendarContainer) === null || u === void 0 ? void 0 : u.getRootNode()).activeElement || document.activeElement;
  }
  function s(u) {
    return u.bind(e);
  }
  function i() {
    var u = e.config;
    u.weekNumbers === !1 && u.showMonths === 1 || u.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (e.calendarContainer !== void 0 && (e.calendarContainer.style.visibility = "hidden", e.calendarContainer.style.display = "block"), e.daysContainer !== void 0) {
        var f = (e.days.offsetWidth + 1) * u.showMonths;
        e.daysContainer.style.width = f + "px", e.calendarContainer.style.width = f + (e.weekWrapper !== void 0 ? e.weekWrapper.offsetWidth : 0) + "px", e.calendarContainer.style.removeProperty("visibility"), e.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function l(u) {
    if (e.selectedDates.length === 0) {
      var f = e.config.minDate === void 0 || Fe(/* @__PURE__ */ new Date(), e.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(e.config.minDate.getTime()), b = sr(e.config);
      f.setHours(b.hours, b.minutes, b.seconds, f.getMilliseconds()), e.selectedDates = [f], e.latestSelectedDateObj = f;
    }
    u !== void 0 && u.type !== "blur" && wi(u);
    var C = e._input.value;
    _(), ot(), e._input.value !== C && e._debouncedChange();
  }
  function d(u, f) {
    return u % 12 + 12 * ze(f === e.l10n.amPM[1]);
  }
  function p(u) {
    switch (u % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return u % 12;
    }
  }
  function _() {
    if (!(e.hourElement === void 0 || e.minuteElement === void 0)) {
      var u = (parseInt(e.hourElement.value.slice(-2), 10) || 0) % 24, f = (parseInt(e.minuteElement.value, 10) || 0) % 60, b = e.secondElement !== void 0 ? (parseInt(e.secondElement.value, 10) || 0) % 60 : 0;
      e.amPM !== void 0 && (u = d(u, e.amPM.textContent));
      var C = e.config.minTime !== void 0 || e.config.minDate && e.minDateHasTime && e.latestSelectedDateObj && Fe(e.latestSelectedDateObj, e.config.minDate, !0) === 0, O = e.config.maxTime !== void 0 || e.config.maxDate && e.maxDateHasTime && e.latestSelectedDateObj && Fe(e.latestSelectedDateObj, e.config.maxDate, !0) === 0;
      if (e.config.maxTime !== void 0 && e.config.minTime !== void 0 && e.config.minTime > e.config.maxTime) {
        var x = ir(e.config.minTime.getHours(), e.config.minTime.getMinutes(), e.config.minTime.getSeconds()), re = ir(e.config.maxTime.getHours(), e.config.maxTime.getMinutes(), e.config.maxTime.getSeconds()), R = ir(u, f, b);
        if (R > re && R < x) {
          var oe = el(x);
          u = oe[0], f = oe[1], b = oe[2];
        }
      } else {
        if (O) {
          var N = e.config.maxTime !== void 0 ? e.config.maxTime : e.config.maxDate;
          u = Math.min(u, N.getHours()), u === N.getHours() && (f = Math.min(f, N.getMinutes())), f === N.getMinutes() && (b = Math.min(b, N.getSeconds()));
        }
        if (C) {
          var X = e.config.minTime !== void 0 ? e.config.minTime : e.config.minDate;
          u = Math.max(u, X.getHours()), u === X.getHours() && f < X.getMinutes() && (f = X.getMinutes()), f === X.getMinutes() && (b = Math.max(b, X.getSeconds()));
        }
      }
      y(u, f, b);
    }
  }
  function h(u) {
    var f = u || e.latestSelectedDateObj;
    f && f instanceof Date && y(f.getHours(), f.getMinutes(), f.getSeconds());
  }
  function y(u, f, b) {
    e.latestSelectedDateObj !== void 0 && e.latestSelectedDateObj.setHours(u % 24, f, b || 0, 0), !(!e.hourElement || !e.minuteElement || e.isMobile) && (e.hourElement.value = Be(e.config.time_24hr ? u : (12 + u) % 12 + 12 * ze(u % 12 === 0)), e.minuteElement.value = Be(f), e.amPM !== void 0 && (e.amPM.textContent = e.l10n.amPM[ze(u >= 12)]), e.secondElement !== void 0 && (e.secondElement.value = Be(b)));
  }
  function $(u) {
    var f = Ne(u), b = parseInt(f.value) + (u.delta || 0);
    (b / 1e3 > 1 || u.key === "Enter" && !/[^\d]/.test(b.toString())) && Oe(b);
  }
  function k(u, f, b, C) {
    if (f instanceof Array)
      return f.forEach(function(O) {
        return k(u, O, b, C);
      });
    if (u instanceof Array)
      return u.forEach(function(O) {
        return k(O, f, b, C);
      });
    u.addEventListener(f, b, C), e._handlers.push({
      remove: function() {
        return u.removeEventListener(f, b, C);
      }
    });
  }
  function M() {
    we("onChange");
  }
  function P() {
    if (e.config.wrap && ["open", "close", "toggle", "clear"].forEach(function(b) {
      Array.prototype.forEach.call(e.element.querySelectorAll("[data-" + b + "]"), function(C) {
        return k(C, "click", e[b]);
      });
    }), e.isMobile) {
      mi();
      return;
    }
    var u = eo(nt, 50);
    if (e._debouncedChange = eo(M, nl), e.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && k(e.daysContainer, "mouseover", function(b) {
      e.config.mode === "range" && He(Ne(b));
    }), k(e._input, "keydown", Ie), e.calendarContainer !== void 0 && k(e.calendarContainer, "keydown", Ie), !e.config.inline && !e.config.static && k(window, "resize", u), window.ontouchstart !== void 0 ? k(window.document, "touchstart", Ae) : k(window.document, "mousedown", Ae), k(window.document, "focus", Ae, { capture: !0 }), e.config.clickOpens === !0 && (k(e._input, "focus", e.open), k(e._input, "click", e.open)), e.daysContainer !== void 0 && (k(e.monthNav, "click", yi), k(e.monthNav, ["keyup", "increment"], $), k(e.daysContainer, "click", xt)), e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0) {
      var f = function(b) {
        return Ne(b).select();
      };
      k(e.timeContainer, ["increment"], l), k(e.timeContainer, "blur", l, { capture: !0 }), k(e.timeContainer, "click", U), k([e.hourElement, e.minuteElement], ["focus", "click"], f), e.secondElement !== void 0 && k(e.secondElement, "focus", function() {
        return e.secondElement && e.secondElement.select();
      }), e.amPM !== void 0 && k(e.amPM, "click", function(b) {
        l(b);
      });
    }
    e.config.allowInput && k(e._input, "blur", Se);
  }
  function D(u, f) {
    var b = u !== void 0 ? e.parseDate(u) : e.latestSelectedDateObj || (e.config.minDate && e.config.minDate > e.now ? e.config.minDate : e.config.maxDate && e.config.maxDate < e.now ? e.config.maxDate : e.now), C = e.currentYear, O = e.currentMonth;
    try {
      b !== void 0 && (e.currentYear = b.getFullYear(), e.currentMonth = b.getMonth());
    } catch (x) {
      x.message = "Invalid date supplied: " + b, e.config.errorHandler(x);
    }
    f && e.currentYear !== C && (we("onYearChange"), me()), f && (e.currentYear !== C || e.currentMonth !== O) && we("onMonthChange"), e.redraw();
  }
  function U(u) {
    var f = Ne(u);
    ~f.className.indexOf("arrow") && F(u, f.classList.contains("arrowUp") ? 1 : -1);
  }
  function F(u, f, b) {
    var C = u && Ne(u), O = b || C && C.parentNode && C.parentNode.firstChild, x = Qn("increment");
    x.delta = f, O && O.dispatchEvent(x);
  }
  function G() {
    var u = window.document.createDocumentFragment();
    if (e.calendarContainer = ce("div", "flatpickr-calendar"), e.calendarContainer.tabIndex = -1, !e.config.noCalendar) {
      if (u.appendChild(S()), e.innerContainer = ce("div", "flatpickr-innerContainer"), e.config.weekNumbers) {
        var f = K(), b = f.weekWrapper, C = f.weekNumbers;
        e.innerContainer.appendChild(b), e.weekNumbers = C, e.weekWrapper = b;
      }
      e.rContainer = ce("div", "flatpickr-rContainer"), e.rContainer.appendChild(A()), e.daysContainer || (e.daysContainer = ce("div", "flatpickr-days"), e.daysContainer.tabIndex = -1), Ce(), e.rContainer.appendChild(e.daysContainer), e.innerContainer.appendChild(e.rContainer), u.appendChild(e.innerContainer);
    }
    e.config.enableTime && u.appendChild(B()), Le(e.calendarContainer, "rangeMode", e.config.mode === "range"), Le(e.calendarContainer, "animate", e.config.animate === !0), Le(e.calendarContainer, "multiMonth", e.config.showMonths > 1), e.calendarContainer.appendChild(u);
    var O = e.config.appendTo !== void 0 && e.config.appendTo.nodeType !== void 0;
    if ((e.config.inline || e.config.static) && (e.calendarContainer.classList.add(e.config.inline ? "inline" : "static"), e.config.inline && (!O && e.element.parentNode ? e.element.parentNode.insertBefore(e.calendarContainer, e._input.nextSibling) : e.config.appendTo !== void 0 && e.config.appendTo.appendChild(e.calendarContainer)), e.config.static)) {
      var x = ce("div", "flatpickr-wrapper");
      e.element.parentNode && e.element.parentNode.insertBefore(x, e.element), x.appendChild(e.element), e.altInput && x.appendChild(e.altInput), x.appendChild(e.calendarContainer);
    }
    !e.config.static && !e.config.inline && (e.config.appendTo !== void 0 ? e.config.appendTo : window.document.body).appendChild(e.calendarContainer);
  }
  function Z(u, f, b, C) {
    var O = $e(f, !0), x = ce("span", u, f.getDate().toString());
    return x.dateObj = f, x.$i = C, x.setAttribute("aria-label", e.formatDate(f, e.config.ariaDateFormat)), u.indexOf("hidden") === -1 && Fe(f, e.now) === 0 && (e.todayDateElem = x, x.classList.add("today"), x.setAttribute("aria-current", "date")), O ? (x.tabIndex = -1, er(f) && (x.classList.add("selected"), e.selectedDateElem = x, e.config.mode === "range" && (Le(x, "startRange", e.selectedDates[0] && Fe(f, e.selectedDates[0], !0) === 0), Le(x, "endRange", e.selectedDates[1] && Fe(f, e.selectedDates[1], !0) === 0), u === "nextMonthDay" && x.classList.add("inRange")))) : x.classList.add("flatpickr-disabled"), e.config.mode === "range" && bi(f) && !er(f) && x.classList.add("inRange"), e.weekNumbers && e.config.showMonths === 1 && u !== "prevMonthDay" && C % 7 === 6 && e.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + e.config.getWeek(f) + "</span>"), we("onDayCreate", x), x;
  }
  function se(u) {
    u.focus(), e.config.mode === "range" && He(u);
  }
  function ne(u) {
    for (var f = u > 0 ? 0 : e.config.showMonths - 1, b = u > 0 ? e.config.showMonths : -1, C = f; C != b; C += u)
      for (var O = e.daysContainer.children[C], x = u > 0 ? 0 : O.children.length - 1, re = u > 0 ? O.children.length : -1, R = x; R != re; R += u) {
        var oe = O.children[R];
        if (oe.className.indexOf("hidden") === -1 && $e(oe.dateObj))
          return oe;
      }
  }
  function fe(u, f) {
    for (var b = u.className.indexOf("Month") === -1 ? u.dateObj.getMonth() : e.currentMonth, C = f > 0 ? e.config.showMonths : -1, O = f > 0 ? 1 : -1, x = b - e.currentMonth; x != C; x += O)
      for (var re = e.daysContainer.children[x], R = b - e.currentMonth === x ? u.$i + f : f < 0 ? re.children.length - 1 : 0, oe = re.children.length, N = R; N >= 0 && N < oe && N != (f > 0 ? oe : -1); N += O) {
        var X = re.children[N];
        if (X.className.indexOf("hidden") === -1 && $e(X.dateObj) && Math.abs(u.$i - N) >= Math.abs(f))
          return se(X);
      }
    e.changeMonth(O), te(ne(O), 0);
  }
  function te(u, f) {
    var b = a(), C = Ee(b || document.body), O = u !== void 0 ? u : C ? b : e.selectedDateElem !== void 0 && Ee(e.selectedDateElem) ? e.selectedDateElem : e.todayDateElem !== void 0 && Ee(e.todayDateElem) ? e.todayDateElem : ne(f > 0 ? 1 : -1);
    O === void 0 ? e._input.focus() : C ? fe(O, f) : se(O);
  }
  function J(u, f) {
    for (var b = (new Date(u, f, 1).getDay() - e.l10n.firstDayOfWeek + 7) % 7, C = e.utils.getDaysInMonth((f - 1 + 12) % 12, u), O = e.utils.getDaysInMonth(f, u), x = window.document.createDocumentFragment(), re = e.config.showMonths > 1, R = re ? "prevMonthDay hidden" : "prevMonthDay", oe = re ? "nextMonthDay hidden" : "nextMonthDay", N = C + 1 - b, X = 0; N <= C; N++, X++)
      x.appendChild(Z("flatpickr-day " + R, new Date(u, f - 1, N), N, X));
    for (N = 1; N <= O; N++, X++)
      x.appendChild(Z("flatpickr-day", new Date(u, f, N), N, X));
    for (var ve = O + 1; ve <= 42 - b && (e.config.showMonths === 1 || X % 7 !== 0); ve++, X++)
      x.appendChild(Z("flatpickr-day " + oe, new Date(u, f + 1, ve % O), ve, X));
    var Ze = ce("div", "dayContainer");
    return Ze.appendChild(x), Ze;
  }
  function Ce() {
    if (e.daysContainer !== void 0) {
      $n(e.daysContainer), e.weekNumbers && $n(e.weekNumbers);
      for (var u = document.createDocumentFragment(), f = 0; f < e.config.showMonths; f++) {
        var b = new Date(e.currentYear, e.currentMonth, 1);
        b.setMonth(e.currentMonth + f), u.appendChild(J(b.getFullYear(), b.getMonth()));
      }
      e.daysContainer.appendChild(u), e.days = e.daysContainer.firstChild, e.config.mode === "range" && e.selectedDates.length === 1 && He();
    }
  }
  function me() {
    if (!(e.config.showMonths > 1 || e.config.monthSelectorType !== "dropdown")) {
      var u = function(C) {
        return e.config.minDate !== void 0 && e.currentYear === e.config.minDate.getFullYear() && C < e.config.minDate.getMonth() ? !1 : !(e.config.maxDate !== void 0 && e.currentYear === e.config.maxDate.getFullYear() && C > e.config.maxDate.getMonth());
      };
      e.monthsDropdownContainer.tabIndex = -1, e.monthsDropdownContainer.innerHTML = "";
      for (var f = 0; f < 12; f++)
        if (u(f)) {
          var b = ce("option", "flatpickr-monthDropdown-month");
          b.value = new Date(e.currentYear, f).getMonth().toString(), b.textContent = In(f, e.config.shorthandCurrentMonth, e.l10n), b.tabIndex = -1, e.currentMonth === f && (b.selected = !0), e.monthsDropdownContainer.appendChild(b);
        }
    }
  }
  function q() {
    var u = ce("div", "flatpickr-month"), f = window.document.createDocumentFragment(), b;
    e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? b = ce("span", "cur-month") : (e.monthsDropdownContainer = ce("select", "flatpickr-monthDropdown-months"), e.monthsDropdownContainer.setAttribute("aria-label", e.l10n.monthAriaLabel), k(e.monthsDropdownContainer, "change", function(re) {
      var R = Ne(re), oe = parseInt(R.value, 10);
      e.changeMonth(oe - e.currentMonth), we("onMonthChange");
    }), me(), b = e.monthsDropdownContainer);
    var C = kn("cur-year", { tabindex: "-1" }), O = C.getElementsByTagName("input")[0];
    O.setAttribute("aria-label", e.l10n.yearAriaLabel), e.config.minDate && O.setAttribute("min", e.config.minDate.getFullYear().toString()), e.config.maxDate && (O.setAttribute("max", e.config.maxDate.getFullYear().toString()), O.disabled = !!e.config.minDate && e.config.minDate.getFullYear() === e.config.maxDate.getFullYear());
    var x = ce("div", "flatpickr-current-month");
    return x.appendChild(b), x.appendChild(C), f.appendChild(x), u.appendChild(f), {
      container: u,
      yearElement: O,
      monthElement: b
    };
  }
  function T() {
    $n(e.monthNav), e.monthNav.appendChild(e.prevMonthNav), e.config.showMonths && (e.yearElements = [], e.monthElements = []);
    for (var u = e.config.showMonths; u--; ) {
      var f = q();
      e.yearElements.push(f.yearElement), e.monthElements.push(f.monthElement), e.monthNav.appendChild(f.container);
    }
    e.monthNav.appendChild(e.nextMonthNav);
  }
  function S() {
    return e.monthNav = ce("div", "flatpickr-months"), e.yearElements = [], e.monthElements = [], e.prevMonthNav = ce("span", "flatpickr-prev-month"), e.prevMonthNav.innerHTML = e.config.prevArrow, e.nextMonthNav = ce("span", "flatpickr-next-month"), e.nextMonthNav.innerHTML = e.config.nextArrow, T(), Object.defineProperty(e, "_hidePrevMonthArrow", {
      get: function() {
        return e.__hidePrevMonthArrow;
      },
      set: function(u) {
        e.__hidePrevMonthArrow !== u && (Le(e.prevMonthNav, "flatpickr-disabled", u), e.__hidePrevMonthArrow = u);
      }
    }), Object.defineProperty(e, "_hideNextMonthArrow", {
      get: function() {
        return e.__hideNextMonthArrow;
      },
      set: function(u) {
        e.__hideNextMonthArrow !== u && (Le(e.nextMonthNav, "flatpickr-disabled", u), e.__hideNextMonthArrow = u);
      }
    }), e.currentYearElement = e.yearElements[0], Cn(), e.monthNav;
  }
  function B() {
    e.calendarContainer.classList.add("hasTime"), e.config.noCalendar && e.calendarContainer.classList.add("noCalendar");
    var u = sr(e.config);
    e.timeContainer = ce("div", "flatpickr-time"), e.timeContainer.tabIndex = -1;
    var f = ce("span", "flatpickr-time-separator", ":"), b = kn("flatpickr-hour", {
      "aria-label": e.l10n.hourAriaLabel
    });
    e.hourElement = b.getElementsByTagName("input")[0];
    var C = kn("flatpickr-minute", {
      "aria-label": e.l10n.minuteAriaLabel
    });
    if (e.minuteElement = C.getElementsByTagName("input")[0], e.hourElement.tabIndex = e.minuteElement.tabIndex = -1, e.hourElement.value = Be(e.latestSelectedDateObj ? e.latestSelectedDateObj.getHours() : e.config.time_24hr ? u.hours : p(u.hours)), e.minuteElement.value = Be(e.latestSelectedDateObj ? e.latestSelectedDateObj.getMinutes() : u.minutes), e.hourElement.setAttribute("step", e.config.hourIncrement.toString()), e.minuteElement.setAttribute("step", e.config.minuteIncrement.toString()), e.hourElement.setAttribute("min", e.config.time_24hr ? "0" : "1"), e.hourElement.setAttribute("max", e.config.time_24hr ? "23" : "12"), e.hourElement.setAttribute("maxlength", "2"), e.minuteElement.setAttribute("min", "0"), e.minuteElement.setAttribute("max", "59"), e.minuteElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild(b), e.timeContainer.appendChild(f), e.timeContainer.appendChild(C), e.config.time_24hr && e.timeContainer.classList.add("time24hr"), e.config.enableSeconds) {
      e.timeContainer.classList.add("hasSeconds");
      var O = kn("flatpickr-second");
      e.secondElement = O.getElementsByTagName("input")[0], e.secondElement.value = Be(e.latestSelectedDateObj ? e.latestSelectedDateObj.getSeconds() : u.seconds), e.secondElement.setAttribute("step", e.minuteElement.getAttribute("step")), e.secondElement.setAttribute("min", "0"), e.secondElement.setAttribute("max", "59"), e.secondElement.setAttribute("maxlength", "2"), e.timeContainer.appendChild(ce("span", "flatpickr-time-separator", ":")), e.timeContainer.appendChild(O);
    }
    return e.config.time_24hr || (e.amPM = ce("span", "flatpickr-am-pm", e.l10n.amPM[ze((e.latestSelectedDateObj ? e.hourElement.value : e.config.defaultHour) > 11)]), e.amPM.title = e.l10n.toggleTitle, e.amPM.tabIndex = -1, e.timeContainer.appendChild(e.amPM)), e.timeContainer;
  }
  function A() {
    e.weekdayContainer ? $n(e.weekdayContainer) : e.weekdayContainer = ce("div", "flatpickr-weekdays");
    for (var u = e.config.showMonths; u--; ) {
      var f = ce("div", "flatpickr-weekdaycontainer");
      e.weekdayContainer.appendChild(f);
    }
    return W(), e.weekdayContainer;
  }
  function W() {
    if (e.weekdayContainer) {
      var u = e.l10n.firstDayOfWeek, f = to(e.l10n.weekdays.shorthand);
      u > 0 && u < f.length && (f = to(f.splice(u, f.length), f.splice(0, u)));
      for (var b = e.config.showMonths; b--; )
        e.weekdayContainer.children[b].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + f.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
    }
  }
  function K() {
    e.calendarContainer.classList.add("hasWeeks");
    var u = ce("div", "flatpickr-weekwrapper");
    u.appendChild(ce("span", "flatpickr-weekday", e.l10n.weekAbbreviation));
    var f = ce("div", "flatpickr-weeks");
    return u.appendChild(f), {
      weekWrapper: u,
      weekNumbers: f
    };
  }
  function le(u, f) {
    f === void 0 && (f = !0);
    var b = f ? u : u - e.currentMonth;
    b < 0 && e._hidePrevMonthArrow === !0 || b > 0 && e._hideNextMonthArrow === !0 || (e.currentMonth += b, (e.currentMonth < 0 || e.currentMonth > 11) && (e.currentYear += e.currentMonth > 11 ? 1 : -1, e.currentMonth = (e.currentMonth + 12) % 12, we("onYearChange"), me()), Ce(), we("onMonthChange"), Cn());
  }
  function de(u, f) {
    if (u === void 0 && (u = !0), f === void 0 && (f = !0), e.input.value = "", e.altInput !== void 0 && (e.altInput.value = ""), e.mobileInput !== void 0 && (e.mobileInput.value = ""), e.selectedDates = [], e.latestSelectedDateObj = void 0, f === !0 && (e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth()), e.config.enableTime === !0) {
      var b = sr(e.config), C = b.hours, O = b.minutes, x = b.seconds;
      y(C, O, x);
    }
    e.redraw(), u && we("onChange");
  }
  function ge() {
    e.isOpen = !1, e.isMobile || (e.calendarContainer !== void 0 && e.calendarContainer.classList.remove("open"), e._input !== void 0 && e._input.classList.remove("active")), we("onClose");
  }
  function be() {
    e.config !== void 0 && we("onDestroy");
    for (var u = e._handlers.length; u--; )
      e._handlers[u].remove();
    if (e._handlers = [], e.mobileInput)
      e.mobileInput.parentNode && e.mobileInput.parentNode.removeChild(e.mobileInput), e.mobileInput = void 0;
    else if (e.calendarContainer && e.calendarContainer.parentNode)
      if (e.config.static && e.calendarContainer.parentNode) {
        var f = e.calendarContainer.parentNode;
        if (f.lastChild && f.removeChild(f.lastChild), f.parentNode) {
          for (; f.firstChild; )
            f.parentNode.insertBefore(f.firstChild, f);
          f.parentNode.removeChild(f);
        }
      } else
        e.calendarContainer.parentNode.removeChild(e.calendarContainer);
    e.altInput && (e.input.type = "text", e.altInput.parentNode && e.altInput.parentNode.removeChild(e.altInput), delete e.altInput), e.input && (e.input.type = e.input._type, e.input.classList.remove("flatpickr-input"), e.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(b) {
      try {
        delete e[b];
      } catch {
      }
    });
  }
  function pe(u) {
    return e.calendarContainer.contains(u);
  }
  function Ae(u) {
    if (e.isOpen && !e.config.inline) {
      var f = Ne(u), b = pe(f), C = f === e.input || f === e.altInput || e.element.contains(f) || u.path && u.path.indexOf && (~u.path.indexOf(e.input) || ~u.path.indexOf(e.altInput)), O = !C && !b && !pe(u.relatedTarget), x = !e.config.ignoredFocusElements.some(function(re) {
        return re.contains(f);
      });
      O && x && (e.config.allowInput && e.setDate(e._input.value, !1, e.config.altInput ? e.config.altFormat : e.config.dateFormat), e.timeContainer !== void 0 && e.minuteElement !== void 0 && e.hourElement !== void 0 && e.input.value !== "" && e.input.value !== void 0 && l(), e.close(), e.config && e.config.mode === "range" && e.selectedDates.length === 1 && e.clear(!1));
    }
  }
  function Oe(u) {
    if (!(!u || e.config.minDate && u < e.config.minDate.getFullYear() || e.config.maxDate && u > e.config.maxDate.getFullYear())) {
      var f = u, b = e.currentYear !== f;
      e.currentYear = f || e.currentYear, e.config.maxDate && e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth = Math.min(e.config.maxDate.getMonth(), e.currentMonth) : e.config.minDate && e.currentYear === e.config.minDate.getFullYear() && (e.currentMonth = Math.max(e.config.minDate.getMonth(), e.currentMonth)), b && (e.redraw(), we("onYearChange"), me());
    }
  }
  function $e(u, f) {
    var b;
    f === void 0 && (f = !0);
    var C = e.parseDate(u, void 0, f);
    if (e.config.minDate && C && Fe(C, e.config.minDate, f !== void 0 ? f : !e.minDateHasTime) < 0 || e.config.maxDate && C && Fe(C, e.config.maxDate, f !== void 0 ? f : !e.maxDateHasTime) > 0)
      return !1;
    if (!e.config.enable && e.config.disable.length === 0)
      return !0;
    if (C === void 0)
      return !1;
    for (var O = !!e.config.enable, x = (b = e.config.enable) !== null && b !== void 0 ? b : e.config.disable, re = 0, R = void 0; re < x.length; re++) {
      if (R = x[re], typeof R == "function" && R(C))
        return O;
      if (R instanceof Date && C !== void 0 && R.getTime() === C.getTime())
        return O;
      if (typeof R == "string") {
        var oe = e.parseDate(R, void 0, !0);
        return oe && oe.getTime() === C.getTime() ? O : !O;
      } else if (typeof R == "object" && C !== void 0 && R.from && R.to && C.getTime() >= R.from.getTime() && C.getTime() <= R.to.getTime())
        return O;
    }
    return !O;
  }
  function Ee(u) {
    return e.daysContainer !== void 0 ? u.className.indexOf("hidden") === -1 && u.className.indexOf("flatpickr-disabled") === -1 && e.daysContainer.contains(u) : !1;
  }
  function Se(u) {
    var f = u.target === e._input, b = e._input.value.trimEnd() !== tr();
    f && b && !(u.relatedTarget && pe(u.relatedTarget)) && e.setDate(e._input.value, !0, u.target === e.altInput ? e.config.altFormat : e.config.dateFormat);
  }
  function Ie(u) {
    var f = Ne(u), b = e.config.wrap ? t.contains(f) : f === e._input, C = e.config.allowInput, O = e.isOpen && (!C || !b), x = e.config.inline && b && !C;
    if (u.keyCode === 13 && b) {
      if (C)
        return e.setDate(e._input.value, !0, f === e.altInput ? e.config.altFormat : e.config.dateFormat), e.close(), f.blur();
      e.open();
    } else if (pe(f) || O || x) {
      var re = !!e.timeContainer && e.timeContainer.contains(f);
      switch (u.keyCode) {
        case 13:
          re ? (u.preventDefault(), l(), Et()) : xt(u);
          break;
        case 27:
          u.preventDefault(), Et();
          break;
        case 8:
        case 46:
          b && !e.config.allowInput && (u.preventDefault(), e.clear());
          break;
        case 37:
        case 39:
          if (!re && !b) {
            u.preventDefault();
            var R = a();
            if (e.daysContainer !== void 0 && (C === !1 || R && Ee(R))) {
              var oe = u.keyCode === 39 ? 1 : -1;
              u.ctrlKey ? (u.stopPropagation(), le(oe), te(ne(1), 0)) : te(void 0, oe);
            }
          } else
            e.hourElement && e.hourElement.focus();
          break;
        case 38:
        case 40:
          u.preventDefault();
          var N = u.keyCode === 40 ? 1 : -1;
          e.daysContainer && f.$i !== void 0 || f === e.input || f === e.altInput ? u.ctrlKey ? (u.stopPropagation(), Oe(e.currentYear - N), te(ne(1), 0)) : re || te(void 0, N * 7) : f === e.currentYearElement ? Oe(e.currentYear - N) : e.config.enableTime && (!re && e.hourElement && e.hourElement.focus(), l(u), e._debouncedChange());
          break;
        case 9:
          if (re) {
            var X = [
              e.hourElement,
              e.minuteElement,
              e.secondElement,
              e.amPM
            ].concat(e.pluginElements).filter(function(je) {
              return je;
            }), ve = X.indexOf(f);
            if (ve !== -1) {
              var Ze = X[ve + (u.shiftKey ? -1 : 1)];
              u.preventDefault(), (Ze || e._input).focus();
            }
          } else
            !e.config.noCalendar && e.daysContainer && e.daysContainer.contains(f) && u.shiftKey && (u.preventDefault(), e._input.focus());
          break;
      }
    }
    if (e.amPM !== void 0 && f === e.amPM)
      switch (u.key) {
        case e.l10n.amPM[0].charAt(0):
        case e.l10n.amPM[0].charAt(0).toLowerCase():
          e.amPM.textContent = e.l10n.amPM[0], _(), ot();
          break;
        case e.l10n.amPM[1].charAt(0):
        case e.l10n.amPM[1].charAt(0).toLowerCase():
          e.amPM.textContent = e.l10n.amPM[1], _(), ot();
          break;
      }
    (b || pe(f)) && we("onKeyDown", u);
  }
  function He(u, f) {
    if (f === void 0 && (f = "flatpickr-day"), !(e.selectedDates.length !== 1 || u && (!u.classList.contains(f) || u.classList.contains("flatpickr-disabled")))) {
      for (var b = u ? u.dateObj.getTime() : e.days.firstElementChild.dateObj.getTime(), C = e.parseDate(e.selectedDates[0], void 0, !0).getTime(), O = Math.min(b, e.selectedDates[0].getTime()), x = Math.max(b, e.selectedDates[0].getTime()), re = !1, R = 0, oe = 0, N = O; N < x; N += tl.DAY)
        $e(new Date(N), !0) || (re = re || N > O && N < x, N < C && (!R || N > R) ? R = N : N > C && (!oe || N < oe) && (oe = N));
      var X = Array.from(e.rContainer.querySelectorAll("*:nth-child(-n+" + e.config.showMonths + ") > ." + f));
      X.forEach(function(ve) {
        var Ze = ve.dateObj, je = Ze.getTime(), Xt = R > 0 && je < R || oe > 0 && je > oe;
        if (Xt) {
          ve.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function(It) {
            ve.classList.remove(It);
          });
          return;
        } else if (re && !Xt)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(It) {
          ve.classList.remove(It);
        }), u !== void 0 && (u.classList.add(b <= e.selectedDates[0].getTime() ? "startRange" : "endRange"), C < b && je === C ? ve.classList.add("startRange") : C > b && je === C && ve.classList.add("endRange"), je >= R && (oe === 0 || je <= oe) && Qs(je, C, b) && ve.classList.add("inRange"));
      });
    }
  }
  function nt() {
    e.isOpen && !e.config.static && !e.config.inline && Tt();
  }
  function Xn(u, f) {
    if (f === void 0 && (f = e._positionElement), e.isMobile === !0) {
      if (u) {
        u.preventDefault();
        var b = Ne(u);
        b && b.blur();
      }
      e.mobileInput !== void 0 && (e.mobileInput.focus(), e.mobileInput.click()), we("onOpen");
      return;
    } else if (e._input.disabled || e.config.inline)
      return;
    var C = e.isOpen;
    e.isOpen = !0, C || (e.calendarContainer.classList.add("open"), e._input.classList.add("active"), we("onOpen"), Tt(f)), e.config.enableTime === !0 && e.config.noCalendar === !0 && e.config.allowInput === !1 && (u === void 0 || !e.timeContainer.contains(u.relatedTarget)) && setTimeout(function() {
      return e.hourElement.select();
    }, 50);
  }
  function mn(u) {
    return function(f) {
      var b = e.config["_" + u + "Date"] = e.parseDate(f, e.config.dateFormat), C = e.config["_" + (u === "min" ? "max" : "min") + "Date"];
      b !== void 0 && (e[u === "min" ? "minDateHasTime" : "maxDateHasTime"] = b.getHours() > 0 || b.getMinutes() > 0 || b.getSeconds() > 0), e.selectedDates && (e.selectedDates = e.selectedDates.filter(function(O) {
        return $e(O);
      }), !e.selectedDates.length && u === "min" && h(b), ot()), e.daysContainer && (Zt(), b !== void 0 ? e.currentYearElement[u] = b.getFullYear().toString() : e.currentYearElement.removeAttribute(u), e.currentYearElement.disabled = !!C && b !== void 0 && C.getFullYear() === b.getFullYear());
    };
  }
  function gn() {
    var u = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], f = xe(xe({}, JSON.parse(JSON.stringify(t.dataset || {}))), n), b = {};
    e.config.parseDate = f.parseDate, e.config.formatDate = f.formatDate, Object.defineProperty(e.config, "enable", {
      get: function() {
        return e.config._enable;
      },
      set: function(X) {
        e.config._enable = Zr(X);
      }
    }), Object.defineProperty(e.config, "disable", {
      get: function() {
        return e.config._disable;
      },
      set: function(X) {
        e.config._disable = Zr(X);
      }
    });
    var C = f.mode === "time";
    if (!f.dateFormat && (f.enableTime || C)) {
      var O = ke.defaultConfig.dateFormat || Bt.dateFormat;
      b.dateFormat = f.noCalendar || C ? "H:i" + (f.enableSeconds ? ":S" : "") : O + " H:i" + (f.enableSeconds ? ":S" : "");
    }
    if (f.altInput && (f.enableTime || C) && !f.altFormat) {
      var x = ke.defaultConfig.altFormat || Bt.altFormat;
      b.altFormat = f.noCalendar || C ? "h:i" + (f.enableSeconds ? ":S K" : " K") : x + (" h:i" + (f.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(e.config, "minDate", {
      get: function() {
        return e.config._minDate;
      },
      set: mn("min")
    }), Object.defineProperty(e.config, "maxDate", {
      get: function() {
        return e.config._maxDate;
      },
      set: mn("max")
    });
    var re = function(X) {
      return function(ve) {
        e.config[X === "min" ? "_minTime" : "_maxTime"] = e.parseDate(ve, "H:i:S");
      };
    };
    Object.defineProperty(e.config, "minTime", {
      get: function() {
        return e.config._minTime;
      },
      set: re("min")
    }), Object.defineProperty(e.config, "maxTime", {
      get: function() {
        return e.config._maxTime;
      },
      set: re("max")
    }), f.mode === "time" && (e.config.noCalendar = !0, e.config.enableTime = !0), Object.assign(e.config, b, f);
    for (var R = 0; R < u.length; R++)
      e.config[u[R]] = e.config[u[R]] === !0 || e.config[u[R]] === "true";
    rr.filter(function(X) {
      return e.config[X] !== void 0;
    }).forEach(function(X) {
      e.config[X] = or(e.config[X] || []).map(s);
    }), e.isMobile = !e.config.disableMobile && !e.config.inline && e.config.mode === "single" && !e.config.disable.length && !e.config.enable && !e.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var R = 0; R < e.config.plugins.length; R++) {
      var oe = e.config.plugins[R](e) || {};
      for (var N in oe)
        rr.indexOf(N) > -1 ? e.config[N] = or(oe[N]).map(s).concat(e.config[N]) : typeof f[N] > "u" && (e.config[N] = oe[N]);
    }
    f.altInputClass || (e.config.altInputClass = Gt().className + " " + e.config.altInputClass), we("onParseConfig");
  }
  function Gt() {
    return e.config.wrap ? t.querySelector("[data-input]") : t;
  }
  function bn() {
    typeof e.config.locale != "object" && typeof ke.l10ns[e.config.locale] > "u" && e.config.errorHandler(new Error("flatpickr: invalid locale " + e.config.locale)), e.l10n = xe(xe({}, ke.l10ns.default), typeof e.config.locale == "object" ? e.config.locale : e.config.locale !== "default" ? ke.l10ns[e.config.locale] : void 0), gt.D = "(" + e.l10n.weekdays.shorthand.join("|") + ")", gt.l = "(" + e.l10n.weekdays.longhand.join("|") + ")", gt.M = "(" + e.l10n.months.shorthand.join("|") + ")", gt.F = "(" + e.l10n.months.longhand.join("|") + ")", gt.K = "(" + e.l10n.amPM[0] + "|" + e.l10n.amPM[1] + "|" + e.l10n.amPM[0].toLowerCase() + "|" + e.l10n.amPM[1].toLowerCase() + ")";
    var u = xe(xe({}, n), JSON.parse(JSON.stringify(t.dataset || {})));
    u.time_24hr === void 0 && ke.defaultConfig.time_24hr === void 0 && (e.config.time_24hr = e.l10n.time_24hr), e.formatDate = ya(e), e.parseDate = vr({ config: e.config, l10n: e.l10n });
  }
  function Tt(u) {
    if (typeof e.config.position == "function")
      return void e.config.position(e, u);
    if (e.calendarContainer !== void 0) {
      we("onPreCalendarPosition");
      var f = u || e._positionElement, b = Array.prototype.reduce.call(e.calendarContainer.children, function(Ti, Ai) {
        return Ti + Ai.offsetHeight;
      }, 0), C = e.calendarContainer.offsetWidth, O = e.config.position.split(" "), x = O[0], re = O.length > 1 ? O[1] : null, R = f.getBoundingClientRect(), oe = window.innerHeight - R.bottom, N = x === "above" || x !== "below" && oe < b && R.top > b, X = window.pageYOffset + R.top + (N ? -b - 2 : f.offsetHeight + 2);
      if (Le(e.calendarContainer, "arrowTop", !N), Le(e.calendarContainer, "arrowBottom", N), !e.config.inline) {
        var ve = window.pageXOffset + R.left, Ze = !1, je = !1;
        re === "center" ? (ve -= (C - R.width) / 2, Ze = !0) : re === "right" && (ve -= C - R.width, je = !0), Le(e.calendarContainer, "arrowLeft", !Ze && !je), Le(e.calendarContainer, "arrowCenter", Ze), Le(e.calendarContainer, "arrowRight", je);
        var Xt = window.document.body.offsetWidth - (window.pageXOffset + R.right), It = ve + C > window.document.body.offsetWidth, Ci = Xt + C > window.document.body.offsetWidth;
        if (Le(e.calendarContainer, "rightMost", It), !e.config.static)
          if (e.calendarContainer.style.top = X + "px", !It)
            e.calendarContainer.style.left = ve + "px", e.calendarContainer.style.right = "auto";
          else if (!Ci)
            e.calendarContainer.style.left = "auto", e.calendarContainer.style.right = Xt + "px";
          else {
            var nr = rt();
            if (nr === void 0)
              return;
            var $i = window.document.body.offsetWidth, ki = Math.max(0, $i / 2 - C / 2), Mi = ".flatpickr-calendar.centerMost:before", Di = ".flatpickr-calendar.centerMost:after", Si = nr.cssRules.length, Oi = "{left:" + R.left + "px;right:auto;}";
            Le(e.calendarContainer, "rightMost", !1), Le(e.calendarContainer, "centerMost", !0), nr.insertRule(Mi + "," + Di + Oi, Si), e.calendarContainer.style.left = ki + "px", e.calendarContainer.style.right = "auto";
          }
      }
    }
  }
  function rt() {
    for (var u = null, f = 0; f < document.styleSheets.length; f++) {
      var b = document.styleSheets[f];
      if (b.cssRules) {
        try {
          b.cssRules;
        } catch {
          continue;
        }
        u = b;
        break;
      }
    }
    return u ?? At();
  }
  function At() {
    var u = document.createElement("style");
    return document.head.appendChild(u), u.sheet;
  }
  function Zt() {
    e.config.noCalendar || e.isMobile || (me(), Cn(), Ce());
  }
  function Et() {
    e._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(e.close, 0) : e.close();
  }
  function xt(u) {
    u.preventDefault(), u.stopPropagation();
    var f = function(X) {
      return X.classList && X.classList.contains("flatpickr-day") && !X.classList.contains("flatpickr-disabled") && !X.classList.contains("notAllowed");
    }, b = ba(Ne(u), f);
    if (b !== void 0) {
      var C = b, O = e.latestSelectedDateObj = new Date(C.dateObj.getTime()), x = (O.getMonth() < e.currentMonth || O.getMonth() > e.currentMonth + e.config.showMonths - 1) && e.config.mode !== "range";
      if (e.selectedDateElem = C, e.config.mode === "single")
        e.selectedDates = [O];
      else if (e.config.mode === "multiple") {
        var re = er(O);
        re ? e.selectedDates.splice(parseInt(re), 1) : e.selectedDates.push(O);
      } else
        e.config.mode === "range" && (e.selectedDates.length === 2 && e.clear(!1, !1), e.latestSelectedDateObj = O, e.selectedDates.push(O), Fe(O, e.selectedDates[0], !0) !== 0 && e.selectedDates.sort(function(X, ve) {
          return X.getTime() - ve.getTime();
        }));
      if (_(), x) {
        var R = e.currentYear !== O.getFullYear();
        e.currentYear = O.getFullYear(), e.currentMonth = O.getMonth(), R && (we("onYearChange"), me()), we("onMonthChange");
      }
      if (Cn(), Ce(), ot(), !x && e.config.mode !== "range" && e.config.showMonths === 1 ? se(C) : e.selectedDateElem !== void 0 && e.hourElement === void 0 && e.selectedDateElem && e.selectedDateElem.focus(), e.hourElement !== void 0 && e.hourElement !== void 0 && e.hourElement.focus(), e.config.closeOnSelect) {
        var oe = e.config.mode === "single" && !e.config.enableTime, N = e.config.mode === "range" && e.selectedDates.length === 2 && !e.config.enableTime;
        (oe || N) && Et();
      }
      M();
    }
  }
  var _t = {
    locale: [bn, W],
    showMonths: [T, i, A],
    minDate: [D],
    maxDate: [D],
    positionElement: [Jr],
    clickOpens: [
      function() {
        e.config.clickOpens === !0 ? (k(e._input, "focus", e.open), k(e._input, "click", e.open)) : (e._input.removeEventListener("focus", e.open), e._input.removeEventListener("click", e.open));
      }
    ]
  };
  function yn(u, f) {
    if (u !== null && typeof u == "object") {
      Object.assign(e.config, u);
      for (var b in u)
        _t[b] !== void 0 && _t[b].forEach(function(C) {
          return C();
        });
    } else
      e.config[u] = f, _t[u] !== void 0 ? _t[u].forEach(function(C) {
        return C();
      }) : rr.indexOf(u) > -1 && (e.config[u] = or(f));
    e.redraw(), ot(!0);
  }
  function Jt(u, f) {
    var b = [];
    if (u instanceof Array)
      b = u.map(function(C) {
        return e.parseDate(C, f);
      });
    else if (u instanceof Date || typeof u == "number")
      b = [e.parseDate(u, f)];
    else if (typeof u == "string")
      switch (e.config.mode) {
        case "single":
        case "time":
          b = [e.parseDate(u, f)];
          break;
        case "multiple":
          b = u.split(e.config.conjunction).map(function(C) {
            return e.parseDate(C, f);
          });
          break;
        case "range":
          b = u.split(e.l10n.rangeSeparator).map(function(C) {
            return e.parseDate(C, f);
          });
          break;
      }
    else
      e.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(u)));
    e.selectedDates = e.config.allowInvalidPreload ? b : b.filter(function(C) {
      return C instanceof Date && $e(C, !1);
    }), e.config.mode === "range" && e.selectedDates.sort(function(C, O) {
      return C.getTime() - O.getTime();
    });
  }
  function wn(u, f, b) {
    if (f === void 0 && (f = !1), b === void 0 && (b = e.config.dateFormat), u !== 0 && !u || u instanceof Array && u.length === 0)
      return e.clear(f);
    Jt(u, b), e.latestSelectedDateObj = e.selectedDates[e.selectedDates.length - 1], e.redraw(), D(void 0, f), h(), e.selectedDates.length === 0 && e.clear(!1), ot(f), f && we("onChange");
  }
  function Zr(u) {
    return u.slice().map(function(f) {
      return typeof f == "string" || typeof f == "number" || f instanceof Date ? e.parseDate(f, void 0, !0) : f && typeof f == "object" && f.from && f.to ? {
        from: e.parseDate(f.from, void 0),
        to: e.parseDate(f.to, void 0)
      } : f;
    }).filter(function(f) {
      return f;
    });
  }
  function hi() {
    e.selectedDates = [], e.now = e.parseDate(e.config.now) || /* @__PURE__ */ new Date();
    var u = e.config.defaultDate || ((e.input.nodeName === "INPUT" || e.input.nodeName === "TEXTAREA") && e.input.placeholder && e.input.value === e.input.placeholder ? null : e.input.value);
    u && Jt(u, e.config.dateFormat), e._initialDate = e.selectedDates.length > 0 ? e.selectedDates[0] : e.config.minDate && e.config.minDate.getTime() > e.now.getTime() ? e.config.minDate : e.config.maxDate && e.config.maxDate.getTime() < e.now.getTime() ? e.config.maxDate : e.now, e.currentYear = e._initialDate.getFullYear(), e.currentMonth = e._initialDate.getMonth(), e.selectedDates.length > 0 && (e.latestSelectedDateObj = e.selectedDates[0]), e.config.minTime !== void 0 && (e.config.minTime = e.parseDate(e.config.minTime, "H:i")), e.config.maxTime !== void 0 && (e.config.maxTime = e.parseDate(e.config.maxTime, "H:i")), e.minDateHasTime = !!e.config.minDate && (e.config.minDate.getHours() > 0 || e.config.minDate.getMinutes() > 0 || e.config.minDate.getSeconds() > 0), e.maxDateHasTime = !!e.config.maxDate && (e.config.maxDate.getHours() > 0 || e.config.maxDate.getMinutes() > 0 || e.config.maxDate.getSeconds() > 0);
  }
  function _i() {
    if (e.input = Gt(), !e.input) {
      e.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    e.input._type = e.input.type, e.input.type = "text", e.input.classList.add("flatpickr-input"), e._input = e.input, e.config.altInput && (e.altInput = ce(e.input.nodeName, e.config.altInputClass), e._input = e.altInput, e.altInput.placeholder = e.input.placeholder, e.altInput.disabled = e.input.disabled, e.altInput.required = e.input.required, e.altInput.tabIndex = e.input.tabIndex, e.altInput.type = "text", e.input.setAttribute("type", "hidden"), !e.config.static && e.input.parentNode && e.input.parentNode.insertBefore(e.altInput, e.input.nextSibling)), e.config.allowInput || e._input.setAttribute("readonly", "readonly"), Jr();
  }
  function Jr() {
    e._positionElement = e.config.positionElement || e._input;
  }
  function mi() {
    var u = e.config.enableTime ? e.config.noCalendar ? "time" : "datetime-local" : "date";
    e.mobileInput = ce("input", e.input.className + " flatpickr-mobile"), e.mobileInput.tabIndex = 1, e.mobileInput.type = u, e.mobileInput.disabled = e.input.disabled, e.mobileInput.required = e.input.required, e.mobileInput.placeholder = e.input.placeholder, e.mobileFormatStr = u === "datetime-local" ? "Y-m-d\\TH:i:S" : u === "date" ? "Y-m-d" : "H:i:S", e.selectedDates.length > 0 && (e.mobileInput.defaultValue = e.mobileInput.value = e.formatDate(e.selectedDates[0], e.mobileFormatStr)), e.config.minDate && (e.mobileInput.min = e.formatDate(e.config.minDate, "Y-m-d")), e.config.maxDate && (e.mobileInput.max = e.formatDate(e.config.maxDate, "Y-m-d")), e.input.getAttribute("step") && (e.mobileInput.step = String(e.input.getAttribute("step"))), e.input.type = "hidden", e.altInput !== void 0 && (e.altInput.type = "hidden");
    try {
      e.input.parentNode && e.input.parentNode.insertBefore(e.mobileInput, e.input.nextSibling);
    } catch {
    }
    k(e.mobileInput, "change", function(f) {
      e.setDate(Ne(f).value, !1, e.mobileFormatStr), we("onChange"), we("onClose");
    });
  }
  function gi(u) {
    if (e.isOpen === !0)
      return e.close();
    e.open(u);
  }
  function we(u, f) {
    if (e.config !== void 0) {
      var b = e.config[u];
      if (b !== void 0 && b.length > 0)
        for (var C = 0; b[C] && C < b.length; C++)
          b[C](e.selectedDates, e.input.value, e, f);
      u === "onChange" && (e.input.dispatchEvent(Qn("change")), e.input.dispatchEvent(Qn("input")));
    }
  }
  function Qn(u) {
    var f = document.createEvent("Event");
    return f.initEvent(u, !0, !0), f;
  }
  function er(u) {
    for (var f = 0; f < e.selectedDates.length; f++) {
      var b = e.selectedDates[f];
      if (b instanceof Date && Fe(b, u) === 0)
        return "" + f;
    }
    return !1;
  }
  function bi(u) {
    return e.config.mode !== "range" || e.selectedDates.length < 2 ? !1 : Fe(u, e.selectedDates[0]) >= 0 && Fe(u, e.selectedDates[1]) <= 0;
  }
  function Cn() {
    e.config.noCalendar || e.isMobile || !e.monthNav || (e.yearElements.forEach(function(u, f) {
      var b = new Date(e.currentYear, e.currentMonth, 1);
      b.setMonth(e.currentMonth + f), e.config.showMonths > 1 || e.config.monthSelectorType === "static" ? e.monthElements[f].textContent = In(b.getMonth(), e.config.shorthandCurrentMonth, e.l10n) + " " : e.monthsDropdownContainer.value = b.getMonth().toString(), u.value = b.getFullYear().toString();
    }), e._hidePrevMonthArrow = e.config.minDate !== void 0 && (e.currentYear === e.config.minDate.getFullYear() ? e.currentMonth <= e.config.minDate.getMonth() : e.currentYear < e.config.minDate.getFullYear()), e._hideNextMonthArrow = e.config.maxDate !== void 0 && (e.currentYear === e.config.maxDate.getFullYear() ? e.currentMonth + 1 > e.config.maxDate.getMonth() : e.currentYear > e.config.maxDate.getFullYear()));
  }
  function tr(u) {
    var f = u || (e.config.altInput ? e.config.altFormat : e.config.dateFormat);
    return e.selectedDates.map(function(b) {
      return e.formatDate(b, f);
    }).filter(function(b, C, O) {
      return e.config.mode !== "range" || e.config.enableTime || O.indexOf(b) === C;
    }).join(e.config.mode !== "range" ? e.config.conjunction : e.l10n.rangeSeparator);
  }
  function ot(u) {
    u === void 0 && (u = !0), e.mobileInput !== void 0 && e.mobileFormatStr && (e.mobileInput.value = e.latestSelectedDateObj !== void 0 ? e.formatDate(e.latestSelectedDateObj, e.mobileFormatStr) : ""), e.input.value = tr(e.config.dateFormat), e.altInput !== void 0 && (e.altInput.value = tr(e.config.altFormat)), u !== !1 && we("onValueUpdate");
  }
  function yi(u) {
    var f = Ne(u), b = e.prevMonthNav.contains(f), C = e.nextMonthNav.contains(f);
    b || C ? le(b ? -1 : 1) : e.yearElements.indexOf(f) >= 0 ? f.select() : f.classList.contains("arrowUp") ? e.changeYear(e.currentYear + 1) : f.classList.contains("arrowDown") && e.changeYear(e.currentYear - 1);
  }
  function wi(u) {
    u.preventDefault();
    var f = u.type === "keydown", b = Ne(u), C = b;
    e.amPM !== void 0 && b === e.amPM && (e.amPM.textContent = e.l10n.amPM[ze(e.amPM.textContent === e.l10n.amPM[0])]);
    var O = parseFloat(C.getAttribute("min")), x = parseFloat(C.getAttribute("max")), re = parseFloat(C.getAttribute("step")), R = parseInt(C.value, 10), oe = u.delta || (f ? u.which === 38 ? 1 : -1 : 0), N = R + re * oe;
    if (typeof C.value < "u" && C.value.length === 2) {
      var X = C === e.hourElement, ve = C === e.minuteElement;
      N < O ? (N = x + N + ze(!X) + (ze(X) && ze(!e.amPM)), ve && F(void 0, -1, e.hourElement)) : N > x && (N = C === e.hourElement ? N - x - ze(!e.amPM) : O, ve && F(void 0, 1, e.hourElement)), e.amPM && X && (re === 1 ? N + R === 23 : Math.abs(N - R) > re) && (e.amPM.textContent = e.l10n.amPM[ze(e.amPM.textContent === e.l10n.amPM[0])]), C.value = Be(N);
    }
  }
  return o(), e;
}
function Vt(t, n) {
  for (var e = Array.prototype.slice.call(t).filter(function(s) {
    return s instanceof HTMLElement;
  }), r = [], o = 0; o < e.length; o++) {
    var a = e[o];
    try {
      if (a.getAttribute("data-fp-omit") !== null)
        continue;
      a._flatpickr !== void 0 && (a._flatpickr.destroy(), a._flatpickr = void 0), a._flatpickr = rl(a, n || {}), r.push(a._flatpickr);
    } catch (s) {
      console.error(s);
    }
  }
  return r.length === 1 ? r[0] : r;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(t) {
  return Vt(this, t);
}, HTMLElement.prototype.flatpickr = function(t) {
  return Vt([this], t);
});
var ke = function(t, n) {
  return typeof t == "string" ? Vt(window.document.querySelectorAll(t), n) : t instanceof Node ? Vt([t], n) : Vt(t, n);
};
ke.defaultConfig = {};
ke.l10ns = {
  en: xe({}, ln),
  default: xe({}, ln)
};
ke.localize = function(t) {
  ke.l10ns.default = xe(xe({}, ke.l10ns.default), t);
};
ke.setDefaults = function(t) {
  ke.defaultConfig = xe(xe({}, ke.defaultConfig), t);
};
ke.parseDate = vr({});
ke.formatDate = ya({});
ke.compareDates = Fe;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(t) {
  return Vt(this, t);
});
Date.prototype.fp_incr = function(t) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof t == "string" ? parseInt(t, 10) : t));
};
typeof window < "u" && (window.flatpickr = ke);
const wa = [
  "onChange",
  "onClose",
  "onDestroy",
  "onMonthChange",
  "onOpen",
  "onYearChange"
], ol = [
  "onValueUpdate",
  "onDayCreate",
  "onParseConfig",
  "onReady",
  "onPreCalendarPosition",
  "onKeyDown"
];
function no(t) {
  return t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function ro(t) {
  return t instanceof Array ? t : [t];
}
function lr(t) {
  return t && t.length ? t : null;
}
const oo = [...wa, ...ol], al = ["locale", "showMonths"], il = Y({
  name: "FlatPickr",
  compatConfig: {
    MODE: 3
  },
  render() {
    return Sn("input", {
      type: "text",
      "data-input": !0,
      disabled: this.disabled,
      onInput: this.onInput
    });
  },
  emits: [
    "blur",
    "update:modelValue",
    ...oo.map(no)
  ],
  props: {
    modelValue: {
      type: [String, Number, Date, Array, null],
      required: !0
    },
    // https://flatpickr.js.org/options/
    config: {
      type: Object,
      default: () => ({
        defaultDate: null,
        wrap: !1
      })
    },
    events: {
      type: Array,
      default: () => wa
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      fp: null
      //todo make it non-reactive
    };
  },
  mounted() {
    this.fp || (this.fp = ke(this.getElem(), this.prepareConfig()), this.fpInput().addEventListener("blur", this.onBlur), this.$watch("disabled", this.watchDisabled, {
      immediate: !0
    }));
  },
  methods: {
    prepareConfig() {
      let t = Object.assign({}, this.config);
      this.events.forEach((e) => {
        let r = ke.defaultConfig[e] || [], o = (...a) => {
          this.$emit(no(e), ...a);
        };
        t[e] = ro(t[e] || []).concat(r, o);
      });
      const n = this.onClose.bind(this);
      return t.onClose = ro(t.onClose || []).concat(n), t.defaultDate = this.modelValue || t.defaultDate, t;
    },
    /**
     * Get the HTML node where flatpickr to be attached
     * Bind on parent element if wrap is true
     */
    getElem() {
      return this.config.wrap ? this.$el.parentNode : this.$el;
    },
    /**
     * Watch for value changed by date-picker itself and notify parent component
     */
    onInput(t) {
      const n = t.target;
      pt().then(() => {
        this.$emit("update:modelValue", lr(n.value));
      });
    },
    fpInput() {
      return this.fp.altInput || this.fp.input;
    },
    /**
     * Blur event is required by many validation libraries
     */
    onBlur(t) {
      this.$emit("blur", lr(t.target.value));
    },
    /**
     * Flatpickr does not emit input event in some cases
     */
    onClose(t, n) {
      this.$emit("update:modelValue", n);
    },
    /**
     * Watch for the disabled property and sets the value to the real input.
     */
    watchDisabled(t) {
      t ? this.fpInput().setAttribute("disabled", "") : this.fpInput().removeAttribute("disabled");
    }
  },
  watch: {
    /**
     * Watch for any config changes and redraw date-picker
     */
    config: {
      deep: !0,
      handler(t) {
        if (!this.fp)
          return;
        let n = Object.assign({}, t);
        oo.forEach((e) => {
          delete n[e];
        }), this.fp.set(n), al.forEach((e) => {
          typeof n[e] < "u" && this.fp.set(e, n[e]);
        });
      }
    },
    /**
     * Watch for changes from parent component and update DOM
     */
    modelValue(t) {
      var n;
      !this.$el || t === lr(this.$el.value) || (n = this.fp) === null || n === void 0 || n.setDate(t, !0);
    }
  },
  beforeUnmount() {
    this.fp && (this.fpInput().removeEventListener("blur", this.onBlur), this.fp.destroy(), this.fp = null);
  }
});
var tn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ca(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $a = { exports: {} };
(function(t, n) {
  (function(e, r) {
    t.exports = r();
  })(tn, function() {
    var e = 1e3, r = 6e4, o = 36e5, a = "millisecond", s = "second", i = "minute", l = "hour", d = "day", p = "week", _ = "month", h = "quarter", y = "year", $ = "date", k = "Invalid Date", M = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, P = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, D = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(q) {
      var T = ["th", "st", "nd", "rd"], S = q % 100;
      return "[" + q + (T[(S - 20) % 10] || T[S] || T[0]) + "]";
    } }, U = function(q, T, S) {
      var B = String(q);
      return !B || B.length >= T ? q : "" + Array(T + 1 - B.length).join(S) + q;
    }, F = { s: U, z: function(q) {
      var T = -q.utcOffset(), S = Math.abs(T), B = Math.floor(S / 60), A = S % 60;
      return (T <= 0 ? "+" : "-") + U(B, 2, "0") + ":" + U(A, 2, "0");
    }, m: function q(T, S) {
      if (T.date() < S.date())
        return -q(S, T);
      var B = 12 * (S.year() - T.year()) + (S.month() - T.month()), A = T.clone().add(B, _), W = S - A < 0, K = T.clone().add(B + (W ? -1 : 1), _);
      return +(-(B + (S - A) / (W ? A - K : K - A)) || 0);
    }, a: function(q) {
      return q < 0 ? Math.ceil(q) || 0 : Math.floor(q);
    }, p: function(q) {
      return { M: _, y, w: p, d, D: $, h: l, m: i, s, ms: a, Q: h }[q] || String(q || "").toLowerCase().replace(/s$/, "");
    }, u: function(q) {
      return q === void 0;
    } }, G = "en", Z = {};
    Z[G] = D;
    var se = "$isDayjsObject", ne = function(q) {
      return q instanceof Ce || !(!q || !q[se]);
    }, fe = function q(T, S, B) {
      var A;
      if (!T)
        return G;
      if (typeof T == "string") {
        var W = T.toLowerCase();
        Z[W] && (A = W), S && (Z[W] = S, A = W);
        var K = T.split("-");
        if (!A && K.length > 1)
          return q(K[0]);
      } else {
        var le = T.name;
        Z[le] = T, A = le;
      }
      return !B && A && (G = A), A || !B && G;
    }, te = function(q, T) {
      if (ne(q))
        return q.clone();
      var S = typeof T == "object" ? T : {};
      return S.date = q, S.args = arguments, new Ce(S);
    }, J = F;
    J.l = fe, J.i = ne, J.w = function(q, T) {
      return te(q, { locale: T.$L, utc: T.$u, x: T.$x, $offset: T.$offset });
    };
    var Ce = function() {
      function q(S) {
        this.$L = fe(S.locale, null, !0), this.parse(S), this.$x = this.$x || S.x || {}, this[se] = !0;
      }
      var T = q.prototype;
      return T.parse = function(S) {
        this.$d = function(B) {
          var A = B.date, W = B.utc;
          if (A === null)
            return /* @__PURE__ */ new Date(NaN);
          if (J.u(A))
            return /* @__PURE__ */ new Date();
          if (A instanceof Date)
            return new Date(A);
          if (typeof A == "string" && !/Z$/i.test(A)) {
            var K = A.match(M);
            if (K) {
              var le = K[2] - 1 || 0, de = (K[7] || "0").substring(0, 3);
              return W ? new Date(Date.UTC(K[1], le, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, de)) : new Date(K[1], le, K[3] || 1, K[4] || 0, K[5] || 0, K[6] || 0, de);
            }
          }
          return new Date(A);
        }(S), this.init();
      }, T.init = function() {
        var S = this.$d;
        this.$y = S.getFullYear(), this.$M = S.getMonth(), this.$D = S.getDate(), this.$W = S.getDay(), this.$H = S.getHours(), this.$m = S.getMinutes(), this.$s = S.getSeconds(), this.$ms = S.getMilliseconds();
      }, T.$utils = function() {
        return J;
      }, T.isValid = function() {
        return this.$d.toString() !== k;
      }, T.isSame = function(S, B) {
        var A = te(S);
        return this.startOf(B) <= A && A <= this.endOf(B);
      }, T.isAfter = function(S, B) {
        return te(S) < this.startOf(B);
      }, T.isBefore = function(S, B) {
        return this.endOf(B) < te(S);
      }, T.$g = function(S, B, A) {
        return J.u(S) ? this[B] : this.set(A, S);
      }, T.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, T.valueOf = function() {
        return this.$d.getTime();
      }, T.startOf = function(S, B) {
        var A = this, W = !!J.u(B) || B, K = J.p(S), le = function(Ee, Se) {
          var Ie = J.w(A.$u ? Date.UTC(A.$y, Se, Ee) : new Date(A.$y, Se, Ee), A);
          return W ? Ie : Ie.endOf(d);
        }, de = function(Ee, Se) {
          return J.w(A.toDate()[Ee].apply(A.toDate("s"), (W ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Se)), A);
        }, ge = this.$W, be = this.$M, pe = this.$D, Ae = "set" + (this.$u ? "UTC" : "");
        switch (K) {
          case y:
            return W ? le(1, 0) : le(31, 11);
          case _:
            return W ? le(1, be) : le(0, be + 1);
          case p:
            var Oe = this.$locale().weekStart || 0, $e = (ge < Oe ? ge + 7 : ge) - Oe;
            return le(W ? pe - $e : pe + (6 - $e), be);
          case d:
          case $:
            return de(Ae + "Hours", 0);
          case l:
            return de(Ae + "Minutes", 1);
          case i:
            return de(Ae + "Seconds", 2);
          case s:
            return de(Ae + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, T.endOf = function(S) {
        return this.startOf(S, !1);
      }, T.$set = function(S, B) {
        var A, W = J.p(S), K = "set" + (this.$u ? "UTC" : ""), le = (A = {}, A[d] = K + "Date", A[$] = K + "Date", A[_] = K + "Month", A[y] = K + "FullYear", A[l] = K + "Hours", A[i] = K + "Minutes", A[s] = K + "Seconds", A[a] = K + "Milliseconds", A)[W], de = W === d ? this.$D + (B - this.$W) : B;
        if (W === _ || W === y) {
          var ge = this.clone().set($, 1);
          ge.$d[le](de), ge.init(), this.$d = ge.set($, Math.min(this.$D, ge.daysInMonth())).$d;
        } else
          le && this.$d[le](de);
        return this.init(), this;
      }, T.set = function(S, B) {
        return this.clone().$set(S, B);
      }, T.get = function(S) {
        return this[J.p(S)]();
      }, T.add = function(S, B) {
        var A, W = this;
        S = Number(S);
        var K = J.p(B), le = function(be) {
          var pe = te(W);
          return J.w(pe.date(pe.date() + Math.round(be * S)), W);
        };
        if (K === _)
          return this.set(_, this.$M + S);
        if (K === y)
          return this.set(y, this.$y + S);
        if (K === d)
          return le(1);
        if (K === p)
          return le(7);
        var de = (A = {}, A[i] = r, A[l] = o, A[s] = e, A)[K] || 1, ge = this.$d.getTime() + S * de;
        return J.w(ge, this);
      }, T.subtract = function(S, B) {
        return this.add(-1 * S, B);
      }, T.format = function(S) {
        var B = this, A = this.$locale();
        if (!this.isValid())
          return A.invalidDate || k;
        var W = S || "YYYY-MM-DDTHH:mm:ssZ", K = J.z(this), le = this.$H, de = this.$m, ge = this.$M, be = A.weekdays, pe = A.months, Ae = A.meridiem, Oe = function(Se, Ie, He, nt) {
          return Se && (Se[Ie] || Se(B, W)) || He[Ie].slice(0, nt);
        }, $e = function(Se) {
          return J.s(le % 12 || 12, Se, "0");
        }, Ee = Ae || function(Se, Ie, He) {
          var nt = Se < 12 ? "AM" : "PM";
          return He ? nt.toLowerCase() : nt;
        };
        return W.replace(P, function(Se, Ie) {
          return Ie || function(He) {
            switch (He) {
              case "YY":
                return String(B.$y).slice(-2);
              case "YYYY":
                return J.s(B.$y, 4, "0");
              case "M":
                return ge + 1;
              case "MM":
                return J.s(ge + 1, 2, "0");
              case "MMM":
                return Oe(A.monthsShort, ge, pe, 3);
              case "MMMM":
                return Oe(pe, ge);
              case "D":
                return B.$D;
              case "DD":
                return J.s(B.$D, 2, "0");
              case "d":
                return String(B.$W);
              case "dd":
                return Oe(A.weekdaysMin, B.$W, be, 2);
              case "ddd":
                return Oe(A.weekdaysShort, B.$W, be, 3);
              case "dddd":
                return be[B.$W];
              case "H":
                return String(le);
              case "HH":
                return J.s(le, 2, "0");
              case "h":
                return $e(1);
              case "hh":
                return $e(2);
              case "a":
                return Ee(le, de, !0);
              case "A":
                return Ee(le, de, !1);
              case "m":
                return String(de);
              case "mm":
                return J.s(de, 2, "0");
              case "s":
                return String(B.$s);
              case "ss":
                return J.s(B.$s, 2, "0");
              case "SSS":
                return J.s(B.$ms, 3, "0");
              case "Z":
                return K;
            }
            return null;
          }(Se) || K.replace(":", "");
        });
      }, T.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, T.diff = function(S, B, A) {
        var W, K = this, le = J.p(B), de = te(S), ge = (de.utcOffset() - this.utcOffset()) * r, be = this - de, pe = function() {
          return J.m(K, de);
        };
        switch (le) {
          case y:
            W = pe() / 12;
            break;
          case _:
            W = pe();
            break;
          case h:
            W = pe() / 3;
            break;
          case p:
            W = (be - ge) / 6048e5;
            break;
          case d:
            W = (be - ge) / 864e5;
            break;
          case l:
            W = be / o;
            break;
          case i:
            W = be / r;
            break;
          case s:
            W = be / e;
            break;
          default:
            W = be;
        }
        return A ? W : J.a(W);
      }, T.daysInMonth = function() {
        return this.endOf(_).$D;
      }, T.$locale = function() {
        return Z[this.$L];
      }, T.locale = function(S, B) {
        if (!S)
          return this.$L;
        var A = this.clone(), W = fe(S, B, !0);
        return W && (A.$L = W), A;
      }, T.clone = function() {
        return J.w(this.$d, this);
      }, T.toDate = function() {
        return new Date(this.valueOf());
      }, T.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, T.toISOString = function() {
        return this.$d.toISOString();
      }, T.toString = function() {
        return this.$d.toUTCString();
      }, q;
    }(), me = Ce.prototype;
    return te.prototype = me, [["$ms", a], ["$s", s], ["$m", i], ["$H", l], ["$W", d], ["$M", _], ["$y", y], ["$D", $]].forEach(function(q) {
      me[q[1]] = function(T) {
        return this.$g(T, q[0], q[1]);
      };
    }), te.extend = function(q, T) {
      return q.$i || (q(T, Ce, te), q.$i = !0), te;
    }, te.locale = fe, te.isDayjs = ne, te.unix = function(q) {
      return te(1e3 * q);
    }, te.en = Z[G], te.Ls = Z, te.p = {}, te;
  });
})($a);
var sl = $a.exports;
const ao = /* @__PURE__ */ Ca(sl), ll = /* @__PURE__ */ Y({
  __name: "VDateField",
  props: /* @__PURE__ */ Ke({
    withTime: { type: Boolean },
    parentConfig: {},
    modelValue: {},
    placeholder: {},
    foreground: { type: Boolean },
    borderless: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    disabled: { type: Boolean }
  }, {
    withTime: !1,
    modelValue: "",
    foreground: !1,
    parentConfig: () => ({}),
    ...Ge,
    placeholder: "YYYY/MM/DD"
  }),
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I(() => ({
      allowInput: !e.withTime,
      altFormat: e.withTime ? "Y/m/d H:i:ss" : "m/d/Y",
      dateFormat: e.withTime ? "Y/m/d H:i:ss" : "m/d/Y",
      altInput: !0,
      wrap: !0,
      enableTime: e.withTime,
      disableMobile: !0,
      time_24hr: !1,
      ...e.parentConfig
    })), a = I({
      get() {
        const i = ao(e.modelValue, e.withTime ? [
          "YYYY-MM-DD HH:mm:ss"
        ] : [
          "YYYY-MM-DD",
          "MM/DD/YYYY"
        ]);
        return i.isValid() ? i.format(e.withTime ? "YYYY-MM-DD HH:mm:ss" : "MM-DD-YYYY") : "";
      },
      set(i) {
        const l = ao(i);
        return l.isValid() ? r("update:modelValue", l.format(e.withTime ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD")) : r("update:modelValue", i);
      }
    }), s = he();
    return (i, l) => (v(), L(c(zn), {
      class: m(c(s)["v-date-field"]),
      label: i.label,
      "with-error": i.withError,
      error: i.error,
      "show-required-star": i.showRequiredStar
    }, {
      default: ee(() => [
        g("div", {
          class: m([
            c(s)["v-date-field__field-wrapper"],
            {
              [c(s)["v-date-field__field-wrapper--foreground"]]: i.foreground
            }
          ])
        }, [
          j(c(il), {
            modelValue: a.value,
            "onUpdate:modelValue": l[0] || (l[0] = (d) => a.value = d),
            class: m(c(s)["v-date-field__flat-pickr"]),
            config: o.value,
            placeholder: i.placeholder
          }, null, 8, ["modelValue", "class", "config", "placeholder"]),
          g("div", {
            class: m(c(s)["v-date-field__flat-icon-wrapper"])
          }, [
            j(Js, {
              height: "16",
              width: "16"
            })
          ], 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["class", "label", "with-error", "error", "show-required-star"]));
  }
}), ul = {
  "v-date-field": "_v-date-field_57t49_1",
  "v-date-field__flat-pickr": "_v-date-field__flat-pickr_57t49_1",
  "v-date-field__field-wrapper": "_v-date-field__field-wrapper_57t49_34",
  "v-date-field__field-wrapper--foreground": "_v-date-field__field-wrapper--foreground_57t49_41",
  "v-date-field__flat-icon-wrapper": "_v-date-field__flat-icon-wrapper_57t49_47"
}, cl = {
  $style: ul
}, dl = /* @__PURE__ */ V(ll, [["__cssModules", cl]]), U3 = /* @__PURE__ */ Y({
  __name: "VDatetimeField",
  props: /* @__PURE__ */ Ke({
    parentConfig: {},
    modelValue: {},
    placeholder: {},
    foreground: { type: Boolean },
    borderless: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    disabled: { type: Boolean }
  }, {
    modelValue: "",
    foreground: !1,
    parentConfig: () => ({}),
    ...Ge,
    placeholder: "YYYY/MM/DD hh:mm:ss"
  }),
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const e = t, r = n;
    return (o, a) => (v(), L(c(dl), De(e, {
      "model-value": o.modelValue,
      "with-time": "",
      "onUpdate:modelValue": a[0] || (a[0] = (s) => r("update:modelValue", s))
    }), null, 16, ["model-value"]));
  }
}), ka = /* @__PURE__ */ Y({
  __name: "VNumberField",
  props: /* @__PURE__ */ Ke({
    modelValue: {},
    foreground: { type: Boolean },
    suffixIcon: {},
    prefixIcon: {},
    borderless: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    placeholder: {},
    disabled: { type: Boolean }
  }, {
    foreground: !1,
    suffixIcon: null,
    prefixIcon: null,
    ...Ge
  }),
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = (l) => l.replaceAll(",", ""), a = I({
      get() {
        if (typeof e.modelValue == "object")
          return "";
        if (e.modelValue === "-")
          return e.modelValue;
        const l = `${e.modelValue}`;
        if (l != null && l.length) {
          const [d, p] = l.replaceAll("%", "").split("."), _ = Intl.NumberFormat(
            "en-EN",
            { minimumFractionDigits: 0, maximumFractionDigits: 0 }
          ).format(Number(o(d)));
          return typeof p == "string" ? `${_}.${p || ""}` : _;
        }
        return "";
      },
      set(l) {
        l === "-" ? r("update:modelValue", "-") : Number.isNaN(Number(o(l))) || r("update:modelValue", o(l));
      }
    }), s = ie(null), i = (l) => {
      var h;
      const d = (h = s.value) == null ? void 0 : h.inputField, p = (d == null ? void 0 : d.selectionStart) || 0, _ = a.value.slice(0, p).split(",").length;
      a.value = l, !(!p && !d) && pt(() => {
        const $ = _ !== a.value.slice(0, p).split(",").length ? p + 1 : p;
        d.focus(), d.setSelectionRange($, $);
      });
    };
    return (l, d) => (v(), L(c(Yn), {
      ref_key: "numberField",
      ref: s,
      "model-value": a.value,
      label: l.label,
      foreground: l.foreground,
      "show-required-star": l.showRequiredStar,
      error: l.error,
      "with-error": l.withError,
      "is-number": "",
      "suffix-icon": l.suffixIcon,
      "prefix-icon": l.prefixIcon,
      borderless: l.borderless,
      "onUpdate:modelValue": d[0] || (d[0] = (p) => i(p))
    }, null, 8, ["model-value", "label", "foreground", "show-required-star", "error", "with-error", "suffix-icon", "prefix-icon", "borderless"]));
  }
}), fl = {}, pl = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  width: "16",
  viewBox: "0 0 16 16"
}, vl = /* @__PURE__ */ g("g", {
  "stroke-width": "1",
  "stroke-linejoin": "round",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round"
}, [
  /* @__PURE__ */ g("line", {
    x1: "3",
    y1: "14.5",
    x2: "13",
    y2: "1.5",
    stroke: "currentColor"
  }),
  /* @__PURE__ */ g("circle", {
    cx: "4.5",
    cy: "4",
    r: "2.5"
  }),
  /* @__PURE__ */ g("circle", {
    cx: "11.5",
    cy: "12",
    r: "2.5"
  })
], -1), hl = [
  vl
];
function _l(t, n) {
  return v(), w("svg", pl, hl);
}
const ml = /* @__PURE__ */ V(fl, [["render", _l]]), q3 = /* @__PURE__ */ Y({
  __name: "VPercentField",
  props: /* @__PURE__ */ Ke({
    modelValue: {},
    foreground: { type: Boolean },
    prefixIcon: {},
    borderless: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    placeholder: {},
    disabled: { type: Boolean }
  }, {
    foreground: !1,
    ...Ge
  }),
  emits: ["update:model-value"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I({
      get() {
        return e.modelValue;
      },
      set(a) {
        r("update:model-value", a);
      }
    });
    return (a, s) => (v(), L(c(ka), {
      modelValue: o.value,
      "onUpdate:modelValue": s[0] || (s[0] = (i) => o.value = i),
      error: a.error,
      "show-required-star": a.showRequiredStar,
      "with-error": a.withError,
      label: a.label,
      foreground: a.foreground,
      borderless: a.borderless,
      "suffix-icon": ml
    }, null, 8, ["modelValue", "error", "show-required-star", "with-error", "label", "foreground", "borderless"]));
  }
}), gl = {}, bl = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  width: "16",
  viewBox: "0 0 16 16"
}, yl = /* @__PURE__ */ g("g", {
  "stroke-width": "1",
  "stroke-linejoin": "round",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round"
}, [
  /* @__PURE__ */ g("line", {
    x1: "8",
    y1: "0.5",
    x2: "8",
    y2: "15.5",
    stroke: "currentColor"
  }),
  /* @__PURE__ */ g("path", { d: "M11.5,3C9.5,1.992,4,1.539,4,5c0,3.525,8,2.005,8,6,0,3.387-5.716,3.2-8,2" })
], -1), wl = [
  yl
];
function Cl(t, n) {
  return v(), w("svg", bl, wl);
}
const $l = /* @__PURE__ */ V(gl, [["render", Cl]]), W3 = /* @__PURE__ */ Y({
  __name: "VCurrencyField",
  props: /* @__PURE__ */ Ke({
    modelValue: {},
    foreground: { type: Boolean },
    prefixIcon: {},
    borderless: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    placeholder: {},
    disabled: { type: Boolean }
  }, {
    foreground: !1,
    ...Ge
  }),
  emits: ["update:model-value"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I({
      get() {
        return e.modelValue;
      },
      set(a) {
        r("update:model-value", a);
      }
    });
    return (a, s) => (v(), L(c(ka), {
      modelValue: o.value,
      "onUpdate:modelValue": s[0] || (s[0] = (i) => o.value = i),
      error: a.error,
      "show-required-star": a.showRequiredStar,
      "with-error": a.withError,
      borderless: a.borderless,
      label: a.label,
      foreground: a.foreground,
      "prefix-icon": $l
    }, null, 8, ["modelValue", "error", "show-required-star", "with-error", "borderless", "label", "foreground"]));
  }
});
var kl = Object.defineProperty, Ml = Object.defineProperties, Dl = Object.getOwnPropertyDescriptors, io = Object.getOwnPropertySymbols, Sl = Object.prototype.hasOwnProperty, Ol = Object.prototype.propertyIsEnumerable, so = (t, n, e) => n in t ? kl(t, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[n] = e, Lt = (t, n) => {
  for (var e in n || (n = {}))
    Sl.call(n, e) && so(t, e, n[e]);
  if (io)
    for (var e of io(n))
      Ol.call(n, e) && so(t, e, n[e]);
  return t;
}, lo = (t, n) => Ml(t, Dl(n));
const Tl = {
  props: {
    autoscroll: {
      type: Boolean,
      default: !0
    }
  },
  watch: {
    typeAheadPointer() {
      this.autoscroll && this.maybeAdjustScroll();
    },
    open(t) {
      this.autoscroll && t && this.$nextTick(() => this.maybeAdjustScroll());
    }
  },
  methods: {
    maybeAdjustScroll() {
      var t;
      const n = ((t = this.$refs.dropdownMenu) == null ? void 0 : t.children[this.typeAheadPointer]) || !1;
      if (n) {
        const e = this.getDropdownViewport(), { top: r, bottom: o, height: a } = n.getBoundingClientRect();
        if (r < e.top)
          return this.$refs.dropdownMenu.scrollTop = n.offsetTop;
        if (o > e.bottom)
          return this.$refs.dropdownMenu.scrollTop = n.offsetTop - (e.height - a);
      }
    },
    getDropdownViewport() {
      return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
        height: 0,
        top: 0,
        bottom: 0
      };
    }
  }
}, Al = {
  data() {
    return {
      typeAheadPointer: -1
    };
  },
  watch: {
    filteredOptions() {
      for (let t = 0; t < this.filteredOptions.length; t++)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    open(t) {
      t && this.typeAheadToLastSelected();
    },
    selectedValue() {
      this.open && this.typeAheadToLastSelected();
    }
  },
  methods: {
    typeAheadUp() {
      for (let t = this.typeAheadPointer - 1; t >= 0; t--)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    typeAheadDown() {
      for (let t = this.typeAheadPointer + 1; t < this.filteredOptions.length; t++)
        if (this.selectable(this.filteredOptions[t])) {
          this.typeAheadPointer = t;
          break;
        }
    },
    typeAheadSelect() {
      const t = this.filteredOptions[this.typeAheadPointer];
      t && this.selectable(t) && this.select(t);
    },
    typeAheadToLastSelected() {
      this.typeAheadPointer = this.selectedValue.length !== 0 ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
    }
  }
}, El = {
  props: {
    loading: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      mutableLoading: !1
    };
  },
  watch: {
    search() {
      this.$emit("search", this.search, this.toggleLoading);
    },
    loading(t) {
      this.mutableLoading = t;
    }
  },
  methods: {
    toggleLoading(t = null) {
      return t == null ? this.mutableLoading = !this.mutableLoading : this.mutableLoading = t;
    }
  }
}, Dr = (t, n) => {
  const e = t.__vccOpts || t;
  for (const [r, o] of n)
    e[r] = o;
  return e;
}, xl = {}, Il = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "10"
}, Ll = /* @__PURE__ */ g("path", { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" }, null, -1), Bl = [
  Ll
];
function Vl(t, n) {
  return v(), w("svg", Il, Bl);
}
const Pl = /* @__PURE__ */ Dr(xl, [["render", Vl]]), jl = {}, Nl = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
}, Fl = /* @__PURE__ */ g("path", { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" }, null, -1), Rl = [
  Fl
];
function Hl(t, n) {
  return v(), w("svg", Nl, Rl);
}
const zl = /* @__PURE__ */ Dr(jl, [["render", Hl]]), uo = {
  Deselect: Pl,
  OpenIndicator: zl
}, Yl = {
  mounted(t, { instance: n }) {
    if (n.appendToBody) {
      const {
        height: e,
        top: r,
        left: o,
        width: a
      } = n.$refs.toggle.getBoundingClientRect();
      let s = window.scrollX || window.pageXOffset, i = window.scrollY || window.pageYOffset;
      t.unbindPosition = n.calculatePosition(t, n, {
        width: a + "px",
        left: s + o + "px",
        top: i + r + e + "px"
      }), document.body.appendChild(t);
    }
  },
  unmounted(t, { instance: n }) {
    n.appendToBody && (t.unbindPosition && typeof t.unbindPosition == "function" && t.unbindPosition(), t.parentNode && t.parentNode.removeChild(t));
  }
};
function Ul(t) {
  const n = {};
  return Object.keys(t).sort().forEach((e) => {
    n[e] = t[e];
  }), JSON.stringify(n);
}
let ql = 0;
function Wl() {
  return ++ql;
}
const Kl = {
  components: Lt({}, uo),
  directives: { appendToBody: Yl },
  mixins: [Tl, Al, El],
  compatConfig: {
    MODE: 3
  },
  emits: [
    "open",
    "close",
    "update:modelValue",
    "search",
    "search:compositionstart",
    "search:compositionend",
    "search:keydown",
    "search:blur",
    "search:focus",
    "search:input",
    "option:created",
    "option:selecting",
    "option:selected",
    "option:deselecting",
    "option:deselected"
  ],
  props: {
    modelValue: {},
    components: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    clearable: {
      type: Boolean,
      default: !0
    },
    deselectFromDropdown: {
      type: Boolean,
      default: !1
    },
    searchable: {
      type: Boolean,
      default: !0
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    transition: {
      type: String,
      default: "vs__fade"
    },
    clearSearchOnSelect: {
      type: Boolean,
      default: !0
    },
    closeOnSelect: {
      type: Boolean,
      default: !0
    },
    label: {
      type: String,
      default: "label"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    reduce: {
      type: Function,
      default: (t) => t
    },
    selectable: {
      type: Function,
      default: (t) => !0
    },
    getOptionLabel: {
      type: Function,
      default(t) {
        return typeof t == "object" ? t.hasOwnProperty(this.label) ? t[this.label] : console.warn(`[vue-select warn]: Label key "option.${this.label}" does not exist in options object ${JSON.stringify(t)}.
https://vue-select.org/api/props.html#getoptionlabel`) : t;
      }
    },
    getOptionKey: {
      type: Function,
      default(t) {
        if (typeof t != "object")
          return t;
        try {
          return t.hasOwnProperty("id") ? t.id : Ul(t);
        } catch (n) {
          return console.warn(`[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.
https://vue-select.org/api/props.html#getoptionkey`, t, n);
        }
      }
    },
    onTab: {
      type: Function,
      default: function() {
        this.selectOnTab && !this.isComposing && this.typeAheadSelect();
      }
    },
    taggable: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    pushTags: {
      type: Boolean,
      default: !1
    },
    filterable: {
      type: Boolean,
      default: !0
    },
    filterBy: {
      type: Function,
      default(t, n, e) {
        return (n || "").toLocaleLowerCase().indexOf(e.toLocaleLowerCase()) > -1;
      }
    },
    filter: {
      type: Function,
      default(t, n) {
        return t.filter((e) => {
          let r = this.getOptionLabel(e);
          return typeof r == "number" && (r = r.toString()), this.filterBy(e, r, n);
        });
      }
    },
    createOption: {
      type: Function,
      default(t) {
        return typeof this.optionList[0] == "object" ? { [this.label]: t } : t;
      }
    },
    resetOnOptionsChange: {
      default: !1,
      validator: (t) => ["function", "boolean"].includes(typeof t)
    },
    clearSearchOnBlur: {
      type: Function,
      default: function({ clearSearchOnSelect: t, multiple: n }) {
        return t && !n;
      }
    },
    noDrop: {
      type: Boolean,
      default: !1
    },
    inputId: {
      type: String
    },
    dir: {
      type: String,
      default: "auto"
    },
    selectOnTab: {
      type: Boolean,
      default: !1
    },
    selectOnKeyCodes: {
      type: Array,
      default: () => [13]
    },
    searchInputQuerySelector: {
      type: String,
      default: "[type=search]"
    },
    mapKeydown: {
      type: Function,
      default: (t, n) => t
    },
    appendToBody: {
      type: Boolean,
      default: !1
    },
    calculatePosition: {
      type: Function,
      default(t, n, { width: e, top: r, left: o }) {
        t.style.top = r, t.style.left = o, t.style.width = e;
      }
    },
    dropdownShouldOpen: {
      type: Function,
      default({ noDrop: t, open: n, mutableLoading: e }) {
        return t ? !1 : n && !e;
      }
    },
    uid: {
      type: [String, Number],
      default: () => Wl()
    }
  },
  data() {
    return {
      search: "",
      open: !1,
      isComposing: !1,
      pushedTags: [],
      _value: [],
      deselectButtons: []
    };
  },
  computed: {
    isReducingValues() {
      return this.$props.reduce !== this.$options.props.reduce.default;
    },
    isTrackingValues() {
      return typeof this.modelValue > "u" || this.isReducingValues;
    },
    selectedValue() {
      let t = this.modelValue;
      return this.isTrackingValues && (t = this.$data._value), t != null && t !== "" ? [].concat(t) : [];
    },
    optionList() {
      return this.options.concat(this.pushTags ? this.pushedTags : []);
    },
    searchEl() {
      return this.$slots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
    },
    scope() {
      const t = {
        search: this.search,
        loading: this.loading,
        searching: this.searching,
        filteredOptions: this.filteredOptions
      };
      return {
        search: {
          attributes: Lt({
            disabled: this.disabled,
            placeholder: this.searchPlaceholder,
            tabindex: this.tabindex,
            readonly: !this.searchable,
            id: this.inputId,
            "aria-autocomplete": "list",
            "aria-labelledby": `vs${this.uid}__combobox`,
            "aria-controls": `vs${this.uid}__listbox`,
            ref: "search",
            type: "search",
            autocomplete: this.autocomplete,
            value: this.search
          }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
            "aria-activedescendant": `vs${this.uid}__option-${this.typeAheadPointer}`
          } : {}),
          events: {
            compositionstart: () => this.isComposing = !0,
            compositionend: () => this.isComposing = !1,
            keydown: this.onSearchKeyDown,
            blur: this.onSearchBlur,
            focus: this.onSearchFocus,
            input: (n) => this.search = n.target.value
          }
        },
        spinner: {
          loading: this.mutableLoading
        },
        noOptions: {
          search: this.search,
          loading: this.mutableLoading,
          searching: this.searching
        },
        openIndicator: {
          attributes: {
            ref: "openIndicator",
            role: "presentation",
            class: "vs__open-indicator"
          }
        },
        listHeader: t,
        listFooter: t,
        header: lo(Lt({}, t), { deselect: this.deselect }),
        footer: lo(Lt({}, t), { deselect: this.deselect })
      };
    },
    childComponents() {
      return Lt(Lt({}, uo), this.components);
    },
    stateClasses() {
      return {
        "vs--open": this.dropdownOpen,
        "vs--single": !this.multiple,
        "vs--multiple": this.multiple,
        "vs--searching": this.searching && !this.noDrop,
        "vs--searchable": this.searchable && !this.noDrop,
        "vs--unsearchable": !this.searchable,
        "vs--loading": this.mutableLoading,
        "vs--disabled": this.disabled
      };
    },
    searching() {
      return !!this.search;
    },
    dropdownOpen() {
      return this.dropdownShouldOpen(this);
    },
    searchPlaceholder() {
      return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
    },
    filteredOptions() {
      const t = [].concat(this.optionList);
      if (!this.filterable && !this.taggable)
        return t;
      const n = this.search.length ? this.filter(t, this.search, this) : t;
      if (this.taggable && this.search.length) {
        const e = this.createOption(this.search);
        this.optionExists(e) || n.unshift(e);
      }
      return n;
    },
    isValueEmpty() {
      return this.selectedValue.length === 0;
    },
    showClearButton() {
      return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
    }
  },
  watch: {
    options(t, n) {
      const e = () => typeof this.resetOnOptionsChange == "function" ? this.resetOnOptionsChange(t, n, this.selectedValue) : this.resetOnOptionsChange;
      !this.taggable && e() && this.clearSelection(), this.modelValue && this.isTrackingValues && this.setInternalValueFromOptions(this.modelValue);
    },
    modelValue: {
      immediate: !0,
      handler(t) {
        this.isTrackingValues && this.setInternalValueFromOptions(t);
      }
    },
    multiple() {
      this.clearSelection();
    },
    open(t) {
      this.$emit(t ? "open" : "close");
    }
  },
  created() {
    this.mutableLoading = this.loading;
  },
  methods: {
    setInternalValueFromOptions(t) {
      Array.isArray(t) ? this.$data._value = t.map((n) => this.findOptionFromReducedValue(n)) : this.$data._value = this.findOptionFromReducedValue(t);
    },
    select(t) {
      this.$emit("option:selecting", t), this.isOptionSelected(t) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(t) : (this.taggable && !this.optionExists(t) && (this.$emit("option:created", t), this.pushTag(t)), this.multiple && (t = this.selectedValue.concat(t)), this.updateValue(t), this.$emit("option:selected", t)), this.onAfterSelect(t);
    },
    deselect(t) {
      this.$emit("option:deselecting", t), this.updateValue(this.selectedValue.filter((n) => !this.optionComparator(n, t))), this.$emit("option:deselected", t);
    },
    clearSelection() {
      this.updateValue(this.multiple ? [] : null);
    },
    onAfterSelect(t) {
      this.closeOnSelect && (this.open = !this.open, this.searchEl.blur()), this.clearSearchOnSelect && (this.search = "");
    },
    updateValue(t) {
      typeof this.modelValue > "u" && (this.$data._value = t), t !== null && (Array.isArray(t) ? t = t.map((n) => this.reduce(n)) : t = this.reduce(t)), this.$emit("update:modelValue", t);
    },
    toggleDropdown(t) {
      const n = t.target !== this.searchEl;
      n && t.preventDefault();
      const e = [
        ...this.deselectButtons || [],
        this.$refs.clearButton
      ];
      if (this.searchEl === void 0 || e.filter(Boolean).some((r) => r.contains(t.target) || r === t.target)) {
        t.preventDefault();
        return;
      }
      this.open && n ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
    },
    isOptionSelected(t) {
      return this.selectedValue.some((n) => this.optionComparator(n, t));
    },
    isOptionDeselectable(t) {
      return this.isOptionSelected(t) && this.deselectFromDropdown;
    },
    optionComparator(t, n) {
      return this.getOptionKey(t) === this.getOptionKey(n);
    },
    findOptionFromReducedValue(t) {
      const n = (r) => JSON.stringify(this.reduce(r)) === JSON.stringify(t), e = [...this.options, ...this.pushedTags].filter(n);
      return e.length === 1 ? e[0] : e.find((r) => this.optionComparator(r, this.$data._value)) || t;
    },
    closeSearchOptions() {
      this.open = !1, this.$emit("search:blur");
    },
    maybeDeleteValue() {
      if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
        let t = null;
        this.multiple && (t = [
          ...this.selectedValue.slice(0, this.selectedValue.length - 1)
        ]), this.updateValue(t);
      }
    },
    optionExists(t) {
      return this.optionList.some((n) => this.optionComparator(n, t));
    },
    normalizeOptionForSlot(t) {
      return typeof t == "object" ? t : { [this.label]: t };
    },
    pushTag(t) {
      this.pushedTags.push(t);
    },
    onEscape() {
      this.search.length ? this.search = "" : this.searchEl.blur();
    },
    onSearchBlur() {
      if (this.mousedown && !this.searching)
        this.mousedown = !1;
      else {
        const { clearSearchOnSelect: t, multiple: n } = this;
        this.clearSearchOnBlur({ clearSearchOnSelect: t, multiple: n }) && (this.search = ""), this.closeSearchOptions();
        return;
      }
      if (this.search.length === 0 && this.options.length === 0) {
        this.closeSearchOptions();
        return;
      }
    },
    onSearchFocus() {
      this.open = !0, this.$emit("search:focus");
    },
    onMousedown() {
      this.mousedown = !0;
    },
    onMouseUp() {
      this.mousedown = !1;
    },
    onSearchKeyDown(t) {
      const n = (o) => (o.preventDefault(), !this.isComposing && this.typeAheadSelect()), e = {
        8: (o) => this.maybeDeleteValue(),
        9: (o) => this.onTab(),
        27: (o) => this.onEscape(),
        38: (o) => (o.preventDefault(), this.typeAheadUp()),
        40: (o) => (o.preventDefault(), this.typeAheadDown())
      };
      this.selectOnKeyCodes.forEach((o) => e[o] = n);
      const r = this.mapKeydown(e, this);
      if (typeof r[t.keyCode] == "function")
        return r[t.keyCode](t);
    }
  }
}, Gl = ["dir"], Zl = ["id", "aria-expanded", "aria-owns"], Jl = {
  ref: "selectedOptions",
  class: "vs__selected-options"
}, Xl = ["disabled", "title", "aria-label", "onClick"], Ql = {
  ref: "actions",
  class: "vs__actions"
}, eu = ["disabled"], tu = { class: "vs__spinner" }, nu = ["id"], ru = ["id", "aria-selected", "onMouseover", "onClick"], ou = {
  key: 0,
  class: "vs__no-options"
}, au = /* @__PURE__ */ Q(" Sorry, no matching options. "), iu = ["id"];
function su(t, n, e, r, o, a) {
  const s = Ii("append-to-body");
  return v(), w("div", {
    dir: e.dir,
    class: m(["v-select", a.stateClasses])
  }, [
    H(t.$slots, "header", Me(Te(a.scope.header))),
    g("div", {
      id: `vs${e.uid}__combobox`,
      ref: "toggle",
      class: "vs__dropdown-toggle",
      role: "combobox",
      "aria-expanded": a.dropdownOpen.toString(),
      "aria-owns": `vs${e.uid}__listbox`,
      "aria-label": "Search for option",
      onMousedown: n[1] || (n[1] = (i) => a.toggleDropdown(i))
    }, [
      g("div", Jl, [
        (v(!0), w(ae, null, ue(a.selectedValue, (i, l) => H(t.$slots, "selected-option-container", {
          option: a.normalizeOptionForSlot(i),
          deselect: a.deselect,
          multiple: e.multiple,
          disabled: e.disabled
        }, () => [
          (v(), w("span", {
            key: e.getOptionKey(i),
            class: "vs__selected"
          }, [
            H(t.$slots, "selected-option", Me(Te(a.normalizeOptionForSlot(i))), () => [
              Q(z(e.getOptionLabel(i)), 1)
            ]),
            e.multiple ? (v(), w("button", {
              key: 0,
              ref_for: !0,
              ref: (d) => o.deselectButtons[l] = d,
              disabled: e.disabled,
              type: "button",
              class: "vs__deselect",
              title: `Deselect ${e.getOptionLabel(i)}`,
              "aria-label": `Deselect ${e.getOptionLabel(i)}`,
              onClick: (d) => a.deselect(i)
            }, [
              (v(), L(We(a.childComponents.Deselect)))
            ], 8, Xl)) : E("", !0)
          ]))
        ])), 256)),
        H(t.$slots, "search", Me(Te(a.scope.search)), () => [
          g("input", De({ class: "vs__search" }, a.scope.search.attributes, aa(a.scope.search.events)), null, 16)
        ])
      ], 512),
      g("div", Ql, [
        it(g("button", {
          ref: "clearButton",
          disabled: e.disabled,
          type: "button",
          class: "vs__clear",
          title: "Clear Selected",
          "aria-label": "Clear Selected",
          onClick: n[0] || (n[0] = (...i) => a.clearSelection && a.clearSelection(...i))
        }, [
          (v(), L(We(a.childComponents.Deselect)))
        ], 8, eu), [
          [sn, a.showClearButton]
        ]),
        H(t.$slots, "open-indicator", Me(Te(a.scope.openIndicator)), () => [
          e.noDrop ? E("", !0) : (v(), L(We(a.childComponents.OpenIndicator), Me(De({ key: 0 }, a.scope.openIndicator.attributes)), null, 16))
        ]),
        H(t.$slots, "spinner", Me(Te(a.scope.spinner)), () => [
          it(g("div", tu, "Loading...", 512), [
            [sn, t.mutableLoading]
          ])
        ])
      ], 512)
    ], 40, Zl),
    j(Li, { name: e.transition }, {
      default: ee(() => [
        a.dropdownOpen ? it((v(), w("ul", {
          id: `vs${e.uid}__listbox`,
          ref: "dropdownMenu",
          key: `vs${e.uid}__listbox`,
          class: "vs__dropdown-menu",
          role: "listbox",
          tabindex: "-1",
          onMousedown: n[2] || (n[2] = Je((...i) => a.onMousedown && a.onMousedown(...i), ["prevent"])),
          onMouseup: n[3] || (n[3] = (...i) => a.onMouseUp && a.onMouseUp(...i))
        }, [
          H(t.$slots, "list-header", Me(Te(a.scope.listHeader))),
          (v(!0), w(ae, null, ue(a.filteredOptions, (i, l) => (v(), w("li", {
            id: `vs${e.uid}__option-${l}`,
            key: e.getOptionKey(i),
            role: "option",
            class: m(["vs__dropdown-option", {
              "vs__dropdown-option--deselect": a.isOptionDeselectable(i) && l === t.typeAheadPointer,
              "vs__dropdown-option--selected": a.isOptionSelected(i),
              "vs__dropdown-option--highlight": l === t.typeAheadPointer,
              "vs__dropdown-option--disabled": !e.selectable(i)
            }]),
            "aria-selected": l === t.typeAheadPointer ? !0 : null,
            onMouseover: (d) => e.selectable(i) ? t.typeAheadPointer = l : null,
            onClick: Je((d) => e.selectable(i) ? a.select(i) : null, ["prevent", "stop"])
          }, [
            H(t.$slots, "option", Me(Te(a.normalizeOptionForSlot(i))), () => [
              Q(z(e.getOptionLabel(i)), 1)
            ])
          ], 42, ru))), 128)),
          a.filteredOptions.length === 0 ? (v(), w("li", ou, [
            H(t.$slots, "no-options", Me(Te(a.scope.noOptions)), () => [
              au
            ])
          ])) : E("", !0),
          H(t.$slots, "list-footer", Me(Te(a.scope.listFooter)))
        ], 40, nu)), [
          [s]
        ]) : (v(), w("ul", {
          key: 1,
          id: `vs${e.uid}__listbox`,
          role: "listbox",
          style: { display: "none", visibility: "hidden" }
        }, null, 8, iu))
      ]),
      _: 3
    }, 8, ["name"]),
    H(t.$slots, "footer", Me(Te(a.scope.footer)))
  ], 10, Gl);
}
const lu = /* @__PURE__ */ Dr(Kl, [["render", su]]);
var Ve = "top", Ue = "bottom", qe = "right", Pe = "left", Sr = "auto", fn = [Ve, Ue, qe, Pe], jt = "start", un = "end", uu = "clippingParents", Ma = "viewport", Qt = "popper", cu = "reference", co = /* @__PURE__ */ fn.reduce(function(t, n) {
  return t.concat([n + "-" + jt, n + "-" + un]);
}, []), Da = /* @__PURE__ */ [].concat(fn, [Sr]).reduce(function(t, n) {
  return t.concat([n, n + "-" + jt, n + "-" + un]);
}, []), du = "beforeRead", fu = "read", pu = "afterRead", vu = "beforeMain", hu = "main", _u = "afterMain", mu = "beforeWrite", gu = "write", bu = "afterWrite", yu = [du, fu, pu, vu, hu, _u, mu, gu, bu];
function Qe(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Re(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var n = t.ownerDocument;
    return n && n.defaultView || window;
  }
  return t;
}
function wt(t) {
  var n = Re(t).Element;
  return t instanceof n || t instanceof Element;
}
function Ye(t) {
  var n = Re(t).HTMLElement;
  return t instanceof n || t instanceof HTMLElement;
}
function Or(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var n = Re(t).ShadowRoot;
  return t instanceof n || t instanceof ShadowRoot;
}
function wu(t) {
  var n = t.state;
  Object.keys(n.elements).forEach(function(e) {
    var r = n.styles[e] || {}, o = n.attributes[e] || {}, a = n.elements[e];
    !Ye(a) || !Qe(a) || (Object.assign(a.style, r), Object.keys(o).forEach(function(s) {
      var i = o[s];
      i === !1 ? a.removeAttribute(s) : a.setAttribute(s, i === !0 ? "" : i);
    }));
  });
}
function Cu(t) {
  var n = t.state, e = {
    popper: {
      position: n.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(n.elements.popper.style, e.popper), n.styles = e, n.elements.arrow && Object.assign(n.elements.arrow.style, e.arrow), function() {
    Object.keys(n.elements).forEach(function(r) {
      var o = n.elements[r], a = n.attributes[r] || {}, s = Object.keys(n.styles.hasOwnProperty(r) ? n.styles[r] : e[r]), i = s.reduce(function(l, d) {
        return l[d] = "", l;
      }, {});
      !Ye(o) || !Qe(o) || (Object.assign(o.style, i), Object.keys(a).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const $u = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: wu,
  effect: Cu,
  requires: ["computeStyles"]
};
function Xe(t) {
  return t.split("-")[0];
}
var bt = Math.max, Ln = Math.min, Nt = Math.round;
function hr() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(n) {
    return n.brand + "/" + n.version;
  }).join(" ") : navigator.userAgent;
}
function Sa() {
  return !/^((?!chrome|android).)*safari/i.test(hr());
}
function Ft(t, n, e) {
  n === void 0 && (n = !1), e === void 0 && (e = !1);
  var r = t.getBoundingClientRect(), o = 1, a = 1;
  n && Ye(t) && (o = t.offsetWidth > 0 && Nt(r.width) / t.offsetWidth || 1, a = t.offsetHeight > 0 && Nt(r.height) / t.offsetHeight || 1);
  var s = wt(t) ? Re(t) : window, i = s.visualViewport, l = !Sa() && e, d = (r.left + (l && i ? i.offsetLeft : 0)) / o, p = (r.top + (l && i ? i.offsetTop : 0)) / a, _ = r.width / o, h = r.height / a;
  return {
    width: _,
    height: h,
    top: p,
    right: d + _,
    bottom: p + h,
    left: d,
    x: d,
    y: p
  };
}
function Tr(t) {
  var n = Ft(t), e = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(n.width - e) <= 1 && (e = n.width), Math.abs(n.height - r) <= 1 && (r = n.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: e,
    height: r
  };
}
function Oa(t, n) {
  var e = n.getRootNode && n.getRootNode();
  if (t.contains(n))
    return !0;
  if (e && Or(e)) {
    var r = n;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function st(t) {
  return Re(t).getComputedStyle(t);
}
function ku(t) {
  return ["table", "td", "th"].indexOf(Qe(t)) >= 0;
}
function ht(t) {
  return ((wt(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function Un(t) {
  return Qe(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (Or(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ht(t)
  );
}
function fo(t) {
  return !Ye(t) || // https://github.com/popperjs/popper-core/issues/837
  st(t).position === "fixed" ? null : t.offsetParent;
}
function Mu(t) {
  var n = /firefox/i.test(hr()), e = /Trident/i.test(hr());
  if (e && Ye(t)) {
    var r = st(t);
    if (r.position === "fixed")
      return null;
  }
  var o = Un(t);
  for (Or(o) && (o = o.host); Ye(o) && ["html", "body"].indexOf(Qe(o)) < 0; ) {
    var a = st(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || n && a.willChange === "filter" || n && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function pn(t) {
  for (var n = Re(t), e = fo(t); e && ku(e) && st(e).position === "static"; )
    e = fo(e);
  return e && (Qe(e) === "html" || Qe(e) === "body" && st(e).position === "static") ? n : e || Mu(t) || n;
}
function Ar(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function rn(t, n, e) {
  return bt(t, Ln(n, e));
}
function Du(t, n, e) {
  var r = rn(t, n, e);
  return r > e ? e : r;
}
function Ta() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Aa(t) {
  return Object.assign({}, Ta(), t);
}
function Ea(t, n) {
  return n.reduce(function(e, r) {
    return e[r] = t, e;
  }, {});
}
var Su = function(n, e) {
  return n = typeof n == "function" ? n(Object.assign({}, e.rects, {
    placement: e.placement
  })) : n, Aa(typeof n != "number" ? n : Ea(n, fn));
};
function Ou(t) {
  var n, e = t.state, r = t.name, o = t.options, a = e.elements.arrow, s = e.modifiersData.popperOffsets, i = Xe(e.placement), l = Ar(i), d = [Pe, qe].indexOf(i) >= 0, p = d ? "height" : "width";
  if (!(!a || !s)) {
    var _ = Su(o.padding, e), h = Tr(a), y = l === "y" ? Ve : Pe, $ = l === "y" ? Ue : qe, k = e.rects.reference[p] + e.rects.reference[l] - s[l] - e.rects.popper[p], M = s[l] - e.rects.reference[l], P = pn(a), D = P ? l === "y" ? P.clientHeight || 0 : P.clientWidth || 0 : 0, U = k / 2 - M / 2, F = _[y], G = D - h[p] - _[$], Z = D / 2 - h[p] / 2 + U, se = rn(F, Z, G), ne = l;
    e.modifiersData[r] = (n = {}, n[ne] = se, n.centerOffset = se - Z, n);
  }
}
function Tu(t) {
  var n = t.state, e = t.options, r = e.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = n.elements.popper.querySelector(o), !o) || Oa(n.elements.popper, o) && (n.elements.arrow = o));
}
const Au = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Ou,
  effect: Tu,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Rt(t) {
  return t.split("-")[1];
}
var Eu = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function xu(t, n) {
  var e = t.x, r = t.y, o = n.devicePixelRatio || 1;
  return {
    x: Nt(e * o) / o || 0,
    y: Nt(r * o) / o || 0
  };
}
function po(t) {
  var n, e = t.popper, r = t.popperRect, o = t.placement, a = t.variation, s = t.offsets, i = t.position, l = t.gpuAcceleration, d = t.adaptive, p = t.roundOffsets, _ = t.isFixed, h = s.x, y = h === void 0 ? 0 : h, $ = s.y, k = $ === void 0 ? 0 : $, M = typeof p == "function" ? p({
    x: y,
    y: k
  }) : {
    x: y,
    y: k
  };
  y = M.x, k = M.y;
  var P = s.hasOwnProperty("x"), D = s.hasOwnProperty("y"), U = Pe, F = Ve, G = window;
  if (d) {
    var Z = pn(e), se = "clientHeight", ne = "clientWidth";
    if (Z === Re(e) && (Z = ht(e), st(Z).position !== "static" && i === "absolute" && (se = "scrollHeight", ne = "scrollWidth")), Z = Z, o === Ve || (o === Pe || o === qe) && a === un) {
      F = Ue;
      var fe = _ && Z === G && G.visualViewport ? G.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        Z[se]
      );
      k -= fe - r.height, k *= l ? 1 : -1;
    }
    if (o === Pe || (o === Ve || o === Ue) && a === un) {
      U = qe;
      var te = _ && Z === G && G.visualViewport ? G.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        Z[ne]
      );
      y -= te - r.width, y *= l ? 1 : -1;
    }
  }
  var J = Object.assign({
    position: i
  }, d && Eu), Ce = p === !0 ? xu({
    x: y,
    y: k
  }, Re(e)) : {
    x: y,
    y: k
  };
  if (y = Ce.x, k = Ce.y, l) {
    var me;
    return Object.assign({}, J, (me = {}, me[F] = D ? "0" : "", me[U] = P ? "0" : "", me.transform = (G.devicePixelRatio || 1) <= 1 ? "translate(" + y + "px, " + k + "px)" : "translate3d(" + y + "px, " + k + "px, 0)", me));
  }
  return Object.assign({}, J, (n = {}, n[F] = D ? k + "px" : "", n[U] = P ? y + "px" : "", n.transform = "", n));
}
function Iu(t) {
  var n = t.state, e = t.options, r = e.gpuAcceleration, o = r === void 0 ? !0 : r, a = e.adaptive, s = a === void 0 ? !0 : a, i = e.roundOffsets, l = i === void 0 ? !0 : i, d = {
    placement: Xe(n.placement),
    variation: Rt(n.placement),
    popper: n.elements.popper,
    popperRect: n.rects.popper,
    gpuAcceleration: o,
    isFixed: n.options.strategy === "fixed"
  };
  n.modifiersData.popperOffsets != null && (n.styles.popper = Object.assign({}, n.styles.popper, po(Object.assign({}, d, {
    offsets: n.modifiersData.popperOffsets,
    position: n.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), n.modifiersData.arrow != null && (n.styles.arrow = Object.assign({}, n.styles.arrow, po(Object.assign({}, d, {
    offsets: n.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-placement": n.placement
  });
}
const Lu = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Iu,
  data: {}
};
var Mn = {
  passive: !0
};
function Bu(t) {
  var n = t.state, e = t.instance, r = t.options, o = r.scroll, a = o === void 0 ? !0 : o, s = r.resize, i = s === void 0 ? !0 : s, l = Re(n.elements.popper), d = [].concat(n.scrollParents.reference, n.scrollParents.popper);
  return a && d.forEach(function(p) {
    p.addEventListener("scroll", e.update, Mn);
  }), i && l.addEventListener("resize", e.update, Mn), function() {
    a && d.forEach(function(p) {
      p.removeEventListener("scroll", e.update, Mn);
    }), i && l.removeEventListener("resize", e.update, Mn);
  };
}
const Vu = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Bu,
  data: {}
};
var Pu = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function On(t) {
  return t.replace(/left|right|bottom|top/g, function(n) {
    return Pu[n];
  });
}
var ju = {
  start: "end",
  end: "start"
};
function vo(t) {
  return t.replace(/start|end/g, function(n) {
    return ju[n];
  });
}
function Er(t) {
  var n = Re(t), e = n.pageXOffset, r = n.pageYOffset;
  return {
    scrollLeft: e,
    scrollTop: r
  };
}
function xr(t) {
  return Ft(ht(t)).left + Er(t).scrollLeft;
}
function Nu(t, n) {
  var e = Re(t), r = ht(t), o = e.visualViewport, a = r.clientWidth, s = r.clientHeight, i = 0, l = 0;
  if (o) {
    a = o.width, s = o.height;
    var d = Sa();
    (d || !d && n === "fixed") && (i = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: i + xr(t),
    y: l
  };
}
function Fu(t) {
  var n, e = ht(t), r = Er(t), o = (n = t.ownerDocument) == null ? void 0 : n.body, a = bt(e.scrollWidth, e.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), s = bt(e.scrollHeight, e.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), i = -r.scrollLeft + xr(t), l = -r.scrollTop;
  return st(o || e).direction === "rtl" && (i += bt(e.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: s,
    x: i,
    y: l
  };
}
function Ir(t) {
  var n = st(t), e = n.overflow, r = n.overflowX, o = n.overflowY;
  return /auto|scroll|overlay|hidden/.test(e + o + r);
}
function xa(t) {
  return ["html", "body", "#document"].indexOf(Qe(t)) >= 0 ? t.ownerDocument.body : Ye(t) && Ir(t) ? t : xa(Un(t));
}
function on(t, n) {
  var e;
  n === void 0 && (n = []);
  var r = xa(t), o = r === ((e = t.ownerDocument) == null ? void 0 : e.body), a = Re(r), s = o ? [a].concat(a.visualViewport || [], Ir(r) ? r : []) : r, i = n.concat(s);
  return o ? i : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    i.concat(on(Un(s)))
  );
}
function _r(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function Ru(t, n) {
  var e = Ft(t, !1, n === "fixed");
  return e.top = e.top + t.clientTop, e.left = e.left + t.clientLeft, e.bottom = e.top + t.clientHeight, e.right = e.left + t.clientWidth, e.width = t.clientWidth, e.height = t.clientHeight, e.x = e.left, e.y = e.top, e;
}
function ho(t, n, e) {
  return n === Ma ? _r(Nu(t, e)) : wt(n) ? Ru(n, e) : _r(Fu(ht(t)));
}
function Hu(t) {
  var n = on(Un(t)), e = ["absolute", "fixed"].indexOf(st(t).position) >= 0, r = e && Ye(t) ? pn(t) : t;
  return wt(r) ? n.filter(function(o) {
    return wt(o) && Oa(o, r) && Qe(o) !== "body";
  }) : [];
}
function zu(t, n, e, r) {
  var o = n === "clippingParents" ? Hu(t) : [].concat(n), a = [].concat(o, [e]), s = a[0], i = a.reduce(function(l, d) {
    var p = ho(t, d, r);
    return l.top = bt(p.top, l.top), l.right = Ln(p.right, l.right), l.bottom = Ln(p.bottom, l.bottom), l.left = bt(p.left, l.left), l;
  }, ho(t, s, r));
  return i.width = i.right - i.left, i.height = i.bottom - i.top, i.x = i.left, i.y = i.top, i;
}
function Ia(t) {
  var n = t.reference, e = t.element, r = t.placement, o = r ? Xe(r) : null, a = r ? Rt(r) : null, s = n.x + n.width / 2 - e.width / 2, i = n.y + n.height / 2 - e.height / 2, l;
  switch (o) {
    case Ve:
      l = {
        x: s,
        y: n.y - e.height
      };
      break;
    case Ue:
      l = {
        x: s,
        y: n.y + n.height
      };
      break;
    case qe:
      l = {
        x: n.x + n.width,
        y: i
      };
      break;
    case Pe:
      l = {
        x: n.x - e.width,
        y: i
      };
      break;
    default:
      l = {
        x: n.x,
        y: n.y
      };
  }
  var d = o ? Ar(o) : null;
  if (d != null) {
    var p = d === "y" ? "height" : "width";
    switch (a) {
      case jt:
        l[d] = l[d] - (n[p] / 2 - e[p] / 2);
        break;
      case un:
        l[d] = l[d] + (n[p] / 2 - e[p] / 2);
        break;
    }
  }
  return l;
}
function cn(t, n) {
  n === void 0 && (n = {});
  var e = n, r = e.placement, o = r === void 0 ? t.placement : r, a = e.strategy, s = a === void 0 ? t.strategy : a, i = e.boundary, l = i === void 0 ? uu : i, d = e.rootBoundary, p = d === void 0 ? Ma : d, _ = e.elementContext, h = _ === void 0 ? Qt : _, y = e.altBoundary, $ = y === void 0 ? !1 : y, k = e.padding, M = k === void 0 ? 0 : k, P = Aa(typeof M != "number" ? M : Ea(M, fn)), D = h === Qt ? cu : Qt, U = t.rects.popper, F = t.elements[$ ? D : h], G = zu(wt(F) ? F : F.contextElement || ht(t.elements.popper), l, p, s), Z = Ft(t.elements.reference), se = Ia({
    reference: Z,
    element: U,
    strategy: "absolute",
    placement: o
  }), ne = _r(Object.assign({}, U, se)), fe = h === Qt ? ne : Z, te = {
    top: G.top - fe.top + P.top,
    bottom: fe.bottom - G.bottom + P.bottom,
    left: G.left - fe.left + P.left,
    right: fe.right - G.right + P.right
  }, J = t.modifiersData.offset;
  if (h === Qt && J) {
    var Ce = J[o];
    Object.keys(te).forEach(function(me) {
      var q = [qe, Ue].indexOf(me) >= 0 ? 1 : -1, T = [Ve, Ue].indexOf(me) >= 0 ? "y" : "x";
      te[me] += Ce[T] * q;
    });
  }
  return te;
}
function Yu(t, n) {
  n === void 0 && (n = {});
  var e = n, r = e.placement, o = e.boundary, a = e.rootBoundary, s = e.padding, i = e.flipVariations, l = e.allowedAutoPlacements, d = l === void 0 ? Da : l, p = Rt(r), _ = p ? i ? co : co.filter(function($) {
    return Rt($) === p;
  }) : fn, h = _.filter(function($) {
    return d.indexOf($) >= 0;
  });
  h.length === 0 && (h = _);
  var y = h.reduce(function($, k) {
    return $[k] = cn(t, {
      placement: k,
      boundary: o,
      rootBoundary: a,
      padding: s
    })[Xe(k)], $;
  }, {});
  return Object.keys(y).sort(function($, k) {
    return y[$] - y[k];
  });
}
function Uu(t) {
  if (Xe(t) === Sr)
    return [];
  var n = On(t);
  return [vo(t), n, vo(n)];
}
function qu(t) {
  var n = t.state, e = t.options, r = t.name;
  if (!n.modifiersData[r]._skip) {
    for (var o = e.mainAxis, a = o === void 0 ? !0 : o, s = e.altAxis, i = s === void 0 ? !0 : s, l = e.fallbackPlacements, d = e.padding, p = e.boundary, _ = e.rootBoundary, h = e.altBoundary, y = e.flipVariations, $ = y === void 0 ? !0 : y, k = e.allowedAutoPlacements, M = n.options.placement, P = Xe(M), D = P === M, U = l || (D || !$ ? [On(M)] : Uu(M)), F = [M].concat(U).reduce(function(be, pe) {
      return be.concat(Xe(pe) === Sr ? Yu(n, {
        placement: pe,
        boundary: p,
        rootBoundary: _,
        padding: d,
        flipVariations: $,
        allowedAutoPlacements: k
      }) : pe);
    }, []), G = n.rects.reference, Z = n.rects.popper, se = /* @__PURE__ */ new Map(), ne = !0, fe = F[0], te = 0; te < F.length; te++) {
      var J = F[te], Ce = Xe(J), me = Rt(J) === jt, q = [Ve, Ue].indexOf(Ce) >= 0, T = q ? "width" : "height", S = cn(n, {
        placement: J,
        boundary: p,
        rootBoundary: _,
        altBoundary: h,
        padding: d
      }), B = q ? me ? qe : Pe : me ? Ue : Ve;
      G[T] > Z[T] && (B = On(B));
      var A = On(B), W = [];
      if (a && W.push(S[Ce] <= 0), i && W.push(S[B] <= 0, S[A] <= 0), W.every(function(be) {
        return be;
      })) {
        fe = J, ne = !1;
        break;
      }
      se.set(J, W);
    }
    if (ne)
      for (var K = $ ? 3 : 1, le = function(pe) {
        var Ae = F.find(function(Oe) {
          var $e = se.get(Oe);
          if ($e)
            return $e.slice(0, pe).every(function(Ee) {
              return Ee;
            });
        });
        if (Ae)
          return fe = Ae, "break";
      }, de = K; de > 0; de--) {
        var ge = le(de);
        if (ge === "break")
          break;
      }
    n.placement !== fe && (n.modifiersData[r]._skip = !0, n.placement = fe, n.reset = !0);
  }
}
const Wu = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: qu,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function _o(t, n, e) {
  return e === void 0 && (e = {
    x: 0,
    y: 0
  }), {
    top: t.top - n.height - e.y,
    right: t.right - n.width + e.x,
    bottom: t.bottom - n.height + e.y,
    left: t.left - n.width - e.x
  };
}
function mo(t) {
  return [Ve, qe, Ue, Pe].some(function(n) {
    return t[n] >= 0;
  });
}
function Ku(t) {
  var n = t.state, e = t.name, r = n.rects.reference, o = n.rects.popper, a = n.modifiersData.preventOverflow, s = cn(n, {
    elementContext: "reference"
  }), i = cn(n, {
    altBoundary: !0
  }), l = _o(s, r), d = _o(i, o, a), p = mo(l), _ = mo(d);
  n.modifiersData[e] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: d,
    isReferenceHidden: p,
    hasPopperEscaped: _
  }, n.attributes.popper = Object.assign({}, n.attributes.popper, {
    "data-popper-reference-hidden": p,
    "data-popper-escaped": _
  });
}
const Gu = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Ku
};
function Zu(t, n, e) {
  var r = Xe(t), o = [Pe, Ve].indexOf(r) >= 0 ? -1 : 1, a = typeof e == "function" ? e(Object.assign({}, n, {
    placement: t
  })) : e, s = a[0], i = a[1];
  return s = s || 0, i = (i || 0) * o, [Pe, qe].indexOf(r) >= 0 ? {
    x: i,
    y: s
  } : {
    x: s,
    y: i
  };
}
function Ju(t) {
  var n = t.state, e = t.options, r = t.name, o = e.offset, a = o === void 0 ? [0, 0] : o, s = Da.reduce(function(p, _) {
    return p[_] = Zu(_, n.rects, a), p;
  }, {}), i = s[n.placement], l = i.x, d = i.y;
  n.modifiersData.popperOffsets != null && (n.modifiersData.popperOffsets.x += l, n.modifiersData.popperOffsets.y += d), n.modifiersData[r] = s;
}
const Xu = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Ju
};
function Qu(t) {
  var n = t.state, e = t.name;
  n.modifiersData[e] = Ia({
    reference: n.rects.reference,
    element: n.rects.popper,
    strategy: "absolute",
    placement: n.placement
  });
}
const ec = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Qu,
  data: {}
};
function tc(t) {
  return t === "x" ? "y" : "x";
}
function nc(t) {
  var n = t.state, e = t.options, r = t.name, o = e.mainAxis, a = o === void 0 ? !0 : o, s = e.altAxis, i = s === void 0 ? !1 : s, l = e.boundary, d = e.rootBoundary, p = e.altBoundary, _ = e.padding, h = e.tether, y = h === void 0 ? !0 : h, $ = e.tetherOffset, k = $ === void 0 ? 0 : $, M = cn(n, {
    boundary: l,
    rootBoundary: d,
    padding: _,
    altBoundary: p
  }), P = Xe(n.placement), D = Rt(n.placement), U = !D, F = Ar(P), G = tc(F), Z = n.modifiersData.popperOffsets, se = n.rects.reference, ne = n.rects.popper, fe = typeof k == "function" ? k(Object.assign({}, n.rects, {
    placement: n.placement
  })) : k, te = typeof fe == "number" ? {
    mainAxis: fe,
    altAxis: fe
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, fe), J = n.modifiersData.offset ? n.modifiersData.offset[n.placement] : null, Ce = {
    x: 0,
    y: 0
  };
  if (Z) {
    if (a) {
      var me, q = F === "y" ? Ve : Pe, T = F === "y" ? Ue : qe, S = F === "y" ? "height" : "width", B = Z[F], A = B + M[q], W = B - M[T], K = y ? -ne[S] / 2 : 0, le = D === jt ? se[S] : ne[S], de = D === jt ? -ne[S] : -se[S], ge = n.elements.arrow, be = y && ge ? Tr(ge) : {
        width: 0,
        height: 0
      }, pe = n.modifiersData["arrow#persistent"] ? n.modifiersData["arrow#persistent"].padding : Ta(), Ae = pe[q], Oe = pe[T], $e = rn(0, se[S], be[S]), Ee = U ? se[S] / 2 - K - $e - Ae - te.mainAxis : le - $e - Ae - te.mainAxis, Se = U ? -se[S] / 2 + K + $e + Oe + te.mainAxis : de + $e + Oe + te.mainAxis, Ie = n.elements.arrow && pn(n.elements.arrow), He = Ie ? F === "y" ? Ie.clientTop || 0 : Ie.clientLeft || 0 : 0, nt = (me = J == null ? void 0 : J[F]) != null ? me : 0, Xn = B + Ee - nt - He, mn = B + Se - nt, gn = rn(y ? Ln(A, Xn) : A, B, y ? bt(W, mn) : W);
      Z[F] = gn, Ce[F] = gn - B;
    }
    if (i) {
      var Gt, bn = F === "x" ? Ve : Pe, Tt = F === "x" ? Ue : qe, rt = Z[G], At = G === "y" ? "height" : "width", Zt = rt + M[bn], Et = rt - M[Tt], xt = [Ve, Pe].indexOf(P) !== -1, _t = (Gt = J == null ? void 0 : J[G]) != null ? Gt : 0, yn = xt ? Zt : rt - se[At] - ne[At] - _t + te.altAxis, Jt = xt ? rt + se[At] + ne[At] - _t - te.altAxis : Et, wn = y && xt ? Du(yn, rt, Jt) : rn(y ? yn : Zt, rt, y ? Jt : Et);
      Z[G] = wn, Ce[G] = wn - rt;
    }
    n.modifiersData[r] = Ce;
  }
}
const kt = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: nc,
  requiresIfExists: ["offset"]
};
function rc(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function oc(t) {
  return t === Re(t) || !Ye(t) ? Er(t) : rc(t);
}
function ac(t) {
  var n = t.getBoundingClientRect(), e = Nt(n.width) / t.offsetWidth || 1, r = Nt(n.height) / t.offsetHeight || 1;
  return e !== 1 || r !== 1;
}
function ic(t, n, e) {
  e === void 0 && (e = !1);
  var r = Ye(n), o = Ye(n) && ac(n), a = ht(n), s = Ft(t, o, e), i = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !e) && ((Qe(n) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ir(a)) && (i = oc(n)), Ye(n) ? (l = Ft(n, !0), l.x += n.clientLeft, l.y += n.clientTop) : a && (l.x = xr(a))), {
    x: s.left + i.scrollLeft - l.x,
    y: s.top + i.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function sc(t) {
  var n = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(a) {
    n.set(a.name, a);
  });
  function o(a) {
    e.add(a.name);
    var s = [].concat(a.requires || [], a.requiresIfExists || []);
    s.forEach(function(i) {
      if (!e.has(i)) {
        var l = n.get(i);
        l && o(l);
      }
    }), r.push(a);
  }
  return t.forEach(function(a) {
    e.has(a.name) || o(a);
  }), r;
}
function lc(t) {
  var n = sc(t);
  return yu.reduce(function(e, r) {
    return e.concat(n.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function uc(t) {
  var n;
  return function() {
    return n || (n = new Promise(function(e) {
      Promise.resolve().then(function() {
        n = void 0, e(t());
      });
    })), n;
  };
}
function cc(t) {
  var n = t.reduce(function(e, r) {
    var o = e[r.name];
    return e[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, e;
  }, {});
  return Object.keys(n).map(function(e) {
    return n[e];
  });
}
var go = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function bo() {
  for (var t = arguments.length, n = new Array(t), e = 0; e < t; e++)
    n[e] = arguments[e];
  return !n.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function dc(t) {
  t === void 0 && (t = {});
  var n = t, e = n.defaultModifiers, r = e === void 0 ? [] : e, o = n.defaultOptions, a = o === void 0 ? go : o;
  return function(i, l, d) {
    d === void 0 && (d = a);
    var p = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, go, a),
      modifiersData: {},
      elements: {
        reference: i,
        popper: l
      },
      attributes: {},
      styles: {}
    }, _ = [], h = !1, y = {
      state: p,
      setOptions: function(P) {
        var D = typeof P == "function" ? P(p.options) : P;
        k(), p.options = Object.assign({}, a, p.options, D), p.scrollParents = {
          reference: wt(i) ? on(i) : i.contextElement ? on(i.contextElement) : [],
          popper: on(l)
        };
        var U = lc(cc([].concat(r, p.options.modifiers)));
        return p.orderedModifiers = U.filter(function(F) {
          return F.enabled;
        }), $(), y.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var P = p.elements, D = P.reference, U = P.popper;
          if (bo(D, U)) {
            p.rects = {
              reference: ic(D, pn(U), p.options.strategy === "fixed"),
              popper: Tr(U)
            }, p.reset = !1, p.placement = p.options.placement, p.orderedModifiers.forEach(function(te) {
              return p.modifiersData[te.name] = Object.assign({}, te.data);
            });
            for (var F = 0; F < p.orderedModifiers.length; F++) {
              if (p.reset === !0) {
                p.reset = !1, F = -1;
                continue;
              }
              var G = p.orderedModifiers[F], Z = G.fn, se = G.options, ne = se === void 0 ? {} : se, fe = G.name;
              typeof Z == "function" && (p = Z({
                state: p,
                options: ne,
                name: fe,
                instance: y
              }) || p);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: uc(function() {
        return new Promise(function(M) {
          y.forceUpdate(), M(p);
        });
      }),
      destroy: function() {
        k(), h = !0;
      }
    };
    if (!bo(i, l))
      return y;
    y.setOptions(d).then(function(M) {
      !h && d.onFirstUpdate && d.onFirstUpdate(M);
    });
    function $() {
      p.orderedModifiers.forEach(function(M) {
        var P = M.name, D = M.options, U = D === void 0 ? {} : D, F = M.effect;
        if (typeof F == "function") {
          var G = F({
            state: p,
            name: P,
            instance: y,
            options: U
          }), Z = function() {
          };
          _.push(G || Z);
        }
      });
    }
    function k() {
      _.forEach(function(M) {
        return M();
      }), _ = [];
    }
    return y;
  };
}
var fc = [Vu, ec, Lu, $u, Xu, Wu, kt, Au, Gu], Mt = /* @__PURE__ */ dc({
  defaultModifiers: fc
});
const pc = {}, vc = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 17",
  fill: "none"
}, hc = /* @__PURE__ */ g("path", {
  d: "M8 11.3V8.5M8 5.7H8.007M15 8.5C15 4.63401 11.866 1.5 8 1.5C4.13401 1.5 1 4.63401 1 8.5C1 12.366 4.13401 15.5 8 15.5C11.866 15.5 15 12.366 15 8.5Z",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _c = [
  hc
];
function mc(t, n) {
  return v(), w("svg", vc, _c);
}
const gc = /* @__PURE__ */ V(pc, [["render", mc]]), bc = /* @__PURE__ */ Y({
  __name: "VTooltip",
  props: {
    content: { default: "" },
    placement: { default: "bottom" },
    tooltipClass: { default: "" },
    size: { default: "md" }
  },
  setup(t) {
    const n = he(), e = t, r = ie(null), o = ie(), a = ie(), s = I(() => [
      n["v-tooltip__tooltip"],
      n[`v-tooltip__tooltip--${e.size}`],
      e.tooltipClass
    ].filter(Boolean)), i = ie(!1), l = I(() => ({
      ontouchstart: d,
      ontouchend: p,
      onmouseenter: d,
      onmouseleave: p,
      onclick: d
    })), d = () => {
      i.value = !0;
    }, p = () => {
      i.value = !1;
    }, _ = () => {
      r.value && (r.value.destroy(), r.value = null);
    };
    return Ct(() => i.value, async (h) => {
      await pt(), h && o.value && a.value ? (r.value = Mt(o.value, a.value, {
        placement: e.placement,
        modifiers: [
          kt,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }), document.body.appendChild(a.value)) : !h && r.value && a.value && (_(), document.body.removeChild(a.value));
    }), $t(() => {
      _();
    }), (h, y) => (v(), w("div", De({
      ref_key: "trigger",
      ref: o,
      class: c(n)["v-tooltip"]
    }, l.value), [
      H(h.$slots, "default", {}, () => [
        j(gc)
      ]),
      i.value ? (v(), w("div", {
        key: 0,
        ref_key: "tooltip",
        ref: a,
        class: m(s.value)
      }, z(h.content), 3)) : E("", !0)
    ], 16));
  }
}), yc = {
  "v-tooltip": "_v-tooltip_1z87u_1",
  "v-tooltip__tooltip": "_v-tooltip__tooltip_1z87u_9",
  "v-tooltip__tooltip--md": "_v-tooltip__tooltip--md_1z87u_29",
  "v-tooltip__tooltip--sm": "_v-tooltip__tooltip--sm_1z87u_33"
}, wc = {
  $style: yc
}, ft = /* @__PURE__ */ V(bc, [["__cssModules", wc]]), Cc = /* @__PURE__ */ Y({
  __name: "VSelect",
  props: /* @__PURE__ */ Ke({
    disabled: { type: Boolean },
    modelValue: { type: [Array, String, Boolean, Number, Object, null] },
    multiple: { type: Boolean },
    clearable: { type: Boolean },
    searchable: { type: Boolean },
    closeOnSelect: { type: Boolean },
    loading: { type: Boolean },
    prefixIcon: {},
    optionLabel: {},
    options: {},
    reduce: { type: Function },
    emptyValue: { type: Boolean },
    placeholder: {},
    filterable: { type: Boolean },
    foreground: { type: Boolean },
    borderless: { type: Boolean },
    appendToBody: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {}
  }, {
    modelValue: "",
    multiple: !1,
    clearable: !1,
    searchable: !1,
    prefixIcon: null,
    closeOnSelect: !0,
    optionLabel: "label",
    loading: !1,
    emptyValue: !0,
    filterable: !1,
    foreground: !1,
    borderless: !0,
    appendToBody: !0,
    reduce: (t) => typeof t == "string" ? t : t.value,
    ...Ge
  }),
  emits: ["update:model-value", "search"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I({
      get() {
        return e.modelValue;
      },
      set(p) {
        r("update:model-value", p);
      }
    }), a = I(() => !!e.prefixIcon), s = he(), i = (p, _, { width: h }) => {
      p.style.width = h, p.classList.add(s["v-select__list"]);
      const y = Mt(_.$refs.toggle, p, {
        placement: "bottom",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1]
            }
          },
          {
            name: "toggleClass",
            enabled: !0,
            phase: "write",
            fn({ state: $ }) {
              _.$el.classList.toggle(
                "drop-up",
                $.placement === "top"
              );
            }
          }
        ]
      });
      return () => y.destroy();
    }, l = I(() => {
      const p = e.options ? e.options.map((_) => _ || "") : [];
      return e.emptyValue ? p : p.filter((_) => _);
    }), d = ie(!1);
    return (p, _) => (v(), L(c(zn), {
      class: m(c(s)["v-select"]),
      error: p.error,
      label: p.label,
      "show-required-star": p.showRequiredStar,
      "with-error": p.withError
    }, {
      default: ee(() => [
        g("div", {
          class: m([
            c(s)["v-select__field-wrapper"],
            {
              [c(s)["v-select__field--foreground"]]: p.foreground
            }
          ])
        }, [
          a.value ? (v(), w("div", {
            key: 0,
            class: m([c(s)["v-select__icon"], c(s)["v-select__icon--prefix"]])
          }, [
            (v(), L(We(p.prefixIcon)))
          ], 2)) : E("", !0),
          j(c(lu), {
            modelValue: o.value,
            "onUpdate:modelValue": _[0] || (_[0] = (h) => o.value = h),
            class: m([
              c(s)["v-select__field"],
              {
                [c(s)["v-select__field--foreground"]]: p.foreground,
                [c(s)["v-select__field--open"]]: d.value,
                [c(s)["v-select__field--with-prefix-icon"]]: a.value
              }
            ]),
            reduce: p.reduce,
            clearable: p.clearable,
            disabled: p.disabled,
            multiple: p.multiple,
            label: p.optionLabel,
            searchable: p.searchable,
            "close-on-select": p.closeOnSelect,
            filterable: p.filterable,
            placeholder: p.placeholder,
            options: l.value,
            value: p.modelValue,
            loading: p.loading,
            "calculate-position": i,
            "append-to-body": p.appendToBody,
            onOpen: _[1] || (_[1] = (h) => d.value = !0),
            onClose: _[2] || (_[2] = (h) => d.value = !1),
            onSearch: _[3] || (_[3] = (h) => r("search", h))
          }, {
            "selected-option": ee((h) => [
              H(p.$slots, "selected-option", Me(Te(typeof h == "string" ? {} : h)), () => [
                typeof h == "string" ? (v(), w(ae, { key: 0 }, [
                  Q(z(h), 1)
                ], 64)) : (v(), w("div", {
                  key: 1,
                  class: m(c(s)["v-select__option"])
                }, [
                  Q(z(h.label) + " ", 1),
                  h.helpText ? (v(), L(c(ft), {
                    key: 0,
                    class: m(c(s)["v-select__option-tooltip"]),
                    content: h.helpText
                  }, null, 8, ["class", "content"])) : E("", !0)
                ], 2))
              ])
            ]),
            option: ee((h) => [
              H(p.$slots, "option", Me(Te(typeof h == "string" ? {} : h)), () => [
                typeof h == "string" ? (v(), w(ae, { key: 0 }, [
                  Q(z(h), 1)
                ], 64)) : (v(), w("div", {
                  key: 1,
                  class: m(c(s)["v-select__option"])
                }, [
                  Q(z(h.label) + " ", 1),
                  h != null && h.helpText ? (v(), L(c(ft), {
                    key: 0,
                    class: m(c(s)["v-select__option-tooltip"]),
                    content: h.helpText
                  }, null, 8, ["class", "content"])) : E("", !0)
                ], 2))
              ])
            ]),
            "open-indicator": ee(() => [
              j(vt, {
                class: m([
                  c(s)["v-select__toggle"],
                  {
                    [c(s)["v-select__toggle--open"]]: d.value
                  }
                ])
              }, null, 8, ["class"])
            ]),
            _: 3
          }, 8, ["modelValue", "class", "reduce", "clearable", "disabled", "multiple", "label", "searchable", "close-on-select", "filterable", "placeholder", "options", "value", "loading", "append-to-body"])
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "error", "label", "show-required-star", "with-error"]));
  }
});
const $c = "_vs__deselect_nxxoy_36", kc = {
  "v-select": "_v-select_nxxoy_1",
  "v-select__field": "_v-select__field_nxxoy_5",
  vs__deselect: $c,
  "vs--open": "_vs--open_nxxoy_10",
  "v-select__field--foreground": "_v-select__field--foreground_nxxoy_79",
  "v-select__list": "_v-select__list_nxxoy_83",
  "v-select__field--open": "_v-select__field--open_nxxoy_134",
  "v-select__toggle": "_v-select__toggle_nxxoy_138",
  "v-select__toggle--open": "_v-select__toggle--open_nxxoy_150",
  "v-select__field-wrapper": "_v-select__field-wrapper_nxxoy_154",
  "v-select__option": "_v-select__option_nxxoy_158",
  "v-select__option-tooltip": "_v-select__option-tooltip_nxxoy_170",
  "v-select__field--with-prefix-icon": "_v-select__field--with-prefix-icon_nxxoy_174",
  "v-select__icon": "_v-select__icon_nxxoy_191"
}, Mc = {
  $style: kc
}, Lr = /* @__PURE__ */ V(Cc, [["__cssModules", Mc]]), Dc = ["src"], Sc = /* @__PURE__ */ Y({
  __name: "VAvatar",
  props: {
    size: { default: ut.MEDIUM },
    imageUrl: { default: "" },
    firstName: { default: "" },
    lastName: { default: "" },
    isLight: { type: Boolean, default: !1 },
    outline: { type: Boolean, default: !1 }
  },
  setup(t) {
    const n = t, e = I(() => !!n.imageUrl && !r.value), r = ie(!1), o = I(() => `${(n.firstName || "").charAt(0)}${(n.lastName || "").charAt(0)}`.toUpperCase());
    return (a, s) => (v(), w("div", {
      class: m([
        a.$style["v-avatar"],
        a.$style[`v-avatar--${a.size}`],
        {
          [a.$style["v-avatar--light"]]: a.isLight,
          [a.$style["v-avatar--outline"]]: a.outline
        }
      ])
    }, [
      e.value ? (v(), w("img", {
        key: 0,
        class: m(a.$style["v-avatar__image"]),
        src: a.imageUrl || "",
        alt: "avatar",
        onError: s[0] || (s[0] = (i) => r.value = !0)
      }, null, 42, Dc)) : (v(), w(ae, { key: 1 }, [
        Q(z(o.value), 1)
      ], 64))
    ], 2));
  }
}), Oc = {
  "v-avatar": "_v-avatar_1kith_1",
  "v-avatar--light": "_v-avatar--light_1kith_14",
  "v-avatar--outline": "_v-avatar--outline_1kith_18",
  "v-avatar--extra-small": "_v-avatar--extra-small_1kith_22",
  "v-avatar--small": "_v-avatar--small_1kith_28",
  "v-avatar--medium-small": "_v-avatar--medium-small_1kith_34",
  "v-avatar--medium": "_v-avatar--medium_1kith_34",
  "v-avatar--large": "_v-avatar--large_1kith_46",
  "v-avatar__image": "_v-avatar__image_1kith_52"
}, Tc = {
  $style: Oc
}, yt = /* @__PURE__ */ V(Sc, [["__cssModules", Tc]]), Bn = (t, n = " ") => t.filter(Boolean).join(n), Ac = {}, Ec = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  width: "16",
  viewBox: "0 0 16 16"
}, xc = /* @__PURE__ */ g("g", {
  "stroke-width": "1",
  "stroke-linejoin": "round",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round"
}, [
  /* @__PURE__ */ g("path", {
    d: "M2.562,10A4,4,0,0,0,.5,13.5v2h15v-2A4,4,0,0,0,13.438,10",
    "data-cap": "butt",
    stroke: "currentColor"
  }),
  /* @__PURE__ */ g("rect", {
    x: "4.5",
    y: "0.5",
    width: "7",
    height: "9",
    rx: "3.5",
    ry: "3.5",
    "data-cap": "butt"
  })
], -1), Ic = [
  xc
];
function Lc(t, n) {
  return v(), w("svg", Ec, Ic);
}
const Bc = /* @__PURE__ */ V(Ac, [["render", Lc]]), Vc = /* @__PURE__ */ Y({
  __name: "VUserField",
  props: /* @__PURE__ */ Ke({
    options: {},
    modelValue: {},
    foreground: { type: Boolean },
    loading: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    borderless: { type: Boolean },
    placeholder: {},
    disabled: { type: Boolean }
  }, {
    modelValue: null,
    foreground: !1,
    loading: !1,
    ...Ge
  }),
  emits: ["update:modelValue", "search"],
  setup(t, { emit: n }) {
    const e = Lr, r = ia(Bc), o = t, a = n, s = he();
    return (i, l) => (v(), w("div", {
      class: m(c(s)["v-user-field"])
    }, [
      j(c(e), De(o, {
        "model-value": i.modelValue,
        options: i.options,
        searchable: "",
        foreground: i.foreground,
        borderless: i.borderless,
        "prefix-icon": c(r),
        "onUpdate:modelValue": l[0] || (l[0] = (d) => a("update:modelValue", d)),
        onSearch: l[1] || (l[1] = (d) => a("search", d))
      }), {
        "selected-option": ee((d) => {
          var p, _;
          return [
            g("div", {
              class: m(c(s)["v-user-field__option"])
            }, [
              j(c(yt), {
                size: c(ut).EXTRA_SMALL,
                "last-name": d.lastName || ((p = d.email) == null ? void 0 : p[0]),
                "first-name": d.firstName || ((_ = d.email) == null ? void 0 : _[1]),
                "image-url": d.avatar,
                "is-light": i.foreground
              }, null, 8, ["size", "last-name", "first-name", "image-url", "is-light"]),
              Q(" " + z(c(Bn)([d.firstName, d.lastName]) || d.email), 1)
            ], 2)
          ];
        }),
        option: ee((d) => {
          var p, _;
          return [
            g("div", {
              class: m(c(s)["v-user-field__option"])
            }, [
              j(c(yt), {
                size: c(ut).EXTRA_SMALL,
                "last-name": d.lastName || ((p = d.email) == null ? void 0 : p[0]),
                "first-name": d.firstName || ((_ = d.email) == null ? void 0 : _[1]),
                "image-url": d.avatar
              }, null, 8, ["size", "last-name", "first-name", "image-url"]),
              Q(" " + z(c(Bn)([d.firstName, d.lastName]) || d.email), 1)
            ], 2)
          ];
        }),
        _: 1
      }, 16, ["model-value", "options", "foreground", "borderless", "prefix-icon"])
    ], 2));
  }
}), Pc = {
  "v-user-field": "_v-user-field_n8iue_1",
  "v-user-field__option": "_v-user-field__option_n8iue_8"
}, jc = {
  $style: Pc
}, K3 = /* @__PURE__ */ V(Vc, [["__cssModules", jc]]), Nc = {}, Fc = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  width: "16",
  viewBox: "0 0 16 16"
}, Rc = /* @__PURE__ */ g("g", {
  "stroke-width": "1",
  fill: "currentColor",
  stroke: "currentColor"
}, [
  /* @__PURE__ */ g("polyline", {
    "data-color": "color-2",
    points: "0.5 5 8 9 15.5 5",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /* @__PURE__ */ g("path", {
    d: "M14,14.5H2A1.5,1.5,0,0,1,.5,13V3A1.5,1.5,0,0,1,2,1.5H14A1.5,1.5,0,0,1,15.5,3V13A1.5,1.5,0,0,1,14,14.5Z",
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1), Hc = [
  Rc
];
function zc(t, n) {
  return v(), w("svg", Fc, Hc);
}
const Yc = /* @__PURE__ */ V(Nc, [["render", zc]]), G3 = /* @__PURE__ */ Y({
  __name: "VEmailField",
  props: /* @__PURE__ */ Ke({
    modelValue: {},
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    borderless: { type: Boolean },
    placeholder: {},
    disabled: { type: Boolean }
  }, {
    modelValue: "",
    ...Ge
  }),
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const e = ia(Yc), r = t, o = n;
    return (a, s) => (v(), L(c(Yn), De({ "prefix-icon": c(e) }, r, {
      "model-value": a.modelValue,
      "onUpdate:modelValue": s[0] || (s[0] = (i) => o("update:modelValue", i))
    }), null, 16, ["prefix-icon", "model-value"]));
  }
}), Uc = /* @__PURE__ */ Y({
  __name: "VAvatarGroup",
  props: {
    users: { default: () => [] },
    size: { default: ut.SMALL },
    maxVisibleUsers: { default: 6 },
    additionalInfoAlign: { default: "right" },
    hideAdditionalInfo: { type: Boolean, default: !1 }
  },
  setup(t) {
    const n = t, e = I(() => n.users.slice(0, n.maxVisibleUsers)), r = I(() => n.users.slice(n.maxVisibleUsers)), o = I(() => n.users.length > n.maxVisibleUsers), a = he();
    return (s, i) => (v(), w("div", {
      class: m(c(a)["v-avatar-group"])
    }, [
      g("div", {
        class: m(c(a)["v-avatar-group__avatars"])
      }, [
        (v(!0), w(ae, null, ue(e.value, (l, d) => (v(), w("div", {
          key: d,
          class: m(c(a)["v-avatar-group__avatar-wrapper"])
        }, [
          j(c(yt), {
            class: m(c(a)["v-avatar-group__avatar"]),
            "first-name": l.firstName || "",
            "image-url": l.avatar || "",
            "last-name": l.lastName || "",
            size: s.size
          }, null, 8, ["class", "first-name", "image-url", "last-name", "size"]),
          s.hideAdditionalInfo ? E("", !0) : (v(), w("div", {
            key: 0,
            class: m([
              c(a)["v-avatar-group__additional-info-wrapper"],
              c(a)[`v-avatar-group__additional-info-wrapper--${s.additionalInfoAlign}`]
            ])
          }, [
            g("div", {
              class: m(c(a)["v-avatar-group__avatar-additional-info"])
            }, [
              j(c(yt), {
                "first-name": l.firstName || "",
                "image-url": l.avatar || "",
                "last-name": l.lastName || "",
                size: c(ut).SMALL
              }, null, 8, ["first-name", "image-url", "last-name", "size"]),
              g("div", {
                class: m(c(a)["v-avatar-group__additional-info-content"])
              }, [
                g("h5", null, z(l.firstName) + " " + z(l.lastName), 1),
                g("p", null, z(l.email), 1)
              ], 2)
            ], 2)
          ], 2))
        ], 2))), 128))
      ], 2),
      o.value ? (v(), w("div", {
        key: 0,
        class: m(c(a)["v-avatar-group__additional-info"])
      }, [
        Q(" +" + z(r.value.length) + " ", 1),
        g("div", {
          class: m([
            c(a)["v-avatar-group__additional-info-wrapper"],
            c(a)[`v-avatar-group__additional-info-wrapper--${s.additionalInfoAlign}`]
          ])
        }, [
          (v(!0), w(ae, null, ue(r.value, (l, d) => (v(), w("div", {
            key: d,
            class: m(c(a)["v-avatar-group__avatar-additional-info"])
          }, [
            j(c(yt), {
              "first-name": l.firstName || "",
              "image-url": l.avatar || "",
              "last-name": l.lastName || "",
              size: c(ut).SMALL
            }, null, 8, ["first-name", "image-url", "last-name", "size"]),
            g("div", {
              class: m(c(a)["v-avatar-group__additional-info-content"])
            }, [
              g("h5", null, z(l.firstName) + " " + z(l.lastName), 1),
              g("p", null, z(l.email), 1)
            ], 2)
          ], 2))), 128))
        ], 2)
      ], 2)) : E("", !0)
    ], 2));
  }
}), qc = {
  "v-avatar-group": "_v-avatar-group_1qn1n_1",
  "v-avatar-group__avatars": "_v-avatar-group__avatars_1qn1n_7",
  "v-avatar-group__avatar-wrapper": "_v-avatar-group__avatar-wrapper_1qn1n_12",
  "v-avatar-group__avatar": "_v-avatar-group__avatar_1qn1n_7",
  "v-avatar-group__additional-info": "_v-avatar-group__additional-info_1qn1n_21",
  "v-avatar-group__additional-info-wrapper": "_v-avatar-group__additional-info-wrapper_1qn1n_42",
  "v-avatar-group__avatar-additional-info": "_v-avatar-group__avatar-additional-info_1qn1n_53",
  "v-avatar-group__additional-info-wrapper--right": "_v-avatar-group__additional-info-wrapper--right_1qn1n_75",
  "v-avatar-group__additional-info-wrapper--left": "_v-avatar-group__additional-info-wrapper--left_1qn1n_80",
  "v-avatar-group__additional-info-content": "_v-avatar-group__additional-info-content_1qn1n_85"
}, Wc = {
  $style: qc
}, Z3 = /* @__PURE__ */ V(Uc, [["__cssModules", Wc]]), Kc = { key: 0 }, Gc = ["onClick"], Zc = /* @__PURE__ */ Y({
  __name: "VProfile",
  props: {
    firstName: { default: "" },
    lastName: { default: "" },
    imageUrl: { default: "" },
    jobTitle: { default: "" },
    email: { default: "" },
    actions: { default: () => [] },
    subtitle: { default: "" },
    simple: { type: Boolean, default: !1 }
  },
  emits: ["click", "changeAvatar"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I(() => Bn([e.firstName, e.lastName])), a = ie(!1), s = () => {
      a.value = !1;
    }, i = () => {
      e.simple || (a.value = !a.value), r("click");
    };
    sa(() => {
      e.simple || window.addEventListener("click", s);
    }), $t(() => {
      e.simple || window.removeEventListener("click", s);
    });
    const l = he();
    return (d, p) => (v(), w("div", {
      class: m(c(l)["v-profile"])
    }, [
      g("div", {
        class: m(c(l)["v-profile__trigger"]),
        onClick: Je(i, ["stop"])
      }, [
        j(c(yt), {
          size: c(ut).MEDIUM_SMALL,
          "first-name": d.firstName,
          "last-name": d.lastName,
          "image-url": d.imageUrl
        }, null, 8, ["size", "first-name", "last-name", "image-url"]),
        g("div", {
          class: m(c(l)["v-profile__user-info"])
        }, [
          g("h5", null, z(o.value), 1),
          d.subtitle ? (v(), w("div", Kc, z(d.subtitle), 1)) : E("", !0)
        ], 2),
        H(d.$slots, "trigger-icon", {}, () => [
          j(vt, {
            class: m([
              c(l)["v-profile__toggle"],
              {
                [c(l)["v-profile__toggle--open"]]: a.value,
                [c(l)["v-profile__toggle--simple"]]: d.simple
              }
            ])
          }, null, 8, ["class"])
        ])
      ], 2),
      g("div", {
        class: m([
          c(l)["v-profile__content"],
          {
            [c(l)["v-profile__content--open"]]: a.value
          }
        ]),
        onClick: p[1] || (p[1] = Je(() => {
        }, ["stop"]))
      }, [
        g("div", {
          class: m(c(l)["v-profile__content-header"])
        }, [
          j(c(yt), {
            "first-name": d.firstName,
            "last-name": d.lastName,
            "image-url": d.imageUrl,
            onClick: p[0] || (p[0] = (_) => r("changeAvatar"))
          }, null, 8, ["first-name", "last-name", "image-url"]),
          g("h4", null, z(o.value), 1),
          g("div", {
            class: m(c(l)["v-profile__email"])
          }, z(d.email), 3),
          d.jobTitle ? (v(), w("div", {
            key: 0,
            class: m(c(l)["v-profile__job-title"])
          }, z(d.jobTitle), 3)) : E("", !0)
        ], 2),
        g("div", {
          class: m(c(l)["v-profile__content-body"])
        }, [
          (v(!0), w(ae, null, ue(d.actions, (_, h) => (v(), w("div", {
            key: h,
            class: m([
              c(l)["v-profile__action"],
              {
                [c(l)[`v-profile__action--${_.type}`]]: _.type,
                [c(l)["v-profile__action--active"]]: _.active,
                [c(l)["v-profile__action--with-prefix-icon"]]: !!_.icon
              }
            ]),
            onClick: (y) => _.action()
          }, [
            _.icon ? (v(), L(We(_.icon), { key: 0 })) : E("", !0),
            Q(" " + z(_.title) + " ", 1),
            _.active ? (v(), L(Hn, { key: 1 })) : E("", !0)
          ], 10, Gc))), 128))
        ], 2)
      ], 2)
    ], 2));
  }
}), Jc = {
  "v-profile": "_v-profile_1vp74_1",
  "v-profile__trigger": "_v-profile__trigger_1vp74_5",
  "v-profile-content__header": "_v-profile-content__header_1vp74_12",
  "v-profile__content": "_v-profile__content_1vp74_20",
  "v-profile__content--open": "_v-profile__content--open_1vp74_24",
  "v-profile__toggle": "_v-profile__toggle_1vp74_38",
  "v-profile__toggle--open": "_v-profile__toggle--open_1vp74_45",
  "v-profile__toggle--simple": "_v-profile__toggle--simple_1vp74_49",
  "v-profile__user-info": "_v-profile__user-info_1vp74_53",
  "v-profile__content-header": "_v-profile__content-header_1vp74_78",
  "v-profile__email": "_v-profile__email_1vp74_93",
  "v-profile__job-title": "_v-profile__job-title_1vp74_93",
  "v-profile__content-body": "_v-profile__content-body_1vp74_103",
  "v-profile__action": "_v-profile__action_1vp74_127",
  "v-profile__action--active": "_v-profile__action--active_1vp74_145",
  "v-profile__action--with-prefix-icon": "_v-profile__action--with-prefix-icon_1vp74_149",
  "v-profile__action--danger": "_v-profile__action--danger_1vp74_160"
}, Xc = {
  $style: Jc
}, yo = /* @__PURE__ */ V(Zc, [["__cssModules", Xc]]), Qc = /* @__PURE__ */ Y({
  __name: "VTopbar",
  props: {
    title: { default: "" }
  },
  setup(t) {
    return (n, e) => (v(), w("div", {
      class: m(n.$style["v-topbar"])
    }, [
      g("h4", {
        class: m(n.$style["v-topbar__title"])
      }, [
        H(n.$slots, "title", {}, () => [
          Q(z(n.title), 1)
        ])
      ], 2),
      g("div", {
        class: m(n.$style["v-topbar__content"])
      }, [
        H(n.$slots, "default")
      ], 2)
    ], 2));
  }
}), ed = {
  "v-topbar": "_v-topbar_117q1_1",
  "v-topbar__content": "_v-topbar__content_117q1_12",
  "v-topbar__title": "_v-topbar__title_117q1_19"
}, td = {
  $style: ed
}, J3 = /* @__PURE__ */ V(Qc, [["__cssModules", td]]), nd = {}, rd = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "70",
  height: "24",
  viewBox: "0 0 70 24",
  fill: "none"
}, od = /* @__PURE__ */ Nn('<path d="M11.9977 12.3415L11.4217 13.5551C11.7088 12.9796 11.8041 12.3274 11.6936 11.6939L10.2402 8.60429C10.0412 8.18183 9.72669 7.82436 9.33297 7.57327C8.93924 7.32219 8.48245 7.18775 8.01547 7.18555H4.50293L9.46646 17.7273H14.5338L11.9977 12.3415Z" fill="currentColor"></path><path d="M21.4752 19.3657C20.0183 21.2393 18.0385 22.6389 15.7861 23.3875C13.5338 24.1361 11.11 24.2 8.82125 23.5711C6.53253 22.9423 4.4817 21.649 2.92809 19.8547C1.37447 18.0604 0.387847 15.8458 0.0929781 13.4908C-0.201891 11.1358 0.208237 8.74632 1.2715 6.62442C2.33476 4.50253 4.00341 2.74355 6.06643 1.56992C8.12945 0.39628 10.4942 -0.139299 12.8616 0.0309037C15.229 0.201106 17.4928 1.06945 19.3667 2.52612C21.8785 4.48034 23.5116 7.35182 23.9069 10.5095C24.3023 13.6671 23.4277 16.8526 21.4752 19.3657ZM18.6845 3.40109C16.9834 2.07863 14.9284 1.29028 12.7792 1.13575C10.6301 0.981226 8.48338 1.46746 6.61061 2.53297C4.73784 3.59847 3.22314 5.19538 2.25809 7.12173C1.29303 9.04807 0.920963 11.2173 1.18894 13.3551C1.45693 15.4929 2.35292 17.5032 3.7636 19.1318C5.17428 20.7604 7.03628 21.9341 9.11411 22.5045C11.1919 23.0748 13.3923 23.0162 15.4368 22.3361C17.4813 21.656 19.2782 20.3848 20.6002 18.6835C21.478 17.5543 22.1248 16.2632 22.5036 14.8841C22.8824 13.5049 22.9858 12.0647 22.8079 10.6455C22.63 9.22641 22.1743 7.85622 21.4668 6.61321C20.7593 5.3702 19.8139 4.27872 18.6845 3.40109Z" fill="currentColor"></path><path d="M11.5058 11.2959L10.2402 8.60429C10.0412 8.18183 9.72669 7.82436 9.33297 7.57327C8.93925 7.32219 8.48245 7.18775 8.01547 7.18555H4.50293L7.92648 14.4572C9.42091 13.8038 10.6728 12.6981 11.5058 11.2959Z" fill="currentColor"></path><path d="M9.46631 17.7248H14.5337L19.4972 7.18311H15.9204C15.4742 7.18315 15.0372 7.31004 14.6603 7.54898C14.2835 7.78793 13.9824 8.12908 13.7921 8.53264L9.46631 17.7248Z" fill="currentColor"></path><path d="M13.5276 9.09326L9.46631 17.7244H14.2964C15.3074 14.7608 16.0242 11.7034 13.5276 9.09326Z" fill="currentColor"></path><path d="M19.4974 7.18311H15.9206C15.4744 7.18315 15.0374 7.31004 14.6606 7.54898C14.2837 7.78793 13.9826 8.12908 13.7923 8.53264L13.5278 9.09371C16.0244 11.7038 15.3076 14.7613 14.2966 17.7248H14.5438L19.4974 7.18311Z" fill="currentColor"></path><path d="M11.9975 12.3414L11.4215 13.555C11.7086 12.9796 11.8039 12.3273 11.6934 11.6938L11.5055 11.2959C10.6725 12.6981 9.4207 13.8037 7.92627 14.4572L9.46625 17.7272H14.5336L11.9975 12.3414Z" fill="currentColor"></path><path d="M30.383 14.7882L28.0139 9.25955C28.004 9.23719 27.9993 9.21293 28.0001 9.18853C28.0001 9.12298 28.0414 9.09293 28.1213 9.09293H28.8403C28.8729 9.09139 28.9051 9.10119 28.9313 9.12064C28.9574 9.14008 28.9759 9.16795 28.9836 9.19946L30.8789 13.9332L32.7631 9.21039C32.7772 9.17497 32.802 9.14471 32.834 9.1237C32.866 9.10269 32.9038 9.09195 32.9422 9.09293H33.6364C33.7494 9.09293 33.7852 9.14756 33.7466 9.25955L31.372 14.7882C31.3624 14.8245 31.3404 14.8563 31.3098 14.8783C31.2791 14.9002 31.2417 14.9109 31.2039 14.9084H30.5676C30.5284 14.908 30.4902 14.8965 30.4574 14.8752C30.4247 14.8539 30.3989 14.8237 30.383 14.7882Z" fill="currentColor"></path><path d="M34.3336 14.3978C34.3205 14.3829 34.3106 14.3656 34.3045 14.3468C34.2983 14.328 34.2961 14.3082 34.2978 14.2886C34.2941 14.256 34.3019 14.2232 34.3198 14.1957L34.5953 13.7422C34.5931 13.737 34.5931 13.7311 34.5953 13.7259C34.5983 13.7246 34.6016 13.7239 34.6049 13.7239C34.6082 13.7239 34.6115 13.7246 34.6146 13.7259C34.6238 13.7124 34.6361 13.7011 34.6504 13.6931C34.6648 13.685 34.6808 13.6804 34.6972 13.6794C34.7114 13.68 34.7253 13.6835 34.7381 13.6896C34.7509 13.6957 34.7623 13.7043 34.7716 13.7149C34.9956 13.8523 35.2351 13.9632 35.4851 14.0454C35.7963 14.155 36.1245 14.2096 36.4548 14.2066C36.7957 14.2227 37.1343 14.1442 37.4327 13.9799C37.5421 13.9231 37.6339 13.838 37.6984 13.7337C37.763 13.6293 37.7977 13.5096 37.7991 13.3871C37.7984 13.2686 37.7671 13.1521 37.7083 13.0489C37.6495 12.9456 37.5651 12.859 37.463 12.7971C37.1179 12.6078 36.7467 12.4697 36.3611 12.3874C35.8229 12.2753 35.3166 12.0457 34.879 11.7154C34.7269 11.5767 34.6061 11.4076 34.5245 11.2193C34.4428 11.031 34.4022 10.8278 34.4052 10.6228C34.3922 10.3149 34.4801 10.0111 34.6559 9.75693C34.843 9.49361 35.1006 9.28737 35.3997 9.16146C35.7477 9.01411 36.1232 8.94149 36.5016 8.9484C37.137 8.93515 37.7596 9.12687 38.2757 9.4947C38.3308 9.52475 38.3446 9.58485 38.3115 9.67225V9.70776L38.0608 10.1831C38.0536 10.2022 38.0403 10.2184 38.0229 10.2293C38.0054 10.2402 37.9849 10.245 37.9644 10.2431C37.9479 10.2431 37.9286 10.2431 37.9038 10.2076C37.483 9.93437 36.9908 9.78909 36.4878 9.78971C36.1774 9.77609 35.8696 9.85098 35.6008 10.0055C35.5015 10.0595 35.4182 10.1383 35.3592 10.2342C35.3002 10.33 35.2676 10.4396 35.2647 10.5518C35.2599 10.6666 35.2851 10.7807 35.3376 10.8831C35.3902 10.9854 35.4685 11.0727 35.565 11.1364C35.9143 11.3284 36.2902 11.4683 36.6807 11.5516C37.2228 11.6832 37.7325 11.9219 38.1793 12.2536C38.3372 12.3933 38.4614 12.5666 38.5425 12.7605C38.6235 12.9544 38.6595 13.1639 38.6476 13.3735C38.6516 13.6066 38.5986 13.8373 38.493 14.0457C38.3875 14.254 38.2326 14.4339 38.0415 14.5699C37.5747 14.8935 37.0126 15.054 36.4437 15.0261C35.6909 15.0444 34.9517 14.8243 34.3336 14.3978Z" fill="currentColor"></path><path d="M40.0249 7.3258C39.9622 7.26266 39.9132 7.18741 39.8809 7.10471C39.8487 7.02201 39.834 6.93363 39.8376 6.84505C39.8335 6.75805 39.848 6.67117 39.8803 6.59017C39.9126 6.50918 39.9619 6.43591 40.0249 6.37523C40.1621 6.25551 40.3411 6.19374 40.5235 6.20314C40.6104 6.19612 40.6977 6.20791 40.7794 6.23769C40.8612 6.26746 40.9354 6.31451 40.997 6.37558C41.0586 6.43665 41.1061 6.51027 41.1361 6.59134C41.1661 6.6724 41.178 6.75898 41.1709 6.84505C41.1759 6.93387 41.1632 7.0228 41.1334 7.10671C41.1036 7.19063 41.0574 7.26787 40.9974 7.334C40.9348 7.39405 40.8604 7.44077 40.779 7.47131C40.6975 7.50184 40.6106 7.51553 40.5235 7.51155C40.4321 7.51591 40.3406 7.50168 40.2549 7.46974C40.1691 7.4378 40.0909 7.38882 40.0249 7.3258ZM40.1269 14.8648C40.115 14.8541 40.1054 14.841 40.0988 14.8265C40.0921 14.8119 40.0886 14.7961 40.0883 14.7802V9.21057C40.0859 9.19435 40.0874 9.17779 40.0927 9.16226C40.0979 9.14672 40.1069 9.13265 40.1187 9.12119C40.1305 9.10973 40.1449 9.10121 40.1607 9.09633C40.1765 9.09145 40.1932 9.09034 40.2095 9.09311H40.81C40.8277 9.09234 40.8453 9.09509 40.8619 9.10119C40.8784 9.10729 40.8936 9.11661 40.9065 9.12862C40.9283 9.15052 40.9411 9.17976 40.9423 9.21057V14.7884C40.9415 14.8201 40.9287 14.8503 40.9065 14.873C40.8799 14.8963 40.8455 14.909 40.81 14.9086H40.2205C40.2027 14.9079 40.1853 14.9037 40.1692 14.8962C40.1531 14.8887 40.1387 14.878 40.1269 14.8648Z" fill="currentColor"></path><path d="M42.9363 14.8647C42.9175 14.8405 42.9077 14.8105 42.9088 14.78V9.28413C42.9089 9.25952 42.9141 9.23519 42.924 9.21264C42.934 9.19009 42.9485 9.1698 42.9666 9.15302C42.9854 9.13348 43.0081 9.11804 43.0332 9.1077C43.0584 9.09735 43.0854 9.09232 43.1126 9.09293H43.4818C43.5082 9.09203 43.5345 9.09695 43.5588 9.10734C43.5831 9.11774 43.6048 9.13333 43.6223 9.15302C43.6564 9.1882 43.6752 9.23531 43.6746 9.28413V10.2456C43.8465 9.86676 44.1176 9.54043 44.4597 9.30052C44.8126 9.06846 45.2292 8.95016 45.6525 8.96181C46.0828 8.95016 46.5077 9.05903 46.8784 9.27594C47.2303 9.50026 47.4991 9.83198 47.6443 10.2211C47.8547 9.84688 48.1558 9.53053 48.5203 9.30052C48.8864 9.07283 49.3113 8.95518 49.7434 8.96181C50.0413 8.94617 50.3391 8.99555 50.6156 9.10646C50.8922 9.21738 51.1408 9.38712 51.344 9.60372C51.7315 10.0317 51.9252 10.6818 51.9252 11.554L51.939 14.7773C51.9402 14.7948 51.9376 14.8124 51.9314 14.8288C51.9252 14.8453 51.9155 14.8602 51.903 14.8727C51.8905 14.8851 51.8754 14.8947 51.8588 14.9009C51.8422 14.907 51.8244 14.9096 51.8068 14.9084H51.2062C51.1885 14.9096 51.1708 14.907 51.1542 14.9009C51.1376 14.8947 51.1225 14.8851 51.11 14.8727C51.0975 14.8602 51.0878 14.8453 51.0816 14.8288C51.0754 14.8124 51.0728 14.7948 51.074 14.7773V11.554C51.074 10.374 50.5947 9.78127 49.636 9.78127C49.4095 9.77873 49.1853 9.82648 48.9799 9.92101C48.7744 10.0155 48.5929 10.1545 48.4487 10.3276C48.1077 10.7391 47.8986 11.2423 47.8481 11.7726V14.7882C47.8482 14.819 47.8375 14.8489 47.8178 14.8729C47.8084 14.8841 47.7966 14.8931 47.7833 14.8992C47.7699 14.9054 47.7554 14.9085 47.7407 14.9084H47.1649C47.1304 14.907 47.0978 14.8923 47.074 14.8674C47.0491 14.8437 47.0343 14.8114 47.0327 14.7773V11.2809C46.9703 10.2811 46.4827 9.78127 45.5699 9.78127C45.2287 9.77787 44.8965 9.88961 44.6278 10.0981C44.3425 10.3211 44.1181 10.6112 43.9749 10.9422C43.8085 11.307 43.7149 11.7003 43.6994 12.1003V14.7773C43.7002 14.7948 43.6974 14.8122 43.6912 14.8286C43.6851 14.8451 43.6757 14.8601 43.6636 14.8729C43.6373 14.8966 43.6027 14.9093 43.5672 14.9084H43.0162C43.0005 14.9073 42.9852 14.9029 42.9714 14.8953C42.9575 14.8878 42.9456 14.8773 42.9363 14.8647Z" fill="currentColor"></path><path d="M53.9173 18.1422C53.8969 18.123 53.8809 18.0996 53.8704 18.0737C53.86 18.0477 53.8553 18.0199 53.8567 17.992V9.27018C53.8591 9.22038 53.8808 9.17342 53.9173 9.13907C53.9362 9.12061 53.9586 9.10605 53.9831 9.0962C54.0077 9.08636 54.034 9.08143 54.0605 9.08171H54.5178C54.5693 9.08338 54.6183 9.1038 54.6556 9.13907C54.6752 9.15511 54.6913 9.17507 54.7027 9.19766C54.7141 9.22025 54.7206 9.24495 54.7217 9.27018V10.1743C54.9488 9.78981 55.2787 9.47502 55.6749 9.26472C56.1069 9.04667 56.5869 8.93872 57.0715 8.95059C57.6124 8.93952 58.1465 9.07052 58.6197 9.33028C59.0642 9.58201 59.4258 9.95575 59.6611 10.4065C59.9154 10.8969 60.0432 11.4422 60.033 11.9935C60.0439 12.5432 59.9161 13.0869 59.6611 13.5751C59.4248 14.0237 59.0633 14.3955 58.6197 14.6458C58.1465 14.9056 57.6124 15.0366 57.0715 15.0255C56.587 15.0362 56.1073 14.9283 55.6749 14.7114C55.2738 14.5038 54.9361 14.1935 54.6969 13.8127V17.9865C54.6992 18.014 54.6955 18.0417 54.6859 18.0676C54.6764 18.0936 54.6614 18.1171 54.6418 18.1368C54.6218 18.1549 54.5983 18.1688 54.5728 18.1778C54.5472 18.1867 54.5201 18.1904 54.493 18.1887H54.0743C54.0463 18.1918 54.018 18.1893 53.991 18.1813C53.9641 18.1733 53.939 18.16 53.9173 18.1422ZM58.6005 13.5942C58.8041 13.3821 58.9627 13.1316 59.0668 12.8576C59.1709 12.5836 59.2184 12.2916 59.2065 11.999C59.2188 11.7059 59.1715 11.4134 59.0674 11.1389C58.9633 10.8644 58.8045 10.6134 58.6005 10.401C58.3909 10.1946 58.1405 10.0335 57.865 9.9277C57.5896 9.82193 57.295 9.77384 56.9999 9.78644C56.7019 9.77483 56.4045 9.8225 56.1254 9.92665C55.8463 10.0308 55.591 10.1893 55.3746 10.3928C54.9642 10.8276 54.7359 11.4008 54.7359 11.9963C54.7359 12.5917 54.9642 13.1649 55.3746 13.5997C55.5923 13.8025 55.8488 13.9602 56.1288 14.0634C56.4089 14.1666 56.7069 14.2132 57.0054 14.2006C57.2974 14.2097 57.5882 14.1602 57.8604 14.055C58.1326 13.9499 58.3806 13.7913 58.5894 13.5887L58.6005 13.5942Z" fill="currentColor"></path><path d="M61.57 14.8646C61.5585 14.8537 61.5493 14.8406 61.5432 14.826C61.537 14.8114 61.534 14.7957 61.5342 14.7799V5.9161C61.5342 5.84508 61.5728 5.80957 61.6526 5.80957H62.2532C62.3413 5.80957 62.3854 5.84508 62.3854 5.9161V14.7881C62.3798 14.8185 62.3631 14.8457 62.3386 14.8646C62.312 14.8879 62.2776 14.9005 62.2422 14.9001H61.6526C61.6218 14.8982 61.5925 14.8857 61.57 14.8646Z" fill="currentColor"></path><path d="M65.4079 14.657C64.9373 14.4129 64.548 14.0391 64.2867 13.5807C64.0119 13.0969 63.8731 12.5489 63.8845 11.9937C63.873 11.4427 64.0049 10.898 64.2674 10.4122C64.5153 9.96102 64.8881 9.58952 65.3418 9.3414C65.8297 9.08089 66.3773 8.95008 66.9313 8.96171C67.3454 8.9396 67.7596 9.00514 68.1462 9.15396C68.5328 9.30278 68.8831 9.53149 69.1737 9.82488C69.7247 10.3985 70.0001 11.1925 70.0001 12.2068C70.0001 12.3188 69.9561 12.3734 69.8679 12.3734H64.7467C64.8164 12.8965 65.088 13.3724 65.5043 13.7009C65.9541 14.0412 66.5092 14.216 67.0745 14.1953C67.3948 14.2168 67.716 14.1693 68.016 14.0562C68.3161 13.943 68.5879 13.7669 68.8128 13.5398C68.8403 13.5078 68.8784 13.4865 68.9203 13.4797C68.9389 13.4806 68.9572 13.4855 68.9738 13.494C68.9904 13.5025 69.005 13.5144 69.0167 13.5288L69.4492 13.9195C69.4877 13.9604 69.5098 13.9905 69.5098 14.0151C69.5085 14.0335 69.5034 14.0515 69.4949 14.0679C69.4864 14.0843 69.4746 14.0989 69.4602 14.1107C69.1806 14.418 68.8312 14.6549 68.4409 14.8017C68.0011 14.9667 67.5337 15.0474 67.0635 15.0394C66.4883 15.0494 65.9195 14.918 65.4079 14.657ZM69.1131 11.614C69.0518 11.0968 68.7972 10.6212 68.3996 10.281C67.9773 9.957 67.4584 9.78117 66.9244 9.78117C66.3904 9.78117 65.8715 9.957 65.4492 10.281C65.0536 10.6221 64.8011 11.0976 64.7412 11.614H69.1131Z" fill="currentColor"></path>', 14), ad = [
  od
];
function id(t, n) {
  return v(), w("svg", rd, ad);
}
const sd = /* @__PURE__ */ V(nd, [["render", id]]), ld = {}, ud = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cd = /* @__PURE__ */ g("path", {
  d: "M8.53553 1.53553L1.46447 8.6066M1.46447 1.53553L8.53553 8.6066",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), dd = [
  cd
];
function fd(t, n) {
  return v(), w("svg", ud, dd);
}
const qn = /* @__PURE__ */ V(ld, [["render", fd]]), pd = {}, vd = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none"
}, hd = /* @__PURE__ */ g("path", {
  d: "M19.5 19.5L15.15 15.15M17.5 9.5C17.5 13.9183 13.9183 17.5 9.5 17.5C5.08172 17.5 1.5 13.9183 1.5 9.5C1.5 5.08172 5.08172 1.5 9.5 1.5C13.9183 1.5 17.5 5.08172 17.5 9.5Z",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), _d = [
  hd
];
function md(t, n) {
  return v(), w("svg", vd, _d);
}
const gd = /* @__PURE__ */ V(pd, [["render", md]]), bd = {}, yd = {
  id: "Capa_1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  "xml:space": "preserve"
}, wd = /* @__PURE__ */ g("g", null, [
  /* @__PURE__ */ g("g", null, [
    /* @__PURE__ */ g("path", {
      fill: "currentColor",
      d: "M481.508,210.335L68.414,38.926c-17.403-7.222-37.063-4.045-51.309,8.287C2.859,59.547-3.099,78.55,1.557,96.808    L42.151,256L1.557,415.192c-4.656,18.258,1.301,37.261,15.547,49.595c14.273,12.358,33.938,15.495,51.31,8.287l413.094-171.409    C500.316,293.861,512,276.363,512,256C512,235.637,500.316,218.139,481.508,210.335z M470.009,273.955L56.916,445.364    c-6.947,2.881-14.488,1.665-20.175-3.259c-5.686-4.923-7.971-12.212-6.113-19.501L69.287,271h149.065    c8.285,0,15.001-6.716,15.001-15.001c0-8.285-6.716-15.001-15.001-15.001H69.288L30.628,89.396    c-1.858-7.288,0.427-14.578,6.113-19.501c5.686-4.923,13.225-6.141,20.174-3.259l413.094,171.409    c11.125,4.616,11.99,14.91,11.99,17.955S481.134,269.339,470.009,273.955z"
    })
  ])
], -1), Cd = /* @__PURE__ */ g("g", null, null, -1), $d = /* @__PURE__ */ g("g", null, null, -1), kd = /* @__PURE__ */ g("g", null, null, -1), Md = /* @__PURE__ */ g("g", null, null, -1), Dd = /* @__PURE__ */ g("g", null, null, -1), Sd = /* @__PURE__ */ g("g", null, null, -1), Od = /* @__PURE__ */ g("g", null, null, -1), Td = /* @__PURE__ */ g("g", null, null, -1), Ad = /* @__PURE__ */ g("g", null, null, -1), Ed = /* @__PURE__ */ g("g", null, null, -1), xd = /* @__PURE__ */ g("g", null, null, -1), Id = /* @__PURE__ */ g("g", null, null, -1), Ld = /* @__PURE__ */ g("g", null, null, -1), Bd = /* @__PURE__ */ g("g", null, null, -1), Vd = /* @__PURE__ */ g("g", null, null, -1), Pd = [
  wd,
  Cd,
  $d,
  kd,
  Md,
  Dd,
  Sd,
  Od,
  Td,
  Ad,
  Ed,
  xd,
  Id,
  Ld,
  Bd,
  Vd
];
function jd(t, n) {
  return v(), w("svg", yd, Pd);
}
const Nd = /* @__PURE__ */ V(bd, [["render", jd]]), Fd = {}, Rd = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hd = /* @__PURE__ */ g("path", {
  d: "M25.3499 21.7253C24.7963 21.1498 24.1286 20.8421 23.421 20.8421C22.7191 20.8421 22.0457 21.1441 21.4693 21.7196L19.6659 23.5147C19.5175 23.4349 19.3691 23.3608 19.2265 23.2867C19.021 23.1842 18.827 23.0873 18.6615 22.9847C16.9723 21.9134 15.4371 20.5172 13.9648 18.7108C13.2514 17.8104 12.7721 17.0525 12.4239 16.2832C12.8919 15.8558 13.3256 15.4114 13.7479 14.984C13.9077 14.8244 14.0675 14.6591 14.2273 14.4996C15.4257 13.3029 15.4257 11.7529 14.2273 10.5562L12.6693 9.0005C12.4924 8.82384 12.3098 8.64149 12.1386 8.45914C11.7962 8.10583 11.4367 7.74112 11.0657 7.39921C10.5121 6.85215 9.85016 6.56152 9.15392 6.56152C8.45769 6.56152 7.78428 6.85215 7.2136 7.39921C7.20789 7.40491 7.20789 7.40491 7.20219 7.41061L5.26186 9.3652C4.53139 10.0946 4.11479 10.9836 4.02348 12.015C3.88652 13.679 4.37731 15.229 4.75396 16.2433C5.67846 18.7336 7.05952 21.0415 9.11968 23.5147C11.6193 26.495 14.6268 28.8485 18.0623 30.5068C19.3749 31.1279 21.1269 31.863 23.0843 31.9884C23.2041 31.9941 23.3297 31.9998 23.4438 31.9998C24.7621 31.9998 25.8692 31.5268 26.7367 30.5866C26.7424 30.5752 26.7538 30.5695 26.7595 30.5581C27.0562 30.1991 27.3987 29.8742 27.7582 29.5266C28.0036 29.293 28.2547 29.048 28.5001 28.7915C29.0651 28.2046 29.3618 27.5207 29.3618 26.8198C29.3618 26.1132 29.0593 25.4351 28.483 24.8652L25.3499 21.7253ZM27.393 27.7259C27.3872 27.7259 27.3872 27.7316 27.393 27.7259C27.1704 27.9652 26.9421 28.1818 26.6967 28.4211C26.3258 28.7744 25.9491 29.1448 25.5953 29.5608C25.0189 30.1763 24.3398 30.4669 23.4495 30.4669C23.3639 30.4669 23.2726 30.4669 23.187 30.4612C21.4921 30.3529 19.917 29.6919 18.7357 29.1277C15.5056 27.5663 12.6693 25.3496 10.3124 22.5402C8.36638 20.1981 7.06522 18.0327 6.20349 15.7077C5.67276 14.2887 5.47872 13.1832 5.56433 12.1404C5.6214 11.4737 5.8782 10.9209 6.35187 10.4479L8.2979 8.50472C8.57753 8.24259 8.87429 8.10013 9.16534 8.10013C9.52487 8.10013 9.81592 8.31667 9.99853 8.49903C10.0042 8.50472 10.0099 8.51042 10.0157 8.51612C10.3638 8.84094 10.6948 9.17715 11.0429 9.53616C11.2198 9.71851 11.4024 9.90087 11.585 10.0889L13.143 11.6446C13.7479 12.2487 13.7479 12.8071 13.143 13.4112C12.9775 13.5764 12.8177 13.7417 12.6522 13.9012C12.1728 14.3913 11.7163 14.8472 11.2198 15.2917C11.2084 15.3031 11.197 15.3088 11.1913 15.3202C10.7005 15.8102 10.7918 16.2889 10.8945 16.6137C10.9002 16.6308 10.9059 16.6479 10.9116 16.665C11.3168 17.6452 11.8875 18.5683 12.7549 19.6682L12.7606 19.6739C14.3357 21.6114 15.9964 23.1215 17.8283 24.2783C18.0623 24.4264 18.302 24.5461 18.5302 24.6601C18.7357 24.7627 18.9297 24.8595 19.0952 24.9621C19.118 24.9735 19.1409 24.9906 19.1637 25.002C19.3577 25.0989 19.5404 25.1445 19.7287 25.1445C20.2023 25.1445 20.4991 24.8481 20.5961 24.7513L22.5479 22.8024C22.7419 22.6086 23.0501 22.375 23.4096 22.375C23.7634 22.375 24.0545 22.5972 24.2314 22.791C24.2371 22.7967 24.2371 22.7967 24.2428 22.8024L27.3872 25.9422C27.975 26.5235 27.975 27.1218 27.393 27.7259Z",
  fill: "currentColor"
}, null, -1), zd = /* @__PURE__ */ g("path", {
  d: "M18.5931 11.4226C20.0883 11.6733 21.4466 12.3799 22.5309 13.4627C23.6152 14.5454 24.3171 15.9016 24.5739 17.3947C24.6367 17.7708 24.962 18.0329 25.3329 18.0329C25.3786 18.0329 25.4185 18.0272 25.4642 18.0215C25.8865 17.9531 26.1661 17.5542 26.0976 17.1325C25.7895 15.3261 24.9334 13.6792 23.6266 12.3743C22.3197 11.0693 20.6704 10.2145 18.8614 9.90678C18.4391 9.8384 18.0453 10.1176 17.9711 10.5336C17.8969 10.9496 18.1708 11.3542 18.5931 11.4226Z",
  fill: "currentColor"
}, null, -1), Yd = /* @__PURE__ */ g("path", {
  d: "M30.9885 16.9103C30.4806 13.9356 29.0767 11.2288 26.9195 9.07479C24.7623 6.92074 22.0516 5.5189 19.0726 5.01173C18.656 4.93765 18.2622 5.22257 18.188 5.63857C18.1196 6.06026 18.3992 6.45346 18.8215 6.52754C21.4809 6.97772 23.9063 8.2371 25.8352 10.1575C27.7641 12.0836 29.0196 14.5055 29.4704 17.161C29.5332 17.5371 29.8585 17.7992 30.2295 17.7992C30.2751 17.7992 30.3151 17.7935 30.3607 17.7878C30.7773 17.7252 31.0627 17.3263 30.9885 16.9103Z",
  fill: "currentColor"
}, null, -1), Ud = [
  Hd,
  zd,
  Yd
];
function qd(t, n) {
  return v(), w("svg", Rd, Ud);
}
const Wd = /* @__PURE__ */ V(Fd, [["render", qd]]), Kd = {}, Gd = {
  width: "36",
  height: "37",
  viewBox: "0 0 36 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zd = /* @__PURE__ */ g("path", {
  d: "M28.1309 2.5H19.3397H10.0592C7.82656 2.5041 6.01472 4.30142 6 6.52664V30.4732C6.01472 32.6984 7.82656 34.4957 10.0592 34.4998H28.1424C28.6389 34.5071 29.1177 34.3166 29.4725 33.9703C29.8111 33.6236 30.0004 33.1589 30 32.675V4.36285C29.9979 3.33485 29.1623 2.5021 28.1309 2.5ZM20.1118 4.0238H24.603V11.1704L23.0091 8.6371C22.9445 8.52987 22.8545 8.44006 22.7469 8.37577C22.3848 8.1593 21.9152 8.27625 21.698 8.6371L20.1118 11.159V4.0238ZM7.54802 6.52664C7.55432 5.14694 8.67492 4.03009 10.0592 4.0238H18.5829V11.7952C18.5541 12.4137 18.9438 12.9752 19.5346 13.1666C20.2074 13.3685 20.8113 12.9342 21.1706 12.3628L22.3593 10.458L23.548 12.3628C23.9035 12.9266 24.5074 13.3609 25.1992 13.1666C25.7873 12.9759 26.1762 12.4186 26.151 11.8028V4.04285H28.1424C28.3189 4.04494 28.4613 4.18694 28.4634 4.36285V26.4575C28.3574 26.4396 28.25 26.4307 28.1424 26.4313H10.0592C9.14735 26.431 8.26221 26.7385 7.54802 27.3037V6.52664Z",
  fill: "currentColor"
}, null, -1), Jd = /* @__PURE__ */ g("path", {
  d: "M8 30.5C8 29.1193 9.11929 28 10.5 28H28.5V33H10.5C9.11929 33 8 31.8807 8 30.5Z",
  fill: "#E5E6F5"
}, null, -1), Xd = [
  Zd,
  Jd
];
function Qd(t, n) {
  return v(), w("svg", Gd, Xd);
}
const ef = /* @__PURE__ */ V(Kd, [["render", Qd]]), tf = {}, nf = {
  width: "36",
  height: "37",
  viewBox: "0 0 36 37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rf = /* @__PURE__ */ g("path", {
  d: "M10.3 31.5C10.1677 31.5 10.0345 31.4694 9.9094 31.4081C9.5989 31.253 9.4 30.9289 9.4 30.5714V25.9286H6.7C5.2114 25.9286 4 24.6787 4 23.1429V8.28571C4 6.74986 5.2114 5.5 6.7 5.5H28.3C29.7886 5.5 31 6.74986 31 8.28571V23.1429C31 24.6787 29.7886 25.9286 28.3 25.9286H17.3659L10.8625 31.2966C10.6996 31.4313 10.5007 31.5 10.3 31.5ZM6.7 7.35714C6.2032 7.35714 5.8 7.77407 5.8 8.28571V23.1429C5.8 23.6545 6.2032 24.0714 6.7 24.0714H10.3C10.7977 24.0714 11.2 24.4865 11.2 25V28.64L16.4875 24.2748C16.6477 24.1429 16.8448 24.0714 17.05 24.0714H28.3C28.7968 24.0714 29.2 23.6545 29.2 23.1429V8.28571C29.2 7.77407 28.7968 7.35714 28.3 7.35714H6.7Z",
  fill: "#6B75D1"
}, null, -1), of = /* @__PURE__ */ g("path", {
  d: "M24.6999 14.7859H10.2999C9.8022 14.7859 9.3999 14.3699 9.3999 13.8573C9.3999 13.3447 9.8022 12.9287 10.2999 12.9287H24.6999C25.1976 12.9287 25.5999 13.3447 25.5999 13.8573C25.5999 14.3699 25.1976 14.7859 24.6999 14.7859Z",
  fill: "#6B75D1"
}, null, -1), af = /* @__PURE__ */ g("path", {
  d: "M17.4999 18.4997H10.2999C9.8022 18.4997 9.3999 18.0837 9.3999 17.5711C9.3999 17.0586 9.8022 16.6426 10.2999 16.6426H17.4999C17.9976 16.6426 18.3999 17.0586 18.3999 17.5711C18.3999 18.0837 17.9976 18.4997 17.4999 18.4997Z",
  fill: "#6B75D1"
}, null, -1), sf = [
  rf,
  of,
  af
];
function lf(t, n) {
  return v(), w("svg", nf, sf);
}
const uf = /* @__PURE__ */ V(tf, [["render", lf]]), cf = /* @__PURE__ */ g("div", null, " | Support Center", -1), df = /* @__PURE__ */ g("h2", null, "Got a question? We’re here to help", -1), ff = [
  df
], pf = /* @__PURE__ */ g("h5", null, "Give us a call", -1), vf = /* @__PURE__ */ g("a", { href: "tel:(812) 909-6714" }, [
  /* @__PURE__ */ g("b", null, "(812) 909-6714")
], -1), hf = /* @__PURE__ */ g("h5", null, "Knowledge base", -1), _f = /* @__PURE__ */ g("br", null, null, -1), mf = /* @__PURE__ */ g("h5", null, "Send us a message", -1), gf = /* @__PURE__ */ g("br", null, null, -1), bf = /* @__PURE__ */ Y({
  __name: "VSupportCenter",
  props: {
    isModalShow: { type: Boolean }
  },
  emits: ["update:is-modal-show"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I({
      get() {
        return e.isModalShow;
      },
      set(a) {
        r("update:is-modal-show", a);
      }
    });
    return (a, s) => (v(), L(c(ca), {
      modelValue: o.value,
      "onUpdate:modelValue": s[1] || (s[1] = (i) => o.value = i),
      class: m(a.$style["v-support-center"])
    }, {
      default: ee(() => [
        g("div", {
          class: m(a.$style["v-support-center__header"])
        }, [
          g("div", {
            class: m(a.$style["v-support-center__header-title"])
          }, [
            j(sd),
            cf
          ], 2),
          g("div", {
            class: m(a.$style["v-support-center__header-wrapper"])
          }, ff, 2),
          g("div", {
            class: m(a.$style["v-support-center__close"]),
            onClick: s[0] || (s[0] = (i) => o.value = !1)
          }, [
            j(qn)
          ], 2)
        ], 2),
        g("div", {
          class: m(a.$style["v-support-center__body"])
        }, [
          g("div", {
            class: m(a.$style["v-support-center__info-item"])
          }, [
            g("div", {
              class: m(a.$style["v-support-center__info-icon"])
            }, [
              j(Wd)
            ], 2),
            g("div", {
              class: m(a.$style["v-support-center__info-content"])
            }, [
              pf,
              Q(" We’re happy to assist you, whenever you need us. ")
            ], 2),
            g("div", {
              class: m([
                a.$style["v-support-center__info-content"],
                a.$style["v-support-center__info-content-action"]
              ])
            }, [
              vf,
              Q(" Elia Tautua | VSimple Agent ")
            ], 2)
          ], 2),
          g("div", {
            class: m(a.$style["v-support-center__info-item"])
          }, [
            g("div", {
              class: m(a.$style["v-support-center__info-icon"])
            }, [
              j(ef)
            ], 2),
            g("div", {
              class: m(a.$style["v-support-center__info-content"])
            }, [
              hf,
              Q(" Find answers to the most popular FAQs,"),
              _f,
              Q(" Read and learn from our knowledge base. ")
            ], 2),
            g("div", {
              class: m(a.$style["v-support-center__info-content-action"])
            }, [
              j(c(xn), {
                href: "https://docs.vsimple.com/",
                target: "_blank",
                tag: c(An).LINK,
                rel: "noopener noreferrer"
              }, {
                icon: ee(() => [
                  j(gd)
                ]),
                default: ee(() => [
                  Q(" View articles ")
                ]),
                _: 1
              }, 8, ["tag"])
            ], 2)
          ], 2),
          g("div", {
            class: m(a.$style["v-support-center__info-item"])
          }, [
            g("div", {
              class: m(a.$style["v-support-center__info-icon"])
            }, [
              j(uf)
            ], 2),
            g("div", {
              class: m(a.$style["v-support-center__info-content"])
            }, [
              mf,
              Q(" Get in touch with us and resolve"),
              gf,
              Q(" any questions you may have. ")
            ], 2),
            g("div", {
              class: m(a.$style["v-support-center__info-content-action"])
            }, [
              j(c(xn), {
                tag: c(An).LINK,
                href: "mailto:support@vsimple.com"
              }, {
                icon: ee(() => [
                  j(Nd)
                ]),
                default: ee(() => [
                  Q(" Send message ")
                ]),
                _: 1
              }, 8, ["tag"])
            ], 2)
          ], 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["modelValue", "class"]));
  }
}), yf = "_vfm__content_2fv97_2", wf = {
  "v-support-center": "_v-support-center_2fv97_2",
  vfm__content: yf,
  "v-support-center__body": "_v-support-center__body_2fv97_6",
  "v-support-center__info-item": "_v-support-center__info-item_2fv97_30",
  "v-support-center__info-content-action": "_v-support-center__info-content-action_2fv97_37",
  "v-support-center__header-wrapper": "_v-support-center__header-wrapper_2fv97_37",
  "v-support-center__header": "_v-support-center__header_2fv97_37",
  "v-support-center__header-title": "_v-support-center__header-title_2fv97_50",
  "v-support-center__close": "_v-support-center__close_2fv97_61",
  "v-support-center__info-icon": "_v-support-center__info-icon_2fv97_122",
  "v-support-center__info-content": "_v-support-center__info-content_2fv97_37"
}, Cf = {
  $style: wf
}, X3 = /* @__PURE__ */ V(bf, [["__cssModules", Cf]]), $f = {}, kf = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mf = /* @__PURE__ */ g("rect", {
  x: "3",
  y: "5",
  width: "18",
  height: "1.6",
  rx: "0.8",
  fill: "currentColor"
}, null, -1), Df = /* @__PURE__ */ g("rect", {
  x: "3",
  y: "11.1",
  width: "18",
  height: "1.6",
  rx: "0.8",
  fill: "currentColor"
}, null, -1), Sf = /* @__PURE__ */ g("rect", {
  x: "3",
  y: "17.2",
  width: "18",
  height: "1.6",
  rx: "0.8",
  fill: "currentColor"
}, null, -1), Of = [
  Mf,
  Df,
  Sf
];
function Tf(t, n) {
  return v(), w("svg", kf, Of);
}
const Af = /* @__PURE__ */ V($f, [["render", Tf]]), Ef = /* @__PURE__ */ Y({
  __name: "VTopbarMobile",
  props: {
    isOpen: { type: Boolean },
    hasNotification: { type: Boolean },
    hasTasks: { type: Boolean }
  },
  emits: ["update:isOpen"],
  setup(t, { emit: n }) {
    const e = n;
    return (r, o) => (v(), w("div", {
      class: m(r.$style["v-topbar-mobile"])
    }, [
      H(r.$slots, "search"),
      g("div", {
        class: m(r.$style["v-topbar-mobile__actions"])
      }, [
        r.hasTasks ? (v(), w("div", {
          key: 0,
          class: m(r.$style["v-topbar-mobile__icon"])
        }, [
          H(r.$slots, "tasks")
        ], 2)) : E("", !0),
        r.hasNotification ? (v(), w("div", {
          key: 1,
          class: m(r.$style["v-topbar-mobile__icon"])
        }, [
          H(r.$slots, "notification")
        ], 2)) : E("", !0),
        g("div", {
          class: m([
            r.$style["v-topbar-mobile__icon"],
            {
              [r.$style["v-topbar-mobile__icon--close"]]: r.isOpen
            }
          ]),
          onClick: o[0] || (o[0] = (a) => e("update:isOpen", !r.isOpen))
        }, [
          r.isOpen ? (v(), L(qn, { key: 0 })) : (v(), L(Af, { key: 1 }))
        ], 2)
      ], 2)
    ], 2));
  }
}), xf = {
  "v-topbar-mobile": "_v-topbar-mobile_1cczz_1",
  "v-topbar-mobile__actions": "_v-topbar-mobile__actions_1cczz_9",
  "v-topbar-mobile__icon": "_v-topbar-mobile__icon_1cczz_16",
  "v-topbar-mobile__icon--close": "_v-topbar-mobile__icon--close_1cczz_28"
}, If = {
  $style: xf
}, Q3 = /* @__PURE__ */ V(Ef, [["__cssModules", If]]), Lf = ["onClick"], Bf = /* @__PURE__ */ Y({
  __name: "VSidebarMobile",
  props: {
    routesGroups: { default: () => [] },
    profileSubtitle: { default: "" },
    profileFirstName: { default: "" },
    profileLastName: { default: "" },
    profileEmail: { default: "" },
    profileActions: {},
    isOpen: { type: Boolean, default: !1 }
  },
  setup(t) {
    const n = t, e = ie(!1);
    return Ct(() => n.isOpen, (r) => {
      r || (e.value = !1);
    }), (r, o) => (v(), w("div", {
      class: m([
        r.$style["v-sidebar-mobile"],
        {
          [r.$style["v-sidebar-mobile--open"]]: r.isOpen,
          [r.$style["v-sidebar-mobile--fullscreen"]]: e.value
        }
      ])
    }, [
      e.value ? (v(), w(ae, { key: 0 }, [
        g("div", {
          class: m([
            r.$style["v-sidebar-mobile__profile"],
            r.$style["v-sidebar-mobile__profile--open"]
          ])
        }, [
          j(c(yo), {
            "first-name": r.profileFirstName,
            "last-name": r.profileLastName,
            subtitle: r.profileEmail,
            simple: ""
          }, {
            "trigger-icon": ee(() => [
              g("div", {
                class: m(r.$style["v-sidebar-mobile__profile-trigger-icon"]),
                onClick: o[0] || (o[0] = (a) => e.value = !1)
              }, [
                j(qn)
              ], 2)
            ]),
            _: 1
          }, 8, ["first-name", "last-name", "subtitle"])
        ], 2),
        g("div", {
          class: m(r.$style["v-sidebar-mobile__profile-actions"])
        }, [
          (v(!0), w(ae, null, ue(r.profileActions, (a, s) => (v(), w("div", {
            key: s,
            class: m([
              r.$style["v-sidebar-mobile__profile-action"],
              {
                [r.$style["v-sidebar-mobile__profile-action--active"]]: a.active,
                [r.$style["v-sidebar-mobile__profile-action--danger"]]: a.type === "danger"
              }
            ]),
            onClick: (i) => a.action()
          }, [
            Q(z(a.title) + " ", 1),
            a.active ? (v(), L(Hn, { key: 0 })) : E("", !0)
          ], 10, Lf))), 128))
        ], 2)
      ], 64)) : (v(), w("div", {
        key: 1,
        class: m(r.$style["v-sidebar-mobile__routes-wrapper"])
      }, [
        (v(!0), w(ae, null, ue(r.routesGroups, (a, s) => (v(), w("div", { key: s }, [
          g("nav", {
            class: m(r.$style["v-sidebar-mobile__routes-group"])
          }, [
            g("div", {
              class: m(r.$style["v-sidebar-mobile__rotes-group-wrapper"])
            }, [
              (v(!0), w(ae, null, ue(a, (i, l) => (v(), L(c(va), {
                key: l,
                collapsed: !1,
                to: i.to,
                title: i.title,
                icon: i.icon,
                active: i.active,
                action: i.action,
                "sub-routes": i.subRoutes,
                "open-on-click": ""
              }, null, 8, ["to", "title", "icon", "active", "action", "sub-routes"]))), 128))
            ], 2)
          ], 2)
        ]))), 128)),
        g("div", {
          class: m(r.$style["v-sidebar-mobile__profile"])
        }, [
          j(c(yo), {
            "first-name": r.profileFirstName,
            "last-name": r.profileLastName,
            subtitle: r.profileSubtitle,
            simple: "",
            onClick: o[1] || (o[1] = (a) => e.value = !0)
          }, null, 8, ["first-name", "last-name", "subtitle"])
        ], 2)
      ], 2))
    ], 2));
  }
}), Vf = {
  "v-sidebar-mobile": "_v-sidebar-mobile_au7ta_1",
  "v-sidebar-mobile--open": "_v-sidebar-mobile--open_au7ta_14",
  "v-sidebar-mobile--fullscreen": "_v-sidebar-mobile--fullscreen_au7ta_18",
  "v-sidebar-mobile__routes-group": "_v-sidebar-mobile__routes-group_au7ta_23",
  "v-sidebar-mobile__profile": "_v-sidebar-mobile__profile_au7ta_34",
  "v-sidebar-mobile__profile--open": "_v-sidebar-mobile__profile--open_au7ta_38",
  "v-sidebar-mobile__profile-trigger-icon": "_v-sidebar-mobile__profile-trigger-icon_au7ta_44",
  "v-sidebar-mobile__profile-actions": "_v-sidebar-mobile__profile-actions_au7ta_59",
  "v-sidebar-mobile__profile-action": "_v-sidebar-mobile__profile-action_au7ta_59",
  "v-sidebar-mobile__profile-action--active": "_v-sidebar-mobile__profile-action--active_au7ta_98",
  "v-sidebar-mobile__profile-action--danger": "_v-sidebar-mobile__profile-action--danger_au7ta_102"
}, Pf = {
  $style: Vf
}, e5 = /* @__PURE__ */ V(Bf, [["__cssModules", Pf]]), jf = /* @__PURE__ */ Y({
  __name: "VMarkedText",
  props: {
    content: { default: "" },
    variant: { default: Mr.SECONDARY }
  },
  setup(t) {
    return (n, e) => (v(), w("div", {
      class: m([
        n.$style["v-marked-text"],
        n.$style[`v-marked-text--${n.variant}`]
      ])
    }, [
      H(n.$slots, "content", {}, () => [
        Q(z(n.content), 1)
      ])
    ], 2));
  }
}), Nf = {
  "v-marked-text": "_v-marked-text_1dkws_1",
  "v-marked-text--secondary": "_v-marked-text--secondary_1dkws_16",
  "v-marked-text--primary": "_v-marked-text--primary_1dkws_21"
}, Ff = {
  $style: Nf
}, Wn = /* @__PURE__ */ V(jf, [["__cssModules", Ff]]), Rf = /* @__PURE__ */ Y({
  __name: "VShrinkText",
  props: {
    maxLength: { default: 50 },
    content: { default: "" },
    placement: { default: "auto" },
    autoShrink: { type: Boolean, default: !1 },
    hoverContent: { default: "" },
    tooltipClass: { default: null }
  },
  setup(t) {
    const n = t, e = he(), r = I(() => [
      e["v-shrink-text__tooltip"],
      ...n.autoShrink ? e["v-shrink-text__tooltip--auto-shrink"] : [],
      n.tooltipClass
    ].filter(Boolean)), o = I(() => {
      var F;
      if (!n.autoShrink)
        return Sn("div", {
          class: [
            e["v-shrink-text__trigger"],
            {
              [e["v-shrink-text__trigger--auto-shrink"]]: n.autoShrink
            }
          ],
          ...h.value ? {
            onmouseenter: k,
            onmouseleave: M
          } : {}
        }, [y.value]);
      const D = new RegExp(/(https?:\/\/[^\s]+)/g), U = (F = String(y.value || "")) == null ? void 0 : F.split(D).map((G) => D.test(String(G)) ? Sn("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: G
      }, [
        G
      ]) : G);
      return Sn("div", {
        class: [
          e["v-shrink-text__trigger"],
          {
            [e["v-shrink-text__trigger--auto-shrink"]]: n.autoShrink
          }
        ],
        ...h.value ? {
          onmouseenter: k,
          onmouseleave: M
        } : {}
      }, [U]);
    }), a = ie(null), s = ie(), i = ie();
    let l = () => {
    };
    const d = ie(!1), p = () => {
      var D, U;
      d.value = (((D = s.value) == null ? void 0 : D.offsetWidth) || 0) < (((U = s.value) == null ? void 0 : U.scrollWidth) || 0);
    }, _ = ji(p, 200);
    sa(() => {
      n.autoShrink && (p(), l = Ni(document.body, _).stop);
    });
    const h = I(() => n.hoverContent && n.hoverContent !== n.content ? !0 : n.autoShrink ? d.value : String(n.content || "").length > n.maxLength), y = I(() => n.autoShrink || !h.value || n.hoverContent ? n.content : String(n.content || "").slice(0, n.maxLength).trim() + "..."), $ = ie(!1), k = () => {
      $.value = !0;
    }, M = () => {
      $.value = !1;
    }, P = () => {
      var D;
      a.value && ((D = a.value) == null || D.destroy(), a.value = null), i.value && document.body.removeChild(i.value);
    };
    return Ct(() => $.value, async (D) => {
      await pt(), D && s.value && i.value ? (a.value = Mt(s.value, i.value, {
        placement: n.placement,
        modifiers: [
          kt,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }), document.body.appendChild(i.value)) : !D && a.value && P();
    }), $t(() => {
      l == null || l(), P();
    }), (D, U) => (v(), w("div", {
      class: m(c(e)["v-shrink-text"])
    }, [
      j(c(o), {
        ref_key: "trigger",
        ref: s
      }, null, 512),
      $.value ? (v(), w("div", {
        key: 0,
        ref_key: "tooltip",
        ref: i,
        class: m(r.value)
      }, z(D.hoverContent || D.content), 3)) : E("", !0)
    ], 2));
  }
}), Hf = {
  "v-shrink-text": "_v-shrink-text_10ynh_1",
  "v-shrink-text__tooltip": "_v-shrink-text__tooltip_10ynh_5",
  "v-shrink-text__trigger": "_v-shrink-text__trigger_10ynh_24",
  "v-shrink-text__trigger--auto-shrink": "_v-shrink-text__trigger--auto-shrink_10ynh_29",
  "v-shrink-text__tooltip--auto-shrink": "_v-shrink-text__tooltip--auto-shrink_10ynh_41"
}, zf = {
  $style: Hf
}, Ht = /* @__PURE__ */ V(Rf, [["__cssModules", zf]]), Yf = /* @__PURE__ */ Y({
  __name: "VChip",
  props: {
    content: { default: "" },
    maxLength: { default: 1 / 0 }
  },
  setup(t) {
    const n = he();
    return (e, r) => (v(), L(c(Ht), {
      content: e.content,
      "max-length": e.maxLength,
      class: m(c(n)["v-chip"])
    }, null, 8, ["content", "max-length", "class"]));
  }
}), Uf = {
  "v-chip": "_v-chip_1bq7j_1"
}, qf = {
  $style: Uf
}, La = /* @__PURE__ */ V(Yf, [["__cssModules", qf]]), Wf = /* @__PURE__ */ Y({
  __name: "VRecordKanbanCard",
  props: {
    isRecordTypesEnabled: { type: Boolean, default: !1 },
    recordType: { default: "Record Type" },
    createdDate: { default: "03/10/2022" },
    notificationCount: { default: 0 },
    inStage: { default: "" },
    title: {},
    to: {},
    statusColor: { default: "" }
  },
  setup(t) {
    return (n, e) => {
      const r = la("router-link");
      return v(), w("div", {
        class: m([
          n.$style["v-record-kanban-card"],
          {
            [n.$style["v-record-kanban-card--with-record-type"]]: n.isRecordTypesEnabled
          }
        ]),
        style: dt({
          color: n.statusColor
        })
      }, [
        n.notificationCount ? (v(), L(c(Wn), {
          key: 0,
          class: m(n.$style["v-record-kanban-card__notification"]),
          content: n.notificationCount
        }, null, 8, ["class", "content"])) : E("", !0),
        g("div", {
          class: m([
            n.$style["v-record-kanban-card__info"],
            {
              [n.$style["v-record-kanban-card__info--with-record-type"]]: n.isRecordTypesEnabled
            }
          ])
        }, [
          n.isRecordTypesEnabled ? (v(), L(c(La), {
            key: 0,
            content: n.recordType
          }, null, 8, ["content"])) : E("", !0),
          n.isRecordTypesEnabled ? (v(), w("div", {
            key: 1,
            class: m(n.$style["v-record-kanban-card__created-date"])
          }, z(n.createdDate), 3)) : E("", !0)
        ], 2),
        g("div", {
          class: m([
            n.$style["v-record-kanban-card__title-wrapper"],
            {
              [n.$style["v-record-kanban-card__title-wrapper--without-record-type"]]: !n.isRecordTypesEnabled
            }
          ])
        }, [
          g("h3", null, [
            j(r, { to: n.to }, {
              default: ee(() => [
                Q(z(n.title), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ], 2),
        g("div", {
          class: m([
            n.$style["v-record-kanban-card__additional-info"],
            {
              [n.$style["v-record-kanban-card__additional-info--without-record-type"]]: !n.isRecordTypesEnabled
            }
          ])
        }, [
          Q(" in stage: " + z(n.inStage) + " ", 1),
          n.isRecordTypesEnabled ? E("", !0) : (v(), w("div", {
            key: 0,
            class: m(n.$style["v-record-kanban-card__created-date"])
          }, z(n.createdDate), 3))
        ], 2)
      ], 6);
    };
  }
}), Kf = {
  "v-record-kanban-card": "_v-record-kanban-card_1o2ta_1",
  "v-record-kanban-card--with-record-type": "_v-record-kanban-card--with-record-type_1o2ta_22",
  "v-record-kanban-card__info": "_v-record-kanban-card__info_1o2ta_22",
  "v-record-kanban-card__title-wrapper": "_v-record-kanban-card__title-wrapper_1o2ta_33",
  "v-record-kanban-card__title-wrapper--without-record-type": "_v-record-kanban-card__title-wrapper--without-record-type_1o2ta_53",
  "v-record-kanban-card__additional-info": "_v-record-kanban-card__additional-info_1o2ta_57",
  "v-record-kanban-card__created-date": "_v-record-kanban-card__created-date_1o2ta_58",
  "v-record-kanban-card__notification": "_v-record-kanban-card__notification_1o2ta_65",
  "v-record-kanban-card__additional-info--without-record-type": "_v-record-kanban-card__additional-info--without-record-type_1o2ta_79"
}, Gf = {
  $style: Kf
}, t5 = /* @__PURE__ */ V(Wf, [["__cssModules", Gf]]), Zf = /* @__PURE__ */ Y({
  __name: "VRecordKanbanColumn",
  props: {
    statusName: {},
    statusColor: {},
    statusDescription: {},
    total: {}
  },
  setup(t) {
    const n = t, e = I(
      () => Bn(
        [String(n.total || ""), n.statusName]
      )
    );
    return (r, o) => (v(), w("div", {
      class: m(r.$style["v-record-kanban-card"])
    }, [
      g("div", {
        class: m([
          r.$style["v-record-kanban-card__status"],
          {
            [r.$style["v-record-kanban-card__status--with-tooltip"]]: r.statusDescription
          }
        ]),
        style: dt({
          color: r.statusColor,
          backgroundColor: `${r.statusColor}1F`
        })
      }, [
        Q(z(e.value) + " ", 1),
        r.statusDescription ? (v(), L(c(ft), {
          key: 0,
          content: r.statusDescription
        }, null, 8, ["content"])) : E("", !0)
      ], 6),
      H(r.$slots, "default")
    ], 2));
  }
}), Jf = {
  "v-record-kanban-card": "_v-record-kanban-card_sr88i_1",
  "v-record-kanban-card__status": "_v-record-kanban-card__status_sr88i_9",
  "v-record-kanban-card__status--with-tooltip": "_v-record-kanban-card__status--with-tooltip_sr88i_24"
}, Xf = {
  $style: Jf
}, n5 = /* @__PURE__ */ V(Zf, [["__cssModules", Xf]]), Qf = /* @__PURE__ */ Y({
  __name: "VFieldValue",
  props: {
    label: {},
    labelColor: { default: "gray" },
    value: {},
    originalValue: {}
  },
  setup(t) {
    const n = he(), e = et();
    return (r, o) => (v(), w("div", {
      class: m(c(n)["v-field-value"])
    }, [
      j(c(ma), {
        size: "small",
        color: r.labelColor,
        "with-space-bottom": !1
      }, {
        default: ee(() => [
          Q(z(r.label), 1)
        ]),
        _: 1
      }, 8, ["color"]),
      g("div", {
        class: m([
          c(n)["v-field-value__wrapper"],
          {
            [c(n)["v-field-value__wrapper--row"]]: c(e).icon
          }
        ])
      }, [
        j(c(Ht), {
          class: m(c(n)["v-field-value__value"]),
          content: r.value || "—",
          placement: "top-start",
          "hover-content": r.originalValue,
          "auto-shrink": ""
        }, null, 8, ["class", "content", "hover-content"]),
        H(r.$slots, "icon")
      ], 2)
    ], 2));
  }
}), ep = {
  "v-field-value": "_v-field-value_fvkny_1",
  "v-field-value__value": "_v-field-value__value_fvkny_12",
  "v-field-value__wrapper": "_v-field-value__wrapper_fvkny_28",
  "v-field-value__wrapper--row": "_v-field-value__wrapper--row_fvkny_50"
}, tp = {
  $style: ep
}, np = /* @__PURE__ */ V(Qf, [["__cssModules", tp]]), rp = (t) => {
  const n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t || "#000000") || [], e = {
    r: parseInt(n[1], 16),
    g: parseInt(n[2], 16),
    b: parseInt(n[3], 16)
  };
  return 0.2126 * e.r + 0.7152 * e.g + 0.0722 * e.b < 170 ? "light" : "dark";
}, op = ["onClick"], ap = /* @__PURE__ */ g("div", null, null, -1), ip = /* @__PURE__ */ Y({
  __name: "VStatusSelect",
  props: {
    activeStatus: {},
    statuses: {},
    disabled: { type: Boolean, default: !1 },
    size: { default: _a.MEDIUM },
    align: { default: ha.RIGHT },
    isColorfull: { type: Boolean, default: !1 }
  },
  emits: ["update:activeStatus"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I(
      () => e.statuses.find(({ slug: D }) => D === e.activeStatus) || null
    ), a = I(() => {
      var D;
      return ((D = o.value) == null ? void 0 : D.color) || "#000000";
    }), s = ie(!1), i = ie(null), l = ie(), d = ie(), p = () => {
      var D;
      i.value && ((D = i.value) == null || D.destroy(), i.value = null);
    };
    Ct(() => s.value, async (D) => {
      await pt(), !(!l.value || !d.value) && (D && l.value && (i.value = Mt(l.value, d.value, {
        placement: "bottom",
        modifiers: [
          kt,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }), document.body.appendChild(d.value)), !D && i.value && (p(), document.body.removeChild(d.value)));
    });
    const _ = () => {
      e.disabled || (s.value = !1);
    }, h = I(() => e.statuses.some((D) => D.description)), y = () => {
      e.disabled || (s.value = !s.value);
    }, $ = (D) => {
      D !== e.activeStatus && (r("update:activeStatus", D), _());
    }, k = ie(null);
    Fn(k, () => {
      _();
    }, {
      ignore: [d]
    });
    const M = I(() => {
      var D;
      return rp((D = o.value) == null ? void 0 : D.color);
    }), P = I(() => e.isColorfull ? {
      backgroundColor: a.value
    } : {
      color: "#2B2B2B",
      backgroundColor: `${a.value}40`
    });
    return $t(() => {
      p();
    }), (D, U) => {
      var F, G, Z, se;
      return v(), w("div", {
        ref_key: "statusSelect",
        ref: k,
        class: m([
          D.$style["v-status-select"],
          D.$style[`v-status-select--${D.size}`],
          {
            [D.$style[`v-status-select__trigger--${M.value}`]]: D.isColorfull,
            [D.$style["v-status-select--disabled"]]: D.disabled
          }
        ])
      }, [
        g("div", {
          ref_key: "trigger",
          ref: l,
          class: m([
            D.$style["v-status-select__trigger"],
            {
              [D.$style["v-status-select__trigger--open"]]: s.value,
              [D.$style["v-status-select__trigger--with-tooltip"]]: (F = o.value) == null ? void 0 : F.description
            }
          ]),
          style: dt(P.value),
          onClick: U[0] || (U[0] = (ne) => y())
        }, [
          (G = o.value) != null && G.description ? (v(), L(c(ft), {
            key: 0,
            content: (Z = o.value) == null ? void 0 : Z.description
          }, null, 8, ["content"])) : E("", !0),
          Q(" " + z((se = o.value) == null ? void 0 : se.name) + " ", 1),
          j(vt, {
            class: m(D.$style["v-status-select__toggle"])
          }, null, 8, ["class"])
        ], 6),
        s.value ? (v(), w("div", {
          key: 0,
          ref_key: "options",
          ref: d,
          class: m(D.$style["v-status-select__options"])
        }, [
          (v(!0), w(ae, null, ue(D.statuses, (ne) => (v(), w("div", {
            key: ne.slug,
            class: m([
              D.$style["v-status-select__option"],
              {
                [D.$style["v-status-select__option--without-tooltip"]]: !h.value,
                [D.$style["v-status-select__option--active"]]: ne.slug === D.activeStatus
              }
            ]),
            onClick: (fe) => $(ne.slug)
          }, [
            g("div", {
              class: m(D.$style["v-status-select__option-color"]),
              style: dt({
                backgroundColor: `${ne == null ? void 0 : ne.color}`
              })
            }, null, 6),
            Q(" " + z(ne.name) + " ", 1),
            ne != null && ne.description ? (v(), L(c(ft), {
              key: 0,
              class: m(D.$style["v-status-select__option-tooltip"]),
              content: ne == null ? void 0 : ne.description
            }, null, 8, ["class", "content"])) : E("", !0),
            ap
          ], 10, op))), 128))
        ], 2)) : E("", !0)
      ], 2);
    };
  }
}), sp = {
  "v-status-select--large": "_v-status-select--large_109fm_1",
  "v-status-select__trigger": "_v-status-select__trigger_109fm_1",
  "v-status-select__trigger--with-tooltip": "_v-status-select__trigger--with-tooltip_109fm_5",
  "v-status-select__toggle": "_v-status-select__toggle_109fm_23",
  "v-status-select__trigger--open": "_v-status-select__trigger--open_109fm_37",
  "v-status-select": "_v-status-select_109fm_1",
  "v-status-select__options": "_v-status-select__options_109fm_46",
  "v-status-select__option": "_v-status-select__option_109fm_46",
  "v-status-select__option--active": "_v-status-select__option--active_109fm_99",
  "v-status-select__option--without-tooltip": "_v-status-select__option--without-tooltip_109fm_103",
  "v-status-select--disabled": "_v-status-select--disabled_109fm_107",
  "v-status-select__option-color": "_v-status-select__option-color_109fm_123",
  "v-status-select__trigger--dark": "_v-status-select__trigger--dark_109fm_130",
  "v-status-select__trigger--light": "_v-status-select__trigger--light_109fm_134"
}, lp = {
  $style: sp
}, up = /* @__PURE__ */ V(ip, [["__cssModules", lp]]), cp = {}, dp = /* @__PURE__ */ g("path", {
  d: "M9.05116 2.89768H2.78915C2.31464 2.89768 1.85956 3.08618 1.52403 3.42171C1.1885 3.75724 1 4.21231 1 4.68682V17.2109C1 17.6854 1.1885 18.1404 1.52403 18.476C1.85956 18.8115 2.31464 19 2.78915 19H15.3132C15.7877 19 16.2428 18.8115 16.5783 18.476C16.9138 18.1404 17.1023 17.6854 17.1023 17.2109V10.9488M15.7605 1.55582C16.1163 1.19993 16.599 1 17.1023 1C17.6056 1 18.0883 1.19993 18.4442 1.55582C18.8001 1.9117 19 2.39438 19 2.89768C19 3.40097 18.8001 3.88365 18.4442 4.23954L9.94574 12.738L6.36744 13.6326L7.26201 10.0543L15.7605 1.55582Z",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), fp = [
  dp
];
function pp(t, n) {
  return v(), w("svg", De(t.$attrs, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none"
  }), fp, 16);
}
const Ba = /* @__PURE__ */ V(cp, [["render", pp]]), vp = /* @__PURE__ */ Y({
  __name: "VRecordCard",
  props: {
    activeStatus: {},
    statuses: {},
    notificationCount: {},
    title: { default: "" },
    to: { default: "" },
    isRecordTypesEnabled: { type: Boolean },
    recordType: {},
    additionalInfo: { default: () => [] },
    inStage: { default: "" },
    countOfCols: { default: 5 },
    disabled: { type: Boolean, default: !1 },
    simple: { type: Boolean, default: !1 },
    createdAt: { default: "" },
    modifiedAt: { default: "" }
  },
  emits: ["update:activeStatus", "click:edit"],
  setup(t, { emit: n }) {
    ua((_) => ({
      "1de88214": _.countOfCols
    }));
    const e = t, r = n, o = I(() => {
      const _ = [];
      return e.createdAt && _.push(`Created: ${e.createdAt}`), e.modifiedAt && _.push(`Modified: ${e.modifiedAt}`), _.join(" — ");
    }), a = ie(!1), s = I(
      () => e.statuses.find(({ slug: _ }) => _ === e.activeStatus) || null
    ), i = I(() => e.additionalInfo.length), l = (_) => {
      const h = Array.from({ length: e.countOfCols }, () => []);
      for (const y in _)
        h[Number(y) % e.countOfCols].push(_[y]);
      return h.filter((y) => y.length);
    }, d = I(() => a.value ? l(e.additionalInfo) : l(e.additionalInfo.slice(0, e.countOfCols))), p = I(() => e.additionalInfo.length > e.countOfCols);
    return (_, h) => {
      var $;
      const y = la("router-link");
      return v(), w("div", {
        class: m(_.$style["v-record-card"]),
        style: dt({
          color: (($ = s.value) == null ? void 0 : $.color) || ""
        })
      }, [
        _.notificationCount ? (v(), L(c(Wn), {
          key: 0,
          class: m(_.$style["v-record-card__notifications"]),
          content: _.notificationCount,
          variant: c(Mr).PRIMARY
        }, null, 8, ["class", "content", "variant"])) : E("", !0),
        g("div", {
          class: m(_.$style["v-record-card__wrapper"])
        }, [
          g("div", {
            class: m(_.$style["v-record-card__status-wrapper"])
          }, [
            _.simple ? E("", !0) : (v(), L(y, {
              key: 0,
              class: m(_.$style["v-record-card__link-area"]),
              to: _.to
            }, null, 8, ["class", "to"])),
            j(c(up), {
              class: m(_.$style["v-record-card__status"]),
              statuses: _.statuses,
              "active-status": _.activeStatus,
              disabled: _.disabled,
              "onUpdate:activeStatus": h[0] || (h[0] = (k) => r("update:activeStatus", k))
            }, null, 8, ["class", "statuses", "active-status", "disabled"]),
            _.simple ? E("", !0) : (v(), w("div", {
              key: 1,
              class: m(_.$style["v-record-card__title-wrapper"])
            }, [
              g("h3", null, z(_.title), 1)
            ], 2)),
            o.value ? (v(), w("div", {
              key: 2,
              class: m(_.$style["v-record-card__timestamps"])
            }, z(o.value), 3)) : E("", !0)
          ], 2),
          g("div", {
            class: m(_.$style["v-record-card__record-type-wrapper"])
          }, [
            g("p", {
              class: m(_.$style["v-record-card__days-in-stage"])
            }, " in stage: " + z(_.inStage), 3),
            _.isRecordTypesEnabled ? (v(), L(c(La), {
              key: 0,
              content: _.recordType,
              "max-length": 20
            }, null, 8, ["content"])) : E("", !0)
          ], 2)
        ], 2),
        i.value ? (v(), w("div", {
          key: 1,
          class: m([
            _.$style["v-record-card__additional-info"]
          ])
        }, [
          (v(!0), w(ae, null, ue(d.value, (k, M) => (v(), w("div", {
            key: M,
            class: m(_.$style["v-record-card__field-value-col"])
          }, [
            (v(!0), w(ae, null, ue(k, (P, D) => (v(), w("div", { key: D }, [
              j(c(np), {
                label: P.label,
                value: P.value,
                "original-value": P.forceHoverValue
              }, ct({ _: 2 }, [
                !_.disabled && P.editOptions ? {
                  name: "icon",
                  fn: ee(() => [
                    j(Ba, {
                      height: "16",
                      width: "16",
                      onClick: (U) => r("click:edit", P.editOptions)
                    }, null, 8, ["onClick"])
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["label", "value", "original-value"])
            ]))), 128))
          ], 2))), 128))
        ], 2)) : E("", !0),
        p.value ? (v(), w("div", {
          key: 2,
          class: m([
            _.$style["v-record-card__toggle"],
            {
              [_.$style["v-record-card__toggle--open"]]: a.value
            }
          ]),
          onClick: h[1] || (h[1] = (k) => a.value = !a.value)
        }, [
          j(vt)
        ], 2)) : E("", !0)
      ], 6);
    };
  }
}), hp = {
  "v-record-card": "_v-record-card_1g1q5_1",
  "v-record-card__toggle": "_v-record-card__toggle_1g1q5_14",
  "v-record-card__additional-info": "_v-record-card__additional-info_1g1q5_29",
  "v-record-card__title-wrapper": "_v-record-card__title-wrapper_1g1q5_40",
  "v-record-card__wrapper": "_v-record-card__wrapper_1g1q5_60",
  "v-record-card__days-in-stage": "_v-record-card__days-in-stage_1g1q5_66",
  "v-record-card__record-type-wrapper": "_v-record-card__record-type-wrapper_1g1q5_76",
  "v-record-card__field-value-col": "_v-record-card__field-value-col_1g1q5_118",
  "v-record-card__toggle--open": "_v-record-card__toggle--open_1g1q5_136",
  "v-record-card__status-wrapper": "_v-record-card__status-wrapper_1g1q5_140",
  "v-record-card__notifications": "_v-record-card__notifications_1g1q5_147",
  "v-record-card__link-area": "_v-record-card__link-area_1g1q5_159",
  "v-record-card__status": "_v-record-card__status_1g1q5_140",
  "v-record-card__timestamps": "_v-record-card__timestamps_1g1q5_171"
}, _p = {
  $style: hp
}, r5 = /* @__PURE__ */ V(vp, [["__cssModules", _p]]);
function dn(t) {
  return t.map((n) => ({
    ...n,
    _id: (n == null ? void 0 : n.id) || Symbol()
  }));
}
const mp = /* @__PURE__ */ Y({
  __name: "Circle",
  props: {
    height: { default: 100 },
    width: { default: 100 },
    color: { default: "rgba(0, 0, 0, 0.12)" },
    animation: { default: "wave" }
  },
  setup(t) {
    const n = t, e = I(() => `animation--${n.animation}`);
    return (r, o) => (v(), w("div", {
      class: m(["loader loader--circle", e.value]),
      style: dt({
        width: typeof r.width == "number" ? `${r.width}px` : r.width,
        height: typeof r.height == "number" ? `${r.height}px` : r.height,
        backgroundColor: r.color
      })
    }, null, 6));
  }
});
const gp = /* @__PURE__ */ V(mp, [["__scopeId", "data-v-7d6b7037"]]), bp = /* @__PURE__ */ Y({
  __name: "Straight",
  props: {
    height: { default: 100 },
    width: { default: 200 },
    color: { default: "rgba(0, 0, 0, 0.12)" },
    animation: { default: "wave" },
    type: { default: "rect" },
    rounded: { type: Boolean, default: !1 },
    radius: { default: 0 }
  },
  setup(t) {
    const n = t, e = I(() => `animation--${n.animation} shape--${n.type} shape--${n.rounded ? "round" : "flat"}`);
    return (r, o) => (v(), w("div", {
      class: m(["loader", e.value]),
      style: dt({
        width: typeof r.width == "number" ? `${r.width}px` : r.width,
        height: typeof r.height == "number" ? `${r.height}px` : r.height,
        backgroundColor: r.color,
        borderRadius: r.rounded ? `${r.radius}px` : 0
      })
    }, null, 6));
  }
});
const yp = /* @__PURE__ */ V(bp, [["__scopeId", "data-v-3ea0ad73"]]), at = /* @__PURE__ */ Y({
  __name: "VSkeletonLoader",
  props: {
    type: { default: "rect" },
    size: {},
    animation: { default: "wave" },
    height: {},
    width: {},
    color: { default: "var(--v-text-secondary-light-color)" },
    waveColor: { default: "var(--v-skeleton-wave-color)" },
    rounded: { type: Boolean, default: !0 },
    radius: { default: 4 }
  },
  setup(t) {
    const n = t, e = I(() => n.size || n.width), r = I(() => n.size || n.height);
    return (o, a) => o.type === "circle" ? (v(), L(gp, {
      key: 0,
      width: e.value,
      height: r.value,
      animation: o.animation,
      color: o.color
    }, null, 8, ["width", "height", "animation", "color"])) : (v(), L(yp, {
      key: 1,
      width: e.value,
      height: r.value,
      animation: o.animation,
      type: o.type,
      color: o.color,
      rounded: o.rounded,
      radius: o.radius
    }, null, 8, ["width", "height", "animation", "type", "color", "rounded", "radius"]));
  }
});
const wp = {}, Cp = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, $p = /* @__PURE__ */ g("g", { fill: "none" }, [
  /* @__PURE__ */ g("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
    fill: "currentColor"
  })
], -1), kp = [
  $p
];
function Mp(t, n) {
  return v(), w("svg", Cp, kp);
}
const Va = /* @__PURE__ */ V(wp, [["render", Mp]]), Dp = { key: 0 }, Sp = { key: 1 }, Op = { key: 1 }, Tp = ["colspan"], Ap = /* @__PURE__ */ Y({
  __name: "TableComponent",
  props: {
    cols: {},
    rows: {},
    isSortEnabled: { type: Boolean },
    sort: {},
    loading: { type: Boolean },
    rowTextMaxLength: {},
    isDraggable: { type: Boolean },
    emptyValue: { default: "Nothing to see here..." },
    fixedTopElement: { type: Boolean }
  },
  emits: ["update:sort", "reorder"],
  setup(t, { emit: n }) {
    const e = et(), r = t, o = n, a = I(() => dn(r.cols)), s = I(() => dn(r.rows)), i = (h) => {
      var y, $;
      if (r.isSortEnabled)
        return !r.sort || ((y = r.sort) == null ? void 0 : y.key) !== h ? o("update:sort", {
          key: h,
          type: "asc"
        }) : (($ = r.sort) == null ? void 0 : $.type) === "asc" ? o("update:sort", {
          key: h,
          type: "desc"
        }) : o("update:sort", null);
    }, l = (h) => {
      var y;
      return h !== ((y = r.sort) == null ? void 0 : y.key) ? "none" : r.sort.type === "asc" ? "ascending" : r.sort.type === "desc" ? "descending" : "none";
    }, d = I(() => s.value.length || 3), p = (h) => {
      o("reorder", h.map((y) => da(y, ["_id"])));
    }, _ = he();
    return (h, y) => (v(), w("table", {
      class: m(c(_)["v-table"])
    }, [
      g("thead", null, [
        g("tr", null, [
          h.isDraggable ? (v(), w("th", {
            key: 0,
            class: m(c(_)["v-table__drag"])
          }, null, 2)) : E("", !0),
          (v(!0), w(ae, null, ue(a.value, ($) => (v(), w("th", De({
            key: $._id,
            ref_for: !0
          }, h.isSortEnabled ? {
            "aria-sort": l($.key)
          } : {}, aa(h.isSortEnabled ? {
            click: () => i($.key)
          } : {}, !0)), [
            g("div", {
              class: m(c(_)["v-table__th-content"])
            }, [
              g("div", {
                class: m(c(_)["v-table__title"])
              }, [
                H(h.$slots, "col-left", {}, () => [
                  $.helpText ? (v(), L(c(ft), {
                    key: 0,
                    placement: "right",
                    content: $.helpText
                  }, null, 8, ["content"])) : E("", !0)
                ]),
                Q(" " + z($.title), 1)
              ], 2),
              $.title && h.isSortEnabled ? (v(), L(vt, {
                key: 0,
                class: m(c(_)["v-table__sort-icon"])
              }, null, 8, ["class"])) : E("", !0)
            ], 2)
          ], 16))), 128))
        ])
      ]),
      h.isDraggable ? (v(), L(c(fa), {
        key: 0,
        tag: "tbody",
        "model-value": s.value,
        "item-key": "_id",
        handle: ".draggable-handle",
        "onUpdate:modelValue": y[0] || (y[0] = ($) => p($))
      }, ct({
        item: ee(({ element: $, index: k }) => [
          h.loading ? E("", !0) : (v(), w("tr", Dp, [
            g("td", {
              class: m(c(_)["v-table__drag"])
            }, [
              !h.fixedTopElement || k > 0 ? (v(), L(Va, {
                key: 0,
                class: "draggable-handle"
              })) : E("", !0)
            ], 2),
            (v(!0), w(ae, null, ue(a.value, (M) => (v(), w("td", {
              key: M._id
            }, [
              c(e)[M.key] ? H(h.$slots, M.key, De({
                key: 0,
                ref_for: !0
              }, $)) : H(h.$slots, "default", De({
                key: 1,
                ref_for: !0
              }, {
                row: $,
                col: M
              }), () => [
                j(c(Ht), {
                  "max-length": h.rowTextMaxLength,
                  content: String($[M.key] || "—")
                }, null, 8, ["max-length", "content"])
              ])
            ]))), 128))
          ]))
        ]),
        _: 2
      }, [
        h.loading ? {
          name: "footer",
          fn: ee(() => [
            (v(!0), w(ae, null, ue(d.value, ($) => (v(), w("tr", { key: $ }, [
              g("td", null, [
                j(c(at), {
                  width: "100%",
                  height: "20px"
                })
              ]),
              (v(!0), w(ae, null, ue(a.value, (k) => (v(), w("td", {
                key: k._id
              }, [
                j(c(at), {
                  width: "100%",
                  height: "20px"
                })
              ]))), 128))
            ]))), 128))
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["model-value"])) : (v(), w("tbody", Sp, [
        h.loading ? (v(!0), w(ae, { key: 0 }, ue(d.value, ($) => (v(), w("tr", { key: $ }, [
          (v(!0), w(ae, null, ue(a.value, (k) => (v(), w("td", {
            key: k._id
          }, [
            j(c(at), {
              width: "100%",
              height: "20px"
            })
          ]))), 128))
        ]))), 128)) : s.value.length ? (v(!0), w(ae, { key: 2 }, ue(s.value, ($) => (v(), w("tr", {
          key: $._id
        }, [
          (v(!0), w(ae, null, ue(a.value, (k) => (v(), w("td", {
            key: k._id
          }, [
            c(e)[k.key] ? H(h.$slots, k.key, De({
              key: 0,
              ref_for: !0
            }, $)) : H(h.$slots, "default", De({
              key: 1,
              ref_for: !0
            }, {
              row: $,
              col: k
            }), () => [
              j(c(Ht), {
                "max-length": h.rowTextMaxLength,
                content: String($[k.key] || "—")
              }, null, 8, ["max-length", "content"])
            ])
          ]))), 128))
        ]))), 128)) : (v(), w("tr", Op, [
          g("td", {
            colspan: a.value.length + Number(h.isDraggable),
            class: m(c(_)["v-table__empty"])
          }, [
            H(h.$slots, "emptyValue", {}, () => [
              Q(z(h.emptyValue), 1)
            ])
          ], 10, Tp)
        ]))
      ]))
    ], 2));
  }
}), Ep = "_td_5sn2w_9", xp = {
  "v-table": "_v-table_5sn2w_1",
  td: Ep,
  "v-table__drag": "_v-table__drag_5sn2w_33",
  "v-table__empty": "_v-table__empty_5sn2w_45",
  "v-table__th-content": "_v-table__th-content_5sn2w_48",
  "v-table__sort-icon": "_v-table__sort-icon_5sn2w_64",
  "v-table__title": "_v-table__title_5sn2w_87"
}, Ip = {
  $style: xp
}, Lp = /* @__PURE__ */ V(Ap, [["__cssModules", Ip]]), Bp = /* @__PURE__ */ Y({
  __name: "CardComponent",
  props: {
    cols: {},
    row: {},
    loading: { type: Boolean },
    rowTextMaxLength: {},
    isDraggable: { type: Boolean },
    cardTitle: {}
  },
  setup(t) {
    const n = t, e = I(() => n.cols.find((i) => i.key === "actions")), r = I(() => !!(e.value || n.isDraggable || n.cardTitle)), o = I(() => dn(
      n.cols.filter(
        (i) => !["actions"].includes(i.key)
      )
    )), a = et(), s = he();
    return (i, l) => (v(), w("div", {
      class: m(c(s)["v-table-card"])
    }, [
      g("div", {
        class: m(c(s)["v-table-card__row"])
      }, [
        r.value ? (v(), w("div", {
          key: 0,
          class: m([c(s)["v-table-card__label"], c(s)["v-table-card__label--header"]])
        }, [
          i.isDraggable ? (v(), L(Va, {
            key: 0,
            class: "draggable-handle"
          })) : E("", !0),
          i.cardTitle ? (v(), w("h3", {
            key: 1,
            class: m(c(s)["v-table-card__title"])
          }, z(i.cardTitle), 3)) : E("", !0)
        ], 2)) : E("", !0),
        g("div", {
          class: m(c(s)["v-table-card__value"])
        }, [
          e.value ? H(i.$slots, "actions", Me(De({ key: 0 }, i.row))) : E("", !0)
        ], 2)
      ], 2),
      (v(!0), w(ae, null, ue(o.value, (d) => (v(), w("div", {
        key: d._id,
        class: m(c(s)["v-table-card__row"])
      }, [
        g("div", {
          class: m(c(s)["v-table-card__label"])
        }, [
          H(i.$slots, "col-left", {}, () => [
            d.helpText ? (v(), L(c(ft), {
              key: 0,
              placement: "right",
              content: d.helpText
            }, null, 8, ["content"])) : E("", !0)
          ]),
          Q(" " + z(d.title), 1)
        ], 2),
        g("div", {
          class: m(c(s)["v-table-card__value"])
        }, [
          c(a)[d.key] ? H(i.$slots, d.key, De({
            key: 0,
            ref_for: !0
          }, i.row)) : H(i.$slots, "default", De({
            key: 1,
            ref_for: !0
          }, {
            row: i.row,
            col: d
          }), () => [
            j(c(Ht), {
              "max-length": i.rowTextMaxLength,
              content: String(i.row[d.key] || "—")
            }, null, 8, ["max-length", "content"])
          ])
        ], 2)
      ], 2))), 128))
    ], 2));
  }
}), Vp = {
  "v-table-card": "_v-table-card_1gl58_1",
  "v-table-card__row": "_v-table-card__row_1gl58_8",
  "v-table-card__label": "_v-table-card__label_1gl58_18",
  "v-table-card__label--header": "_v-table-card__label--header_1gl58_31",
  "v-table-card__value": "_v-table-card__value_1gl58_43",
  "v-table-card__title": "_v-table-card__title_1gl58_53"
}, Pp = {
  $style: Vp
}, wo = /* @__PURE__ */ V(Bp, [["__cssModules", Pp]]), jp = /* @__PURE__ */ Y({
  __name: "CardsComponent",
  props: {
    cols: {},
    rows: {},
    loading: { type: Boolean },
    rowTextMaxLength: {},
    isDraggable: { type: Boolean },
    cardTitle: {},
    fixedTopElement: { type: Boolean }
  },
  emits: ["reorder"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = et(), a = I(() => dn(e.rows)), s = (l) => {
      r("reorder", l.map((d) => da(d, ["_id"])));
    }, i = he();
    return (l, d) => l.isDraggable ? (v(), L(c(fa), {
      key: 0,
      tag: "div",
      class: m(c(i)["v-table-cards"]),
      "model-value": a.value,
      "item-key": "_id",
      handle: ".draggable-handle",
      "onUpdate:modelValue": d[0] || (d[0] = (p) => s(p))
    }, {
      item: ee(({ element: p, index: _ }) => [
        j(wo, {
          row: p,
          cols: l.cols,
          "card-title": l.cardTitle,
          "is-draggable": l.isDraggable && (!l.fixedTopElement || _ > 0),
          loading: l.loading,
          "row-text-max-length": l.rowTextMaxLength
        }, ct({ _: 2 }, [
          ue(c(o), (h, y) => ({
            name: y,
            fn: ee(($) => [
              H(l.$slots, y, Me(Te($)))
            ])
          }))
        ]), 1032, ["row", "cols", "card-title", "is-draggable", "loading", "row-text-max-length"])
      ]),
      _: 3
    }, 8, ["class", "model-value"])) : (v(), w("div", {
      key: 1,
      class: m(c(i)["v-table-cards"])
    }, [
      (v(!0), w(ae, null, ue(a.value, (p) => (v(), L(wo, {
        key: p._id,
        row: p,
        "card-title": l.cardTitle,
        "is-draggable": l.isDraggable,
        loading: l.loading,
        "row-text-max-length": l.rowTextMaxLength,
        cols: l.cols
      }, ct({ _: 2 }, [
        ue(c(o), (_, h) => ({
          name: h,
          fn: ee((y) => [
            H(l.$slots, h, De({ ref_for: !0 }, y))
          ])
        }))
      ]), 1032, ["row", "card-title", "is-draggable", "loading", "row-text-max-length", "cols"]))), 128))
    ], 2));
  }
}), Np = {
  "v-table-cards": "_v-table-cards_jd9vj_1"
}, Fp = {
  $style: Np
}, Rp = /* @__PURE__ */ V(jp, [["__cssModules", Fp]]), o5 = /* @__PURE__ */ Y({
  __name: "VTable",
  props: {
    cols: {},
    rows: {},
    isSortEnabled: { type: Boolean, default: !1 },
    sort: { default: null },
    loading: { type: Boolean, default: !1 },
    rowTextMaxLength: { default: 15 },
    isDraggable: { type: Boolean, default: !1 },
    isMobile: { type: Boolean, default: !1 },
    cardTitle: {},
    fixedTopElement: { type: Boolean, default: !1 }
  },
  emits: ["update:sort", "reorder"],
  setup(t, { emit: n }) {
    const e = et(), r = n;
    return (o, a) => o.isMobile ? (v(), L(Rp, {
      key: 0,
      cols: o.cols,
      rows: o.rows,
      "card-title": o.cardTitle,
      loading: o.loading,
      "row-text-max-length": o.rowTextMaxLength,
      "is-draggable": o.isDraggable,
      "fixed-top-element": o.fixedTopElement,
      onReorder: a[0] || (a[0] = (s) => r("reorder", s))
    }, ct({ _: 2 }, [
      ue(c(e), (s, i) => ({
        name: i,
        fn: ee((l) => [
          H(o.$slots, i, Me(Te(l)))
        ])
      }))
    ]), 1032, ["cols", "rows", "card-title", "loading", "row-text-max-length", "is-draggable", "fixed-top-element"])) : (v(), L(Lp, {
      key: 1,
      cols: o.cols,
      rows: o.rows,
      sort: o.sort,
      "is-sort-enabled": o.isSortEnabled,
      loading: o.loading,
      "row-text-max-length": o.rowTextMaxLength,
      "is-draggable": o.isDraggable,
      "fixed-top-element": o.fixedTopElement,
      "onUpdate:sort": a[1] || (a[1] = (s) => r("update:sort", s)),
      onReorder: a[2] || (a[2] = (s) => r("reorder", s))
    }, ct({ _: 2 }, [
      ue(c(e), (s, i) => ({
        name: i,
        fn: ee((l) => [
          H(o.$slots, i, Me(Te(l)))
        ])
      }))
    ]), 1032, ["cols", "rows", "sort", "is-sort-enabled", "loading", "row-text-max-length", "is-draggable", "fixed-top-element"]));
  }
}), Hp = /* @__PURE__ */ Y({
  __name: "VSkeletonRecordsPage",
  props: {
    isRecordTypesEnabled: { type: Boolean, default: !1 },
    countOfCols: { default: 5 }
  },
  setup(t) {
    return (n, e) => (v(), w("div", {
      class: m(n.$style["v-skeleton-records-cards"])
    }, [
      (v(), w(ae, null, ue(6, (r) => g("div", {
        key: r,
        class: m(n.$style["v-skeleton-records-cards__card"])
      }, [
        g("div", {
          class: m(n.$style["v-skeleton-records-cards__header"])
        }, [
          g("div", {
            class: m(n.$style["v-skeleton-records-cards__status-wrapper"])
          }, [
            j(c(at), {
              height: "28px",
              width: "110px",
              radius: 20
            }),
            j(c(at), {
              class: m(n.$style["v-skeleton-records-cards__header-title"]),
              height: "24px",
              width: "max(60%, 150px)"
            }, null, 8, ["class"])
          ], 2),
          g("div", {
            class: m(n.$style["v-skeleton-records-cards__record-type-wrapper"])
          }, [
            j(c(at), {
              height: "18px",
              width: "90px"
            }),
            n.isRecordTypesEnabled ? (v(), L(c(at), {
              key: 0,
              height: "24px",
              width: "95px",
              radius: 24
            })) : E("", !0)
          ], 2)
        ], 2),
        g("div", {
          class: m(n.$style["v-skeleton-records-cards__body"])
        }, [
          (v(!0), w(ae, null, ue(n.countOfCols, (o) => (v(), w("div", {
            key: o,
            class: m(n.$style["v-skeleton-records-cards__field-value"])
          }, [
            j(c(at), {
              height: "15px",
              width: "100%"
            }),
            j(c(at), {
              height: "18px",
              width: "70%"
            })
          ], 2))), 128))
        ], 2)
      ], 2)), 64))
    ], 2));
  }
}), zp = {
  "v-skeleton-records-cards": "_v-skeleton-records-cards_1mh17_1",
  "v-skeleton-records-cards__card": "_v-skeleton-records-cards__card_1mh17_13",
  "v-skeleton-records-cards__header-title-wrapper": "_v-skeleton-records-cards__header-title-wrapper_1mh17_35",
  "v-skeleton-records-cards__header": "_v-skeleton-records-cards__header_1mh17_35",
  "v-skeleton-records-cards__record-type-wrapper": "_v-skeleton-records-cards__record-type-wrapper_1mh17_47",
  "v-skeleton-records-cards__status-wrapper": "_v-skeleton-records-cards__status-wrapper_1mh17_55",
  "v-skeleton-records-cards__body": "_v-skeleton-records-cards__body_1mh17_61",
  "v-skeleton-records-cards__field-value": "_v-skeleton-records-cards__field-value_1mh17_73"
}, Yp = {
  $style: zp
}, a5 = /* @__PURE__ */ V(Hp, [["__cssModules", Yp]]);
function Up(t, n) {
  for (var e = -1, r = t == null ? 0 : t.length, o = Array(r); ++e < r; )
    o[e] = n(t[e], e, t);
  return o;
}
var Pa = Up;
function qp() {
  this.__data__ = [], this.size = 0;
}
var Wp = qp;
function Kp(t, n) {
  return t === n || t !== t && n !== n;
}
var ja = Kp, Gp = ja;
function Zp(t, n) {
  for (var e = t.length; e--; )
    if (Gp(t[e][0], n))
      return e;
  return -1;
}
var Kn = Zp, Jp = Kn, Xp = Array.prototype, Qp = Xp.splice;
function e1(t) {
  var n = this.__data__, e = Jp(n, t);
  if (e < 0)
    return !1;
  var r = n.length - 1;
  return e == r ? n.pop() : Qp.call(n, e, 1), --this.size, !0;
}
var t1 = e1, n1 = Kn;
function r1(t) {
  var n = this.__data__, e = n1(n, t);
  return e < 0 ? void 0 : n[e][1];
}
var o1 = r1, a1 = Kn;
function i1(t) {
  return a1(this.__data__, t) > -1;
}
var s1 = i1, l1 = Kn;
function u1(t, n) {
  var e = this.__data__, r = l1(e, t);
  return r < 0 ? (++this.size, e.push([t, n])) : e[r][1] = n, this;
}
var c1 = u1, d1 = Wp, f1 = t1, p1 = o1, v1 = s1, h1 = c1;
function zt(t) {
  var n = -1, e = t == null ? 0 : t.length;
  for (this.clear(); ++n < e; ) {
    var r = t[n];
    this.set(r[0], r[1]);
  }
}
zt.prototype.clear = d1;
zt.prototype.delete = f1;
zt.prototype.get = p1;
zt.prototype.has = v1;
zt.prototype.set = h1;
var Gn = zt, _1 = Gn;
function m1() {
  this.__data__ = new _1(), this.size = 0;
}
var g1 = m1;
function b1(t) {
  var n = this.__data__, e = n.delete(t);
  return this.size = n.size, e;
}
var y1 = b1;
function w1(t) {
  return this.__data__.get(t);
}
var C1 = w1;
function $1(t) {
  return this.__data__.has(t);
}
var k1 = $1, M1 = typeof tn == "object" && tn && tn.Object === Object && tn, Na = M1, D1 = Na, S1 = typeof self == "object" && self && self.Object === Object && self, O1 = D1 || S1 || Function("return this")(), tt = O1, T1 = tt, A1 = T1.Symbol, vn = A1, Co = vn, Fa = Object.prototype, E1 = Fa.hasOwnProperty, x1 = Fa.toString, en = Co ? Co.toStringTag : void 0;
function I1(t) {
  var n = E1.call(t, en), e = t[en];
  try {
    t[en] = void 0;
    var r = !0;
  } catch {
  }
  var o = x1.call(t);
  return r && (n ? t[en] = e : delete t[en]), o;
}
var L1 = I1, B1 = Object.prototype, V1 = B1.toString;
function P1(t) {
  return V1.call(t);
}
var j1 = P1, $o = vn, N1 = L1, F1 = j1, R1 = "[object Null]", H1 = "[object Undefined]", ko = $o ? $o.toStringTag : void 0;
function z1(t) {
  return t == null ? t === void 0 ? H1 : R1 : ko && ko in Object(t) ? N1(t) : F1(t);
}
var Yt = z1;
function Y1(t) {
  var n = typeof t;
  return t != null && (n == "object" || n == "function");
}
var hn = Y1, U1 = Yt, q1 = hn, W1 = "[object AsyncFunction]", K1 = "[object Function]", G1 = "[object GeneratorFunction]", Z1 = "[object Proxy]";
function J1(t) {
  if (!q1(t))
    return !1;
  var n = U1(t);
  return n == K1 || n == G1 || n == W1 || n == Z1;
}
var Ra = J1, X1 = tt, Q1 = X1["__core-js_shared__"], ev = Q1, ur = ev, Mo = function() {
  var t = /[^.]+$/.exec(ur && ur.keys && ur.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function tv(t) {
  return !!Mo && Mo in t;
}
var nv = tv, rv = Function.prototype, ov = rv.toString;
function av(t) {
  if (t != null) {
    try {
      return ov.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var Ha = av, iv = Ra, sv = nv, lv = hn, uv = Ha, cv = /[\\^$.*+?()[\]{}|]/g, dv = /^\[object .+?Constructor\]$/, fv = Function.prototype, pv = Object.prototype, vv = fv.toString, hv = pv.hasOwnProperty, _v = RegExp(
  "^" + vv.call(hv).replace(cv, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function mv(t) {
  if (!lv(t) || sv(t))
    return !1;
  var n = iv(t) ? _v : dv;
  return n.test(uv(t));
}
var gv = mv;
function bv(t, n) {
  return t == null ? void 0 : t[n];
}
var yv = bv, wv = gv, Cv = yv;
function $v(t, n) {
  var e = Cv(t, n);
  return wv(e) ? e : void 0;
}
var Dt = $v, kv = Dt, Mv = tt, Dv = kv(Mv, "Map"), Br = Dv, Sv = Dt, Ov = Sv(Object, "create"), Zn = Ov, Do = Zn;
function Tv() {
  this.__data__ = Do ? Do(null) : {}, this.size = 0;
}
var Av = Tv;
function Ev(t) {
  var n = this.has(t) && delete this.__data__[t];
  return this.size -= n ? 1 : 0, n;
}
var xv = Ev, Iv = Zn, Lv = "__lodash_hash_undefined__", Bv = Object.prototype, Vv = Bv.hasOwnProperty;
function Pv(t) {
  var n = this.__data__;
  if (Iv) {
    var e = n[t];
    return e === Lv ? void 0 : e;
  }
  return Vv.call(n, t) ? n[t] : void 0;
}
var jv = Pv, Nv = Zn, Fv = Object.prototype, Rv = Fv.hasOwnProperty;
function Hv(t) {
  var n = this.__data__;
  return Nv ? n[t] !== void 0 : Rv.call(n, t);
}
var zv = Hv, Yv = Zn, Uv = "__lodash_hash_undefined__";
function qv(t, n) {
  var e = this.__data__;
  return this.size += this.has(t) ? 0 : 1, e[t] = Yv && n === void 0 ? Uv : n, this;
}
var Wv = qv, Kv = Av, Gv = xv, Zv = jv, Jv = zv, Xv = Wv;
function Ut(t) {
  var n = -1, e = t == null ? 0 : t.length;
  for (this.clear(); ++n < e; ) {
    var r = t[n];
    this.set(r[0], r[1]);
  }
}
Ut.prototype.clear = Kv;
Ut.prototype.delete = Gv;
Ut.prototype.get = Zv;
Ut.prototype.has = Jv;
Ut.prototype.set = Xv;
var Qv = Ut, So = Qv, eh = Gn, th = Br;
function nh() {
  this.size = 0, this.__data__ = {
    hash: new So(),
    map: new (th || eh)(),
    string: new So()
  };
}
var rh = nh;
function oh(t) {
  var n = typeof t;
  return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
}
var ah = oh, ih = ah;
function sh(t, n) {
  var e = t.__data__;
  return ih(n) ? e[typeof n == "string" ? "string" : "hash"] : e.map;
}
var Jn = sh, lh = Jn;
function uh(t) {
  var n = lh(this, t).delete(t);
  return this.size -= n ? 1 : 0, n;
}
var ch = uh, dh = Jn;
function fh(t) {
  return dh(this, t).get(t);
}
var ph = fh, vh = Jn;
function hh(t) {
  return vh(this, t).has(t);
}
var _h = hh, mh = Jn;
function gh(t, n) {
  var e = mh(this, t), r = e.size;
  return e.set(t, n), this.size += e.size == r ? 0 : 1, this;
}
var bh = gh, yh = rh, wh = ch, Ch = ph, $h = _h, kh = bh;
function qt(t) {
  var n = -1, e = t == null ? 0 : t.length;
  for (this.clear(); ++n < e; ) {
    var r = t[n];
    this.set(r[0], r[1]);
  }
}
qt.prototype.clear = yh;
qt.prototype.delete = wh;
qt.prototype.get = Ch;
qt.prototype.has = $h;
qt.prototype.set = kh;
var za = qt, Mh = Gn, Dh = Br, Sh = za, Oh = 200;
function Th(t, n) {
  var e = this.__data__;
  if (e instanceof Mh) {
    var r = e.__data__;
    if (!Dh || r.length < Oh - 1)
      return r.push([t, n]), this.size = ++e.size, this;
    e = this.__data__ = new Sh(r);
  }
  return e.set(t, n), this.size = e.size, this;
}
var Ah = Th, Eh = Gn, xh = g1, Ih = y1, Lh = C1, Bh = k1, Vh = Ah;
function Wt(t) {
  var n = this.__data__ = new Eh(t);
  this.size = n.size;
}
Wt.prototype.clear = xh;
Wt.prototype.delete = Ih;
Wt.prototype.get = Lh;
Wt.prototype.has = Bh;
Wt.prototype.set = Vh;
var Ph = Wt;
function jh(t, n) {
  for (var e = -1, r = t == null ? 0 : t.length; ++e < r && n(t[e], e, t) !== !1; )
    ;
  return t;
}
var Nh = jh, Fh = Dt, Rh = function() {
  try {
    var t = Fh(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), Ya = Rh, Oo = Ya;
function Hh(t, n, e) {
  n == "__proto__" && Oo ? Oo(t, n, {
    configurable: !0,
    enumerable: !0,
    value: e,
    writable: !0
  }) : t[n] = e;
}
var Ua = Hh, zh = Ua, Yh = ja, Uh = Object.prototype, qh = Uh.hasOwnProperty;
function Wh(t, n, e) {
  var r = t[n];
  (!(qh.call(t, n) && Yh(r, e)) || e === void 0 && !(n in t)) && zh(t, n, e);
}
var qa = Wh, Kh = qa, Gh = Ua;
function Zh(t, n, e, r) {
  var o = !e;
  e || (e = {});
  for (var a = -1, s = n.length; ++a < s; ) {
    var i = n[a], l = r ? r(e[i], t[i], i, e, t) : void 0;
    l === void 0 && (l = t[i]), o ? Gh(e, i, l) : Kh(e, i, l);
  }
  return e;
}
var _n = Zh;
function Jh(t, n) {
  for (var e = -1, r = Array(t); ++e < t; )
    r[e] = n(e);
  return r;
}
var Xh = Jh;
function Qh(t) {
  return t != null && typeof t == "object";
}
var St = Qh, e_ = Yt, t_ = St, n_ = "[object Arguments]";
function r_(t) {
  return t_(t) && e_(t) == n_;
}
var o_ = r_, To = o_, a_ = St, Wa = Object.prototype, i_ = Wa.hasOwnProperty, s_ = Wa.propertyIsEnumerable, l_ = To(function() {
  return arguments;
}()) ? To : function(t) {
  return a_(t) && i_.call(t, "callee") && !s_.call(t, "callee");
}, Ka = l_, u_ = Array.isArray, Ot = u_, Vn = { exports: {} };
function c_() {
  return !1;
}
var d_ = c_;
Vn.exports;
(function(t, n) {
  var e = tt, r = d_, o = n && !n.nodeType && n, a = o && !0 && t && !t.nodeType && t, s = a && a.exports === o, i = s ? e.Buffer : void 0, l = i ? i.isBuffer : void 0, d = l || r;
  t.exports = d;
})(Vn, Vn.exports);
var Ga = Vn.exports, f_ = 9007199254740991, p_ = /^(?:0|[1-9]\d*)$/;
function v_(t, n) {
  var e = typeof t;
  return n = n ?? f_, !!n && (e == "number" || e != "symbol" && p_.test(t)) && t > -1 && t % 1 == 0 && t < n;
}
var h_ = v_, __ = 9007199254740991;
function m_(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= __;
}
var Za = m_, g_ = Yt, b_ = Za, y_ = St, w_ = "[object Arguments]", C_ = "[object Array]", $_ = "[object Boolean]", k_ = "[object Date]", M_ = "[object Error]", D_ = "[object Function]", S_ = "[object Map]", O_ = "[object Number]", T_ = "[object Object]", A_ = "[object RegExp]", E_ = "[object Set]", x_ = "[object String]", I_ = "[object WeakMap]", L_ = "[object ArrayBuffer]", B_ = "[object DataView]", V_ = "[object Float32Array]", P_ = "[object Float64Array]", j_ = "[object Int8Array]", N_ = "[object Int16Array]", F_ = "[object Int32Array]", R_ = "[object Uint8Array]", H_ = "[object Uint8ClampedArray]", z_ = "[object Uint16Array]", Y_ = "[object Uint32Array]", ye = {};
ye[V_] = ye[P_] = ye[j_] = ye[N_] = ye[F_] = ye[R_] = ye[H_] = ye[z_] = ye[Y_] = !0;
ye[w_] = ye[C_] = ye[L_] = ye[$_] = ye[B_] = ye[k_] = ye[M_] = ye[D_] = ye[S_] = ye[O_] = ye[T_] = ye[A_] = ye[E_] = ye[x_] = ye[I_] = !1;
function U_(t) {
  return y_(t) && b_(t.length) && !!ye[g_(t)];
}
var q_ = U_;
function W_(t) {
  return function(n) {
    return t(n);
  };
}
var Vr = W_, Pn = { exports: {} };
Pn.exports;
(function(t, n) {
  var e = Na, r = n && !n.nodeType && n, o = r && !0 && t && !t.nodeType && t, a = o && o.exports === r, s = a && e.process, i = function() {
    try {
      var l = o && o.require && o.require("util").types;
      return l || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  t.exports = i;
})(Pn, Pn.exports);
var Pr = Pn.exports, K_ = q_, G_ = Vr, Ao = Pr, Eo = Ao && Ao.isTypedArray, Z_ = Eo ? G_(Eo) : K_, J_ = Z_, X_ = Xh, Q_ = Ka, em = Ot, tm = Ga, nm = h_, rm = J_, om = Object.prototype, am = om.hasOwnProperty;
function im(t, n) {
  var e = em(t), r = !e && Q_(t), o = !e && !r && tm(t), a = !e && !r && !o && rm(t), s = e || r || o || a, i = s ? X_(t.length, String) : [], l = i.length;
  for (var d in t)
    (n || am.call(t, d)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    nm(d, l))) && i.push(d);
  return i;
}
var Ja = im, sm = Object.prototype;
function lm(t) {
  var n = t && t.constructor, e = typeof n == "function" && n.prototype || sm;
  return t === e;
}
var jr = lm;
function um(t, n) {
  return function(e) {
    return t(n(e));
  };
}
var Xa = um, cm = Xa, dm = cm(Object.keys, Object), fm = dm, pm = jr, vm = fm, hm = Object.prototype, _m = hm.hasOwnProperty;
function mm(t) {
  if (!pm(t))
    return vm(t);
  var n = [];
  for (var e in Object(t))
    _m.call(t, e) && e != "constructor" && n.push(e);
  return n;
}
var gm = mm, bm = Ra, ym = Za;
function wm(t) {
  return t != null && ym(t.length) && !bm(t);
}
var Qa = wm, Cm = Ja, $m = gm, km = Qa;
function Mm(t) {
  return km(t) ? Cm(t) : $m(t);
}
var Nr = Mm, Dm = _n, Sm = Nr;
function Om(t, n) {
  return t && Dm(n, Sm(n), t);
}
var Tm = Om;
function Am(t) {
  var n = [];
  if (t != null)
    for (var e in Object(t))
      n.push(e);
  return n;
}
var Em = Am, xm = hn, Im = jr, Lm = Em, Bm = Object.prototype, Vm = Bm.hasOwnProperty;
function Pm(t) {
  if (!xm(t))
    return Lm(t);
  var n = Im(t), e = [];
  for (var r in t)
    r == "constructor" && (n || !Vm.call(t, r)) || e.push(r);
  return e;
}
var jm = Pm, Nm = Ja, Fm = jm, Rm = Qa;
function Hm(t) {
  return Rm(t) ? Nm(t, !0) : Fm(t);
}
var Fr = Hm, zm = _n, Ym = Fr;
function Um(t, n) {
  return t && zm(n, Ym(n), t);
}
var qm = Um, jn = { exports: {} };
jn.exports;
(function(t, n) {
  var e = tt, r = n && !n.nodeType && n, o = r && !0 && t && !t.nodeType && t, a = o && o.exports === r, s = a ? e.Buffer : void 0, i = s ? s.allocUnsafe : void 0;
  function l(d, p) {
    if (p)
      return d.slice();
    var _ = d.length, h = i ? i(_) : new d.constructor(_);
    return d.copy(h), h;
  }
  t.exports = l;
})(jn, jn.exports);
var Wm = jn.exports;
function Km(t, n) {
  var e = -1, r = t.length;
  for (n || (n = Array(r)); ++e < r; )
    n[e] = t[e];
  return n;
}
var Gm = Km;
function Zm(t, n) {
  for (var e = -1, r = t == null ? 0 : t.length, o = 0, a = []; ++e < r; ) {
    var s = t[e];
    n(s, e, t) && (a[o++] = s);
  }
  return a;
}
var Jm = Zm;
function Xm() {
  return [];
}
var ei = Xm, Qm = Jm, eg = ei, tg = Object.prototype, ng = tg.propertyIsEnumerable, xo = Object.getOwnPropertySymbols, rg = xo ? function(t) {
  return t == null ? [] : (t = Object(t), Qm(xo(t), function(n) {
    return ng.call(t, n);
  }));
} : eg, Rr = rg, og = _n, ag = Rr;
function ig(t, n) {
  return og(t, ag(t), n);
}
var sg = ig;
function lg(t, n) {
  for (var e = -1, r = n.length, o = t.length; ++e < r; )
    t[o + e] = n[e];
  return t;
}
var Hr = lg, ug = Xa, cg = ug(Object.getPrototypeOf, Object), zr = cg, dg = Hr, fg = zr, pg = Rr, vg = ei, hg = Object.getOwnPropertySymbols, _g = hg ? function(t) {
  for (var n = []; t; )
    dg(n, pg(t)), t = fg(t);
  return n;
} : vg, ti = _g, mg = _n, gg = ti;
function bg(t, n) {
  return mg(t, gg(t), n);
}
var yg = bg, wg = Hr, Cg = Ot;
function $g(t, n, e) {
  var r = n(t);
  return Cg(t) ? r : wg(r, e(t));
}
var ni = $g, kg = ni, Mg = Rr, Dg = Nr;
function Sg(t) {
  return kg(t, Dg, Mg);
}
var Og = Sg, Tg = ni, Ag = ti, Eg = Fr;
function xg(t) {
  return Tg(t, Eg, Ag);
}
var ri = xg, Ig = Dt, Lg = tt, Bg = Ig(Lg, "DataView"), Vg = Bg, Pg = Dt, jg = tt, Ng = Pg(jg, "Promise"), Fg = Ng, Rg = Dt, Hg = tt, zg = Rg(Hg, "Set"), Yg = zg, Ug = Dt, qg = tt, Wg = Ug(qg, "WeakMap"), Kg = Wg, mr = Vg, gr = Br, br = Fg, yr = Yg, wr = Kg, oi = Yt, Kt = Ha, Io = "[object Map]", Gg = "[object Object]", Lo = "[object Promise]", Bo = "[object Set]", Vo = "[object WeakMap]", Po = "[object DataView]", Zg = Kt(mr), Jg = Kt(gr), Xg = Kt(br), Qg = Kt(yr), e0 = Kt(wr), mt = oi;
(mr && mt(new mr(new ArrayBuffer(1))) != Po || gr && mt(new gr()) != Io || br && mt(br.resolve()) != Lo || yr && mt(new yr()) != Bo || wr && mt(new wr()) != Vo) && (mt = function(t) {
  var n = oi(t), e = n == Gg ? t.constructor : void 0, r = e ? Kt(e) : "";
  if (r)
    switch (r) {
      case Zg:
        return Po;
      case Jg:
        return Io;
      case Xg:
        return Lo;
      case Qg:
        return Bo;
      case e0:
        return Vo;
    }
  return n;
});
var Yr = mt, t0 = Object.prototype, n0 = t0.hasOwnProperty;
function r0(t) {
  var n = t.length, e = new t.constructor(n);
  return n && typeof t[0] == "string" && n0.call(t, "index") && (e.index = t.index, e.input = t.input), e;
}
var o0 = r0, a0 = tt, i0 = a0.Uint8Array, s0 = i0, jo = s0;
function l0(t) {
  var n = new t.constructor(t.byteLength);
  return new jo(n).set(new jo(t)), n;
}
var Ur = l0, u0 = Ur;
function c0(t, n) {
  var e = n ? u0(t.buffer) : t.buffer;
  return new t.constructor(e, t.byteOffset, t.byteLength);
}
var d0 = c0, f0 = /\w*$/;
function p0(t) {
  var n = new t.constructor(t.source, f0.exec(t));
  return n.lastIndex = t.lastIndex, n;
}
var v0 = p0, No = vn, Fo = No ? No.prototype : void 0, Ro = Fo ? Fo.valueOf : void 0;
function h0(t) {
  return Ro ? Object(Ro.call(t)) : {};
}
var _0 = h0, m0 = Ur;
function g0(t, n) {
  var e = n ? m0(t.buffer) : t.buffer;
  return new t.constructor(e, t.byteOffset, t.length);
}
var b0 = g0, y0 = Ur, w0 = d0, C0 = v0, $0 = _0, k0 = b0, M0 = "[object Boolean]", D0 = "[object Date]", S0 = "[object Map]", O0 = "[object Number]", T0 = "[object RegExp]", A0 = "[object Set]", E0 = "[object String]", x0 = "[object Symbol]", I0 = "[object ArrayBuffer]", L0 = "[object DataView]", B0 = "[object Float32Array]", V0 = "[object Float64Array]", P0 = "[object Int8Array]", j0 = "[object Int16Array]", N0 = "[object Int32Array]", F0 = "[object Uint8Array]", R0 = "[object Uint8ClampedArray]", H0 = "[object Uint16Array]", z0 = "[object Uint32Array]";
function Y0(t, n, e) {
  var r = t.constructor;
  switch (n) {
    case I0:
      return y0(t);
    case M0:
    case D0:
      return new r(+t);
    case L0:
      return w0(t, e);
    case B0:
    case V0:
    case P0:
    case j0:
    case N0:
    case F0:
    case R0:
    case H0:
    case z0:
      return k0(t, e);
    case S0:
      return new r();
    case O0:
    case E0:
      return new r(t);
    case T0:
      return C0(t);
    case A0:
      return new r();
    case x0:
      return $0(t);
  }
}
var U0 = Y0, q0 = hn, Ho = Object.create, W0 = function() {
  function t() {
  }
  return function(n) {
    if (!q0(n))
      return {};
    if (Ho)
      return Ho(n);
    t.prototype = n;
    var e = new t();
    return t.prototype = void 0, e;
  };
}(), K0 = W0, G0 = K0, Z0 = zr, J0 = jr;
function X0(t) {
  return typeof t.constructor == "function" && !J0(t) ? G0(Z0(t)) : {};
}
var Q0 = X0, e2 = Yr, t2 = St, n2 = "[object Map]";
function r2(t) {
  return t2(t) && e2(t) == n2;
}
var o2 = r2, a2 = o2, i2 = Vr, zo = Pr, Yo = zo && zo.isMap, s2 = Yo ? i2(Yo) : a2, l2 = s2, u2 = Yr, c2 = St, d2 = "[object Set]";
function f2(t) {
  return c2(t) && u2(t) == d2;
}
var p2 = f2, v2 = p2, h2 = Vr, Uo = Pr, qo = Uo && Uo.isSet, _2 = qo ? h2(qo) : v2, m2 = _2, g2 = Ph, b2 = Nh, y2 = qa, w2 = Tm, C2 = qm, $2 = Wm, k2 = Gm, M2 = sg, D2 = yg, S2 = Og, O2 = ri, T2 = Yr, A2 = o0, E2 = U0, x2 = Q0, I2 = Ot, L2 = Ga, B2 = l2, V2 = hn, P2 = m2, j2 = Nr, N2 = Fr, F2 = 1, R2 = 2, H2 = 4, ai = "[object Arguments]", z2 = "[object Array]", Y2 = "[object Boolean]", U2 = "[object Date]", q2 = "[object Error]", ii = "[object Function]", W2 = "[object GeneratorFunction]", K2 = "[object Map]", G2 = "[object Number]", si = "[object Object]", Z2 = "[object RegExp]", J2 = "[object Set]", X2 = "[object String]", Q2 = "[object Symbol]", eb = "[object WeakMap]", tb = "[object ArrayBuffer]", nb = "[object DataView]", rb = "[object Float32Array]", ob = "[object Float64Array]", ab = "[object Int8Array]", ib = "[object Int16Array]", sb = "[object Int32Array]", lb = "[object Uint8Array]", ub = "[object Uint8ClampedArray]", cb = "[object Uint16Array]", db = "[object Uint32Array]", _e = {};
_e[ai] = _e[z2] = _e[tb] = _e[nb] = _e[Y2] = _e[U2] = _e[rb] = _e[ob] = _e[ab] = _e[ib] = _e[sb] = _e[K2] = _e[G2] = _e[si] = _e[Z2] = _e[J2] = _e[X2] = _e[Q2] = _e[lb] = _e[ub] = _e[cb] = _e[db] = !0;
_e[q2] = _e[ii] = _e[eb] = !1;
function Tn(t, n, e, r, o, a) {
  var s, i = n & F2, l = n & R2, d = n & H2;
  if (e && (s = o ? e(t, r, o, a) : e(t)), s !== void 0)
    return s;
  if (!V2(t))
    return t;
  var p = I2(t);
  if (p) {
    if (s = A2(t), !i)
      return k2(t, s);
  } else {
    var _ = T2(t), h = _ == ii || _ == W2;
    if (L2(t))
      return $2(t, i);
    if (_ == si || _ == ai || h && !o) {
      if (s = l || h ? {} : x2(t), !i)
        return l ? D2(t, C2(s, t)) : M2(t, w2(s, t));
    } else {
      if (!_e[_])
        return o ? t : {};
      s = E2(t, _, i);
    }
  }
  a || (a = new g2());
  var y = a.get(t);
  if (y)
    return y;
  a.set(t, s), P2(t) ? t.forEach(function(M) {
    s.add(Tn(M, n, e, M, t, a));
  }) : B2(t) && t.forEach(function(M, P) {
    s.set(P, Tn(M, n, e, P, t, a));
  });
  var $ = d ? l ? O2 : S2 : l ? N2 : j2, k = p ? void 0 : $(t);
  return b2(k || t, function(M, P) {
    k && (P = M, M = t[P]), y2(s, P, Tn(M, n, e, P, t, a));
  }), s;
}
var fb = Tn, pb = Yt, vb = St, hb = "[object Symbol]";
function _b(t) {
  return typeof t == "symbol" || vb(t) && pb(t) == hb;
}
var qr = _b, mb = Ot, gb = qr, bb = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, yb = /^\w*$/;
function wb(t, n) {
  if (mb(t))
    return !1;
  var e = typeof t;
  return e == "number" || e == "symbol" || e == "boolean" || t == null || gb(t) ? !0 : yb.test(t) || !bb.test(t) || n != null && t in Object(n);
}
var Cb = wb, li = za, $b = "Expected a function";
function Wr(t, n) {
  if (typeof t != "function" || n != null && typeof n != "function")
    throw new TypeError($b);
  var e = function() {
    var r = arguments, o = n ? n.apply(this, r) : r[0], a = e.cache;
    if (a.has(o))
      return a.get(o);
    var s = t.apply(this, r);
    return e.cache = a.set(o, s) || a, s;
  };
  return e.cache = new (Wr.Cache || li)(), e;
}
Wr.Cache = li;
var kb = Wr, Mb = kb, Db = 500;
function Sb(t) {
  var n = Mb(t, function(r) {
    return e.size === Db && e.clear(), r;
  }), e = n.cache;
  return n;
}
var Ob = Sb, Tb = Ob, Ab = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Eb = /\\(\\)?/g, xb = Tb(function(t) {
  var n = [];
  return t.charCodeAt(0) === 46 && n.push(""), t.replace(Ab, function(e, r, o, a) {
    n.push(o ? a.replace(Eb, "$1") : r || e);
  }), n;
}), Ib = xb, Wo = vn, Lb = Pa, Bb = Ot, Vb = qr, Pb = 1 / 0, Ko = Wo ? Wo.prototype : void 0, Go = Ko ? Ko.toString : void 0;
function ui(t) {
  if (typeof t == "string")
    return t;
  if (Bb(t))
    return Lb(t, ui) + "";
  if (Vb(t))
    return Go ? Go.call(t) : "";
  var n = t + "";
  return n == "0" && 1 / t == -Pb ? "-0" : n;
}
var jb = ui, Nb = jb;
function Fb(t) {
  return t == null ? "" : Nb(t);
}
var Rb = Fb, Hb = Ot, zb = Cb, Yb = Ib, Ub = Rb;
function qb(t, n) {
  return Hb(t) ? t : zb(t, n) ? [t] : Yb(Ub(t));
}
var Kr = qb;
function Wb(t) {
  var n = t == null ? 0 : t.length;
  return n ? t[n - 1] : void 0;
}
var Kb = Wb, Gb = qr, Zb = 1 / 0;
function Jb(t) {
  if (typeof t == "string" || Gb(t))
    return t;
  var n = t + "";
  return n == "0" && 1 / t == -Zb ? "-0" : n;
}
var ci = Jb, Xb = Kr, Qb = ci;
function e4(t, n) {
  n = Xb(n, t);
  for (var e = 0, r = n.length; t != null && e < r; )
    t = t[Qb(n[e++])];
  return e && e == r ? t : void 0;
}
var t4 = e4;
function n4(t, n, e) {
  var r = -1, o = t.length;
  n < 0 && (n = -n > o ? 0 : o + n), e = e > o ? o : e, e < 0 && (e += o), o = n > e ? 0 : e - n >>> 0, n >>>= 0;
  for (var a = Array(o); ++r < o; )
    a[r] = t[r + n];
  return a;
}
var r4 = n4, o4 = t4, a4 = r4;
function i4(t, n) {
  return n.length < 2 ? t : o4(t, a4(n, 0, -1));
}
var s4 = i4, l4 = Kr, u4 = Kb, c4 = s4, d4 = ci;
function f4(t, n) {
  return n = l4(n, t), t = c4(t, n), t == null || delete t[d4(u4(n))];
}
var p4 = f4, v4 = Yt, h4 = zr, _4 = St, m4 = "[object Object]", g4 = Function.prototype, b4 = Object.prototype, di = g4.toString, y4 = b4.hasOwnProperty, w4 = di.call(Object);
function C4(t) {
  if (!_4(t) || v4(t) != m4)
    return !1;
  var n = h4(t);
  if (n === null)
    return !0;
  var e = y4.call(n, "constructor") && n.constructor;
  return typeof e == "function" && e instanceof e && di.call(e) == w4;
}
var $4 = C4, k4 = $4;
function M4(t) {
  return k4(t) ? void 0 : t;
}
var D4 = M4, Zo = vn, S4 = Ka, O4 = Ot, Jo = Zo ? Zo.isConcatSpreadable : void 0;
function T4(t) {
  return O4(t) || S4(t) || !!(Jo && t && t[Jo]);
}
var A4 = T4, E4 = Hr, x4 = A4;
function fi(t, n, e, r, o) {
  var a = -1, s = t.length;
  for (e || (e = x4), o || (o = []); ++a < s; ) {
    var i = t[a];
    n > 0 && e(i) ? n > 1 ? fi(i, n - 1, e, r, o) : E4(o, i) : r || (o[o.length] = i);
  }
  return o;
}
var I4 = fi, L4 = I4;
function B4(t) {
  var n = t == null ? 0 : t.length;
  return n ? L4(t, 1) : [];
}
var V4 = B4;
function P4(t, n, e) {
  switch (e.length) {
    case 0:
      return t.call(n);
    case 1:
      return t.call(n, e[0]);
    case 2:
      return t.call(n, e[0], e[1]);
    case 3:
      return t.call(n, e[0], e[1], e[2]);
  }
  return t.apply(n, e);
}
var j4 = P4, N4 = j4, Xo = Math.max;
function F4(t, n, e) {
  return n = Xo(n === void 0 ? t.length - 1 : n, 0), function() {
    for (var r = arguments, o = -1, a = Xo(r.length - n, 0), s = Array(a); ++o < a; )
      s[o] = r[n + o];
    o = -1;
    for (var i = Array(n + 1); ++o < n; )
      i[o] = r[o];
    return i[n] = e(s), N4(t, this, i);
  };
}
var R4 = F4;
function H4(t) {
  return function() {
    return t;
  };
}
var z4 = H4;
function Y4(t) {
  return t;
}
var U4 = Y4, q4 = z4, Qo = Ya, W4 = U4, K4 = Qo ? function(t, n) {
  return Qo(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: q4(n),
    writable: !0
  });
} : W4, G4 = K4, Z4 = 800, J4 = 16, X4 = Date.now;
function Q4(t) {
  var n = 0, e = 0;
  return function() {
    var r = X4(), o = J4 - (r - e);
    if (e = r, o > 0) {
      if (++n >= Z4)
        return arguments[0];
    } else
      n = 0;
    return t.apply(void 0, arguments);
  };
}
var ey = Q4, ty = G4, ny = ey, ry = ny(ty), oy = ry, ay = V4, iy = R4, sy = oy;
function ly(t) {
  return sy(iy(t, void 0, ay), t + "");
}
var uy = ly, cy = Pa, dy = fb, fy = p4, py = Kr, vy = _n, hy = D4, _y = uy, my = ri, gy = 1, by = 2, yy = 4, wy = _y(function(t, n) {
  var e = {};
  if (t == null)
    return e;
  var r = !1;
  n = cy(n, function(a) {
    return a = py(a, t), r || (r = a.length > 1), a;
  }), vy(t, my(t), e), r && (e = dy(e, gy | by | yy, hy));
  for (var o = n.length; o--; )
    fy(e, n[o]);
  return e;
}), Cy = wy;
const $y = /* @__PURE__ */ Ca(Cy), i5 = /* @__PURE__ */ Y({
  __name: "VMultiSelect",
  props: {
    disabled: { type: Boolean, default: !1 },
    clearable: { type: Boolean },
    searchable: { type: Boolean },
    loading: { type: Boolean },
    prefixIcon: {},
    optionLabel: {},
    options: {},
    reduce: {},
    emptyValue: { type: Boolean },
    placeholder: {},
    filterable: { type: Boolean },
    foreground: { type: Boolean },
    borderless: { type: Boolean, default: !0 },
    appendToBody: { type: Boolean },
    label: {},
    showRequiredStar: { type: Boolean },
    withError: { type: Boolean },
    error: {},
    modelValue: { default: "[]" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I({
      get() {
        try {
          return JSON.parse(e.modelValue || "[]") || [];
        } catch {
          return [];
        }
      },
      set(s) {
        return s || r("update:modelValue", s), r("update:modelValue", JSON.stringify(s));
      }
    }), a = I(() => $y(e, ["modelValue"]));
    return (s, i) => (v(), L(c(Lr), De({
      modelValue: o.value,
      "onUpdate:modelValue": i[0] || (i[0] = (l) => o.value = l)
    }, a.value, {
      "close-on-select": "",
      multiple: ""
    }), null, 16, ["modelValue"]));
  }
}), ky = {}, My = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none"
}, Dy = /* @__PURE__ */ g("rect", {
  x: "2.7",
  y: "3.2",
  width: "18.6",
  height: "18.6",
  rx: "4.8",
  stroke: "currentColor",
  "stroke-width": "1.6"
}, null, -1), Sy = /* @__PURE__ */ g("path", {
  d: "M15.5355 9.03553L8.46447 16.1066M8.46447 9.03553L15.5355 16.1066",
  stroke: "currentColor",
  "stroke-width": "1.6",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Oy = [
  Dy,
  Sy
];
function Ty(t, n) {
  return v(), w("svg", My, Oy);
}
const Ay = /* @__PURE__ */ V(ky, [["render", Ty]]), Ey = /* @__PURE__ */ Y({
  __name: "VBaseModal",
  props: {
    title: { default: "" },
    cancelButtonText: { default: "Cancel" },
    cancelButtonDisabled: { type: Boolean, default: !1 },
    submitButtonDisabled: { type: Boolean, default: !1 },
    submitButtonText: { default: "Submit" },
    isModalShow: { type: Boolean },
    loading: { type: Boolean, default: !1 },
    closeOnOverlayClick: { type: Boolean, default: !0 },
    maxWidth: { default: "396px" },
    withCloseIcon: { type: Boolean, default: !0 },
    closeIconCustomEvent: { type: Boolean, default: !1 },
    hideFooter: { type: Boolean, default: !1 },
    hideSubmit: { type: Boolean, default: !1 },
    btnsAlignRight: { type: Boolean, default: !1 },
    zIndexFn: { type: Function, default: ({ index: t }) => 1e3 + 2 * t }
  },
  emits: ["update:is-modal-show", "cancel", "click:closeIcon", "submit", "closed"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I({
      get() {
        return e.isModalShow;
      },
      set(i) {
        r("update:is-modal-show", i);
      }
    }), a = I(() => e.closeOnOverlayClick ? !e.loading : e.closeOnOverlayClick), s = () => {
      if (e.closeIconCustomEvent)
        return r("click:closeIcon");
      r("cancel");
    };
    return (i, l) => (v(), L(c(ca), {
      modelValue: o.value,
      "onUpdate:modelValue": l[2] || (l[2] = (d) => o.value = d),
      class: m(i.$style["v-base-modal"]),
      "click-to-close": a.value,
      "esc-to-close": !i.loading,
      "z-index-fn": i.zIndexFn,
      style: dt({
        "--modal-max-width": i.maxWidth
      }),
      onClosed: l[3] || (l[3] = (d) => r("closed"))
    }, {
      default: ee(() => [
        g("div", {
          class: m(i.$style["v-base-modal__header"])
        }, [
          H(i.$slots, "modal-title", {}, () => [
            g("h3", {
              class: m([
                i.$style["v-base-modal__title"],
                {
                  [i.$style["v-base-modal__title--with-close"]]: i.withCloseIcon
                }
              ])
            }, z(i.title), 3)
          ]),
          i.withCloseIcon ? (v(), w("div", {
            key: 0,
            class: m(i.$style["v-base-modal__close-icon"]),
            onClick: s
          }, [
            j(qn)
          ], 2)) : E("", !0)
        ], 2),
        g("div", {
          class: m(i.$style["v-base-modal__body"])
        }, [
          H(i.$slots, "default")
        ], 2),
        i.hideFooter ? E("", !0) : (v(), w("div", {
          key: 0,
          class: m([
            i.$style["v-base-modal__buttons"],
            {
              [i.$style["v-base-modal__buttons--right"]]: i.btnsAlignRight,
              [i.$style["v-base-modal__buttons--single"]]: i.hideSubmit
            }
          ])
        }, [
          H(i.$slots, "cancel-btn", {}, () => [
            j(c(xn), {
              variant: c(En).PRIMARY_OUTLINE,
              fill: "",
              disabled: i.loading || i.cancelButtonDisabled,
              onClick: l[0] || (l[0] = (d) => r("cancel"))
            }, {
              icon: ee(() => [
                j(Ay)
              ]),
              default: ee(() => [
                Q(" " + z(i.cancelButtonText), 1)
              ]),
              _: 1
            }, 8, ["variant", "disabled"])
          ]),
          i.hideSubmit ? E("", !0) : H(i.$slots, "submit-btn", { key: 0 }, () => [
            j(c(xn), {
              variant: c(En).PRIMARY,
              loading: i.loading,
              disabled: i.submitButtonDisabled,
              fill: "",
              onClick: l[1] || (l[1] = (d) => r("submit"))
            }, {
              icon: ee(() => [
                j(Hn)
              ]),
              default: ee(() => [
                Q(" " + z(i.submitButtonText), 1)
              ]),
              _: 1
            }, 8, ["variant", "loading", "disabled"])
          ])
        ], 2))
      ]),
      _: 3
    }, 8, ["modelValue", "class", "click-to-close", "esc-to-close", "z-index-fn", "style"]));
  }
}), xy = {
  "v-base-modal": "_v-base-modal_r2ov0_1",
  "v-base-modal__header": "_v-base-modal__header_r2ov0_36",
  "v-base-modal__title": "_v-base-modal__title_r2ov0_45",
  "v-base-modal__title--with-close": "_v-base-modal__title--with-close_r2ov0_54",
  "v-base-modal__body": "_v-base-modal__body_r2ov0_58",
  "v-base-modal__buttons": "_v-base-modal__buttons_r2ov0_64",
  "v-base-modal__buttons--single": "_v-base-modal__buttons--single_r2ov0_76",
  "v-base-modal__buttons--right": "_v-base-modal__buttons--right_r2ov0_85",
  "v-base-modal__close-icon": "_v-base-modal__close-icon_r2ov0_96"
}, Iy = {
  $style: xy
}, Gr = /* @__PURE__ */ V(Ey, [["__cssModules", Iy]]), s5 = /* @__PURE__ */ Y({
  __name: "VUpdateField",
  props: {
    isModalShow: { type: Boolean },
    fieldName: { default: "field" },
    loading: { type: Boolean, default: !1 },
    isEdit: { type: Boolean, default: !0 },
    cancelButtonDisabled: { type: Boolean, default: !1 },
    submitButtonDisabled: { type: Boolean, default: !1 },
    withSubmit: { type: Boolean, default: !0 },
    maxWidth: { default: "396px" }
  },
  emits: ["update:is-modal-show", "cancel", "submit"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I({
      get() {
        return e.isModalShow;
      },
      set(s) {
        r("update:is-modal-show", s);
      }
    }), a = I(() => e.fieldName.toLowerCase());
    return (s, i) => (v(), L(c(Gr), {
      "is-modal-show": o.value,
      "onUpdate:isModalShow": i[0] || (i[0] = (l) => o.value = l),
      title: `${s.isEdit ? "Update" : "Field"} ${a.value}`,
      "cancel-button-text": s.isEdit ? "Cancel" : "Close",
      "submit-button-text": s.isEdit ? "Update" : "Edit",
      "cancel-button-disabled": s.cancelButtonDisabled,
      "submit-button-disabled": s.submitButtonDisabled,
      loading: s.loading,
      "hide-submit": !s.withSubmit,
      "max-width": s.maxWidth,
      onCancel: i[1] || (i[1] = (l) => r("cancel")),
      onSubmit: i[2] || (i[2] = (l) => r("submit")),
      onClose: i[3] || (i[3] = (l) => r("cancel"))
    }, {
      default: ee(() => [
        H(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["is-modal-show", "title", "cancel-button-text", "submit-button-text", "cancel-button-disabled", "submit-button-disabled", "loading", "hide-submit", "max-width"]));
  }
}), Ly = /* @__PURE__ */ Y({
  __name: "VEditableTableItem",
  props: {
    content: { default: "—" },
    maxLength: { default: 50 },
    disabled: { type: Boolean, default: !1 },
    hoverContent: { default: "" }
  },
  emits: ["edit"],
  setup(t, { emit: n }) {
    const e = n, r = he();
    return (o, a) => (v(), w("div", {
      class: m([
        c(r)["v-editable-table-item"],
        {
          [c(r)["v-editable-table-item--disabled"]]: o.disabled
        }
      ])
    }, [
      g("div", {
        class: m(c(r)["v-editable-table-item__content"])
      }, [
        H(o.$slots, "default", {}, () => [
          j(c(Ht), {
            content: o.content,
            "hover-content": o.hoverContent,
            "max-length": o.maxLength,
            placement: "top"
          }, null, 8, ["content", "hover-content", "max-length"])
        ])
      ], 2),
      o.disabled ? E("", !0) : (v(), w("div", {
        key: 0,
        onClick: a[0] || (a[0] = (s) => e("edit"))
      }, [
        j(Ba, {
          class: m(c(r)["v-editable-table-item__edit-icon"])
        }, null, 8, ["class"])
      ]))
    ], 2));
  }
}), By = {
  "v-editable-table-item": "_v-editable-table-item_1oa4z_1",
  "v-editable-table-item__edit-icon": "_v-editable-table-item__edit-icon_1oa4z_12",
  "v-editable-table-item--disabled": "_v-editable-table-item--disabled_1oa4z_16",
  "v-editable-table-item__content": "_v-editable-table-item__content_1oa4z_21"
}, Vy = {
  $style: By
}, l5 = /* @__PURE__ */ V(Ly, [["__cssModules", Vy]]), Py = /* @__PURE__ */ Y({
  __name: "VNewVersion",
  props: {
    isModalShow: { type: Boolean }
  },
  emits: ["update:is-modal-show", "cancel", "submit"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I({
      get() {
        return e.isModalShow;
      },
      set(s) {
        r("update:is-modal-show", s);
      }
    }), a = he();
    return (s, i) => (v(), L(c(Gr), {
      "is-modal-show": o.value,
      "onUpdate:isModalShow": i[0] || (i[0] = (l) => o.value = l),
      title: "New version available",
      "submit-button-text": "Refresh",
      "close-on-overlay-click": !1,
      onCancel: i[1] || (i[1] = (l) => r("cancel")),
      onSubmit: i[2] || (i[2] = (l) => r("submit")),
      onClose: i[3] || (i[3] = (l) => r("cancel"))
    }, {
      default: ee(() => [
        g("p", {
          class: m(c(a)["v-new-version__content"])
        }, ' Please click "Refresh" to use the latest version of Vsimple! If you need to save your work first, hit "Cancel" and refresh your browser at your convenience. ', 2)
      ]),
      _: 1
    }, 8, ["is-modal-show"]));
  }
}), jy = {
  "v-new-version__content": "_v-new-version__content_1v7hk_1"
}, Ny = {
  $style: jy
}, u5 = /* @__PURE__ */ V(Py, [["__cssModules", Ny]]), c5 = /* @__PURE__ */ Y({
  __name: "VCreateViewModal",
  props: {
    isModalShow: { type: Boolean },
    title: {},
    loading: { type: Boolean, default: !1 }
  },
  emits: ["submit", "update:is-modal-show"],
  setup(t, { emit: n }) {
    const e = Bi(), r = ie({
      title: ""
    }), o = {
      title: {
        required: dr.withMessage("Title is required field", fr)
      }
    }, a = pa(o, r), s = t, i = n, l = I({
      get() {
        return s.isModalShow;
      },
      set(_) {
        i("update:is-modal-show", _);
      }
    }), d = () => {
      a.value.$validate(), a.value.$error || i("submit", r.value);
    }, p = () => {
      a.value.$reset(), r.value = {
        title: ""
      };
    };
    return (_, h) => (v(), L(c(Gr), De({
      "is-modal-show": l.value,
      "onUpdate:isModalShow": h[1] || (h[1] = (y) => l.value = y),
      title: _.title,
      loading: _.loading,
      "max-width": "500px"
    }, c(e), {
      onSubmit: d,
      onClosed: p,
      onCancel: h[2] || (h[2] = (y) => l.value = !1)
    }), {
      default: ee(() => {
        var y;
        return [
          j(c(Yn), {
            modelValue: r.value.title,
            "onUpdate:modelValue": h[0] || (h[0] = ($) => r.value.title = $),
            label: "Title",
            foreground: "",
            "with-error": "",
            error: String(((y = c(a).title.$errors[0]) == null ? void 0 : y.$message) || "")
          }, null, 8, ["modelValue", "error"]),
          H(_.$slots, "default")
        ];
      }),
      _: 3
    }, 16, ["is-modal-show", "title", "loading"]));
  }
}), Fy = ["onClick"], Ry = /* @__PURE__ */ Y({
  __name: "VTab",
  props: {
    title: {},
    count: { default: null },
    isCountLoading: { type: Boolean, default: !1 },
    actions: { default: () => [] },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    description: { default: "" },
    tooltipClass: { default: "" }
  },
  emits: ["click:action", "click:tab"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I(() => {
      var y;
      return !!((y = e.actions) != null && y.length);
    }), a = I(() => dn(e.actions)), s = (y) => {
      r("click:action", y), d.value = !1;
    }, i = ie(null), l = ie(null), d = ie(!1), p = ie(null), _ = () => {
      var y;
      p.value && ((y = p.value) == null || y.destroy(), p.value = null);
    };
    Ct(() => d.value, async (y) => {
      var $;
      await pt(), !(!i.value || !l.value) && (y && i.value && (l.value.style.minWidth = `max(${($ = i.value) == null ? void 0 : $.clientWidth}px, 100px)`, p.value = Mt(i.value, l.value, {
        placement: "bottom",
        modifiers: [
          kt,
          {
            name: "offset",
            options: {
              offset: [0, -20]
            }
          }
        ]
      }), document.body.appendChild(l.value)), !y && p.value && (_(), document.body.removeChild(l.value)));
    }), $t(() => {
      _();
    }), Fn(i, () => {
      d.value = !1;
    }, {
      ignore: [l]
    });
    const h = he();
    return (y, $) => (v(), w("div", {
      ref_key: "tab",
      ref: i,
      class: m([
        c(h)["v-tab"],
        {
          [c(h)["v-tab--active"]]: y.active,
          [c(h)["v-tab--with-actions"]]: o.value
        }
      ]),
      onClick: $[1] || ($[1] = (k) => r("click:tab"))
    }, [
      y.description ? (v(), L(c(ft), {
        key: 0,
        content: y.description,
        "tooltip-class": y.tooltipClass
      }, null, 8, ["content", "tooltip-class"])) : E("", !0),
      Q(" " + z(y.title) + " ", 1),
      y.count || y.isCountLoading ? (v(), L(c(Wn), { key: 1 }, {
        content: ee(() => [
          y.isCountLoading ? (v(), w(ae, { key: 0 }, [
            y.isCountLoading ? (v(), L(c(kr), {
              key: 0,
              size: c(Pt).SMALL
            }, null, 8, ["size"])) : E("", !0)
          ], 64)) : (v(), w(ae, { key: 1 }, [
            Q(z(y.count), 1)
          ], 64))
        ]),
        _: 1
      })) : E("", !0),
      o.value && !y.disabled ? (v(), w("div", {
        key: 2,
        class: m(c(h)["v-tab__toggle"]),
        onClick: $[0] || ($[0] = Je((k) => d.value = !d.value, ["stop"]))
      }, [
        j(vt)
      ], 2)) : E("", !0),
      d.value && o.value ? (v(), w("div", {
        key: 3,
        ref_key: "actions",
        ref: l,
        class: m(c(h)["v-tab__actions"])
      }, [
        (v(!0), w(ae, null, ue(a.value, (k) => (v(), w("div", {
          key: k._id,
          class: m(c(h)["v-tab__action"]),
          onClick: Je((M) => s(k.value), ["stop"])
        }, z(k.title), 11, Fy))), 128))
      ], 2)) : E("", !0)
    ], 2));
  }
}), Hy = {
  "v-tab": "_v-tab_177ry_1",
  "v-tab--active": "_v-tab--active_177ry_32",
  "v-tab--with-actions": "_v-tab--with-actions_177ry_39",
  "v-tab__toggle": "_v-tab__toggle_177ry_43",
  "v-tab__actions": "_v-tab__actions_177ry_58",
  "v-tab__action": "_v-tab__action_177ry_58"
}, zy = {
  $style: Hy
}, d5 = /* @__PURE__ */ V(Ry, [["__cssModules", zy]]), Yy = ["onClick"], Uy = /* @__PURE__ */ Y({
  __name: "VActions",
  props: {
    options: {},
    minWidth: { default: "150px" },
    placement: { default: "bottom" },
    emitWholeOption: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["option:click", "actions:open"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I(() => e.options.map(($) => ({
      ...$,
      _id: Symbol()
    }))), a = ie(null), s = ie(), i = ie();
    Fn(s, () => {
      p.value = !1;
    }, {
      ignore: [i]
    });
    const { stop: l } = Fi(s, ([{ isIntersecting: $ }]) => {
      !$ && p.value && (p.value = !1);
    }), d = () => {
      var $;
      a.value && (($ = a.value) == null || $.destroy(), a.value = null);
    }, p = ie(!1);
    Ct(() => p.value, async ($) => {
      var k;
      await pt(), !(!s.value || !i.value) && ($ && s.value && (i.value.style.width = `max(${(k = s.value) == null ? void 0 : k.clientWidth}px, ${e.minWidth})`, a.value = Mt(s.value, i.value, {
        placement: e.placement,
        modifiers: [
          kt,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }), document.body.appendChild(i.value)), !$ && a.value && (d(), document.body.removeChild(i.value)));
    });
    const _ = ($) => {
      e.emitWholeOption ? r("option:click", $) : r("option:click", $.value), p.value = !1;
    }, h = () => {
      e.disabled || (p.value || r("actions:open"), p.value = !p.value);
    }, y = he();
    return $t(() => {
      d(), l == null || l();
    }), ($, k) => (v(), w("div", null, [
      g("div", {
        ref_key: "trigger",
        ref: s,
        class: m(c(y)["v-actions__trigger"]),
        onClick: k[0] || (k[0] = (M) => h())
      }, [
        H($.$slots, "trigger")
      ], 2),
      it(g("div", {
        ref_key: "optionsList",
        ref: i,
        class: m(c(y)["v-actions__list"])
      }, [
        (v(!0), w(ae, null, ue(o.value, (M) => (v(), w("div", De({
          key: M._id,
          ref_for: !0
        }, M.dataTest ? {
          "data-test": M.dataTest
        } : {}, {
          class: [
            c(y)["v-actions__option"],
            {
              [c(y)[`v-actions__option--${M.modifier}`]]: M.modifier,
              [c(y)["v-actions__option--with-icon"]]: M.icon,
              [c(y)["v-actions__option--with-count"]]: "count" in M
            }
          ],
          onClick: (P) => _(M)
        }), [
          M.icon ? (v(), L(We(M.icon), { key: 0 })) : E("", !0),
          Q(" " + z(M.label) + " ", 1),
          M.count || M.isCountLoading ? (v(), L(c(Wn), { key: 1 }, {
            content: ee(() => [
              M.isCountLoading ? (v(), w(ae, { key: 0 }, [
                M.isCountLoading ? (v(), L(c(kr), {
                  key: 0,
                  size: c(Pt).SMALL
                }, null, 8, ["size"])) : E("", !0)
              ], 64)) : (v(), w(ae, { key: 1 }, [
                Q(z(M.count), 1)
              ], 64))
            ]),
            _: 2
          }, 1024)) : E("", !0)
        ], 16, Yy))), 128))
      ], 2), [
        [sn, p.value]
      ])
    ]));
  }
}), qy = {
  "v-actions__trigger": "_v-actions__trigger_1xcgl_1",
  "v-actions__list": "_v-actions__list_1xcgl_6",
  "v-actions__option": "_v-actions__option_1xcgl_35",
  "v-actions__option--with-icon": "_v-actions__option--with-icon_1xcgl_71",
  "v-actions__option--with-count": "_v-actions__option--with-count_1xcgl_75",
  "v-actions__option--danger": "_v-actions__option--danger_1xcgl_79"
}, Wy = {
  $style: qy
}, f5 = /* @__PURE__ */ V(Uy, [["__cssModules", Wy]]), Ky = /* @__PURE__ */ Y({
  __name: "VColorPicker",
  props: {
    simple: { type: Boolean, default: !1 },
    modelValue: { default: "" },
    placement: { default: "bottom" }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    ua((p) => ({
      bd6ff244: p.modelValue
    }));
    const e = t, r = n, o = ie(null), a = ie(), s = ie();
    Fn(a, (p) => {
      l.value = !1;
    }, {
      ignore: [
        s
      ]
    });
    const i = () => {
      var p;
      o.value && ((p = o.value) == null || p.destroy(), o.value = null);
    }, l = ie(!1);
    Ct(() => l.value, async (p) => {
      var _;
      await pt(), !(!a.value || !s.value) && (p && a.value && (s.value.style.width = `max(${(_ = a.value) == null ? void 0 : _.clientWidth}px, ${e.minWidth})`, o.value = Mt(a.value, s.value, {
        placement: e.placement,
        modifiers: [
          kt,
          {
            name: "offset",
            options: {
              offset: [0, 4]
            }
          }
        ]
      }), document.body.appendChild(s.value)), !p && o.value && (i(), document.body.removeChild(s.value)));
    });
    const d = he();
    return $t(() => {
      i();
    }), (p, _) => (v(), w("div", null, [
      g("div", {
        ref_key: "trigger",
        ref: a,
        class: m(p.$style["v-color-picker__trigger"]),
        onClick: _[0] || (_[0] = (h) => l.value = !l.value)
      }, [
        g("div", {
          class: m(c(d)["v-color-picker__circle"])
        }, null, 2),
        p.simple ? E("", !0) : (v(), w("span", {
          key: 0,
          class: m(c(d)["v-color-picker__text"])
        }, z(p.modelValue), 3))
      ], 2),
      l.value ? (v(), w("div", {
        key: 0,
        ref_key: "popperWrapper",
        ref: s,
        class: m(c(d)["v-color-picker__wrapper"])
      }, [
        j(c(Ri), {
          "model-value": {
            hex: p.modelValue
          },
          "onUpdate:modelValue": _[1] || (_[1] = (h) => r("update:modelValue", h.hex))
        }, null, 8, ["model-value"])
      ], 2)) : E("", !0)
    ]));
  }
}), Gy = {
  "v-color-picker__trigger": "_v-color-picker__trigger_t6wdk_1",
  "v-color-picker__circle": "_v-color-picker__circle_t6wdk_10",
  "v-color-picker__text": "_v-color-picker__text_t6wdk_21",
  "v-color-picker__wrapper": "_v-color-picker__wrapper_t6wdk_26"
}, Zy = {
  $style: Gy
}, p5 = /* @__PURE__ */ V(Ky, [["__cssModules", Zy]]), Jy = {}, Xy = {
  width: "48",
  height: "48",
  viewBox: "0 0 49 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qy = /* @__PURE__ */ Nn('<g clip-path="url(#clip0_26272_79717)"><path d="M39.264 14.3353C37.6428 6.20102 29.7344 0.921359 21.6002 2.54258C15.6507 3.72837 10.9987 8.37741 9.80928 14.3261C4.04182 14.9908 -0.0952621 20.2049 0.569045 25.9728C1.18062 31.281 5.67659 35.2859 11.02 35.2822H18.5288C19.3582 35.2822 20.0306 34.6098 20.0306 33.7804C20.0306 32.9509 19.3582 32.2785 18.5288 32.2785H11.02C6.87263 32.254 3.53096 28.8724 3.55513 24.7254C3.57966 20.5785 6.96126 17.2364 11.1086 17.2606C11.874 17.261 12.517 16.6849 12.6013 15.9243C13.3637 9.33286 19.3253 4.60764 25.9167 5.37009C31.4582 6.01133 35.8297 10.3824 36.4705 15.9243C36.5965 16.6985 37.2674 17.2657 38.0518 17.2606C42.1992 17.2606 45.561 20.6224 45.561 24.7697C45.561 28.9167 42.1992 32.2785 38.0518 32.2785H30.543C29.7136 32.2785 29.0412 32.9509 29.0412 33.7804C29.0412 34.6098 29.7136 35.2822 30.543 35.2822H38.0522C43.8577 35.2459 48.535 30.5105 48.4991 24.7046C48.4661 19.4176 44.5118 14.9776 39.264 14.3353Z" fill="currentColor"></path><path d="M29.8461 29.1996C30.4226 29.7966 31.3732 29.813 31.9698 29.2366C32.5664 28.6606 32.5828 27.7099 32.0068 27.1133C31.9947 27.1005 31.9823 27.0884 31.9698 27.0763L25.6007 20.7057C25.0151 20.1183 24.064 20.1172 23.4766 20.7028C23.4759 20.7039 23.4748 20.7046 23.4741 20.7057L17.1049 27.0763C16.5084 27.6524 16.4919 28.6031 17.0679 29.1996C17.6444 29.7962 18.595 29.8127 19.1916 29.2366C19.2041 29.2245 19.2165 29.2121 19.2286 29.1996L23.0357 25.391V44.2926C23.0357 45.1221 23.7081 45.7945 24.5376 45.7945C25.3667 45.7945 26.039 45.1221 26.039 44.2926V25.391L29.8461 29.1996Z" fill="currentColor"></path></g><defs><clipPath id="clip0_26272_79717"><rect width="48" height="48" fill="white" transform="translate(0.5)"></rect></clipPath></defs>', 2), e3 = [
  Qy
];
function t3(t, n) {
  return v(), w("svg", Xy, e3);
}
const n3 = /* @__PURE__ */ V(Jy, [["render", t3]]);
function cr(t) {
  return i3(t) || a3(t) || o3(t) || r3();
}
function r3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function o3(t, n) {
  if (t) {
    if (typeof t == "string")
      return Cr(t, n);
    var e = Object.prototype.toString.call(t).slice(8, -1);
    if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set")
      return Array.from(t);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))
      return Cr(t, n);
  }
}
function a3(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
    return Array.from(t);
}
function i3(t) {
  if (Array.isArray(t))
    return Cr(t);
}
function Cr(t, n) {
  (n == null || n > t.length) && (n = t.length);
  for (var e = 0, r = new Array(n); e < n; e++)
    r[e] = t[e];
  return r;
}
function ea(t, n) {
  var e = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    n && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function lt(t) {
  for (var n = 1; n < arguments.length; n++) {
    var e = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ea(Object(e), !0).forEach(function(r) {
      s3(t, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : ea(Object(e)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return t;
}
function s3(t, n, e) {
  return n in t ? Object.defineProperty(t, n, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = e, t;
}
function an(t) {
  "@babel/helpers - typeof";
  return an = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, an(t);
}
function ta(t, n) {
  var e = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    n && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function Dn(t) {
  for (var n = 1; n < arguments.length; n++) {
    var e = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ta(Object(e), !0).forEach(function(r) {
      c3(t, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : ta(Object(e)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return t;
}
function l3(t, n) {
  if (!(t instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function na(t, n) {
  for (var e = 0; e < n.length; e++) {
    var r = n[e];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function u3(t, n, e) {
  return n && na(t.prototype, n), e && na(t, e), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function c3(t, n, e) {
  return n in t ? Object.defineProperty(t, n, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = e, t;
}
var pi = function(n) {
  var e = new XMLHttpRequest();
  return e.open(n.method || "GET", n.url), e.responseType = "json", n.headers && Object.keys(n.headers).forEach(function(r) {
    e.setRequestHeader(r, n.headers[r]);
  }), e;
}, d3 = function(n, e) {
  return new Promise(function(r, o) {
    n.onload = function() {
      if (n.status >= 200 && n.status < 300) {
        var a;
        try {
          a = JSON.parse(n.response);
        } catch {
          a = n.response;
        }
        r(a);
      } else
        o(n.response);
    }, n.onerror = function() {
      return o(n.response);
    }, n.send(JSON.stringify(e));
  });
}, f3 = function(n, e) {
  var r = new FormData();
  for (var o in e)
    r.append(o, e[o]);
  return new Promise(function(a, s) {
    n.onload = function() {
      if (n.status >= 200 && n.status < 300) {
        var i;
        try {
          i = JSON.parse(n.response);
        } catch {
          i = n.response;
        }
        a(i);
      } else
        s(n.response);
    }, n.onerror = function() {
      return s(n.response);
    }, n.send(r);
  });
};
function ra(t) {
  var n = pi(t);
  return d3(n, t.body);
}
var p3 = /* @__PURE__ */ function() {
  function t(n, e) {
    l3(this, t), this.file = n, this.options = e, this.chunks = [], this.sessionId = null, this.chunkSize = null, this.speedInterval = null;
  }
  return u3(t, [{
    key: "maxRetries",
    get: function() {
      return parseInt(this.options.maxRetries, 10);
    }
    /**
     * Gets the max number of active chunks being uploaded at once from options
     */
  }, {
    key: "maxActiveChunks",
    get: function() {
      return parseInt(this.options.maxActive, 10);
    }
    /**
     * Gets the file type
     */
  }, {
    key: "fileType",
    get: function() {
      return this.file.type;
    }
    /**
     * Gets the file size
     */
  }, {
    key: "fileSize",
    get: function() {
      return this.file.size;
    }
    /**
     * Gets the file name
     */
  }, {
    key: "fileName",
    get: function() {
      return this.file.name;
    }
    /**
     * Gets action (url) to upload the file
     */
  }, {
    key: "action",
    get: function() {
      return this.options.action || null;
    }
    /**
     * Gets the body to be merged when sending the request in start phase
     */
  }, {
    key: "startBody",
    get: function() {
      return this.options.startBody || {};
    }
    /**
     * Gets the body to be merged when sending the request in upload phase
     */
  }, {
    key: "uploadBody",
    get: function() {
      return this.options.uploadBody || {};
    }
    /**
     * Gets the body to be merged when sending the request in finish phase
     */
  }, {
    key: "finishBody",
    get: function() {
      return this.options.finishBody || {};
    }
    /**
     * Gets the headers of the requests from options
     */
  }, {
    key: "headers",
    get: function() {
      return this.options.headers || {};
    }
    /**
     * Whether it's ready to upload files or not
     */
  }, {
    key: "readyToUpload",
    get: function() {
      return !!this.chunks;
    }
    /**
     * Gets the progress of the chunk upload
     * - Gets all the completed chunks
     * - Gets the progress of all the chunks that are being uploaded
     */
  }, {
    key: "progress",
    get: function() {
      var e = this, r = this.chunksUploaded.length / this.chunks.length * 100, o = this.chunksUploading.reduce(function(a, s) {
        return a + (s.progress | 0) / e.chunks.length;
      }, 0);
      return Math.min(r + o, 100);
    }
    /**
     * Gets all the chunks that are pending to be uploaded
     */
  }, {
    key: "chunksToUpload",
    get: function() {
      return this.chunks.filter(function(e) {
        return !e.active && !e.uploaded;
      });
    }
    /**
     * Whether there are chunks to upload or not
     */
  }, {
    key: "hasChunksToUpload",
    get: function() {
      return this.chunksToUpload.length > 0;
    }
    /**
     * Gets all the chunks that are uploading
     */
  }, {
    key: "chunksUploading",
    get: function() {
      return this.chunks.filter(function(e) {
        return !!e.xhr && !!e.active;
      });
    }
    /**
     * Gets all the chunks that have finished uploading
     */
  }, {
    key: "chunksUploaded",
    get: function() {
      return this.chunks.filter(function(e) {
        return !!e.uploaded;
      });
    }
    /**
     * Creates all the chunks in the initial state
     */
  }, {
    key: "createChunks",
    value: function() {
      this.chunks = [];
      for (var e = 0, r = this.chunkSize; e < this.fileSize; )
        this.chunks.push({
          blob: this.file.file.slice(e, r),
          startOffset: e,
          active: !1,
          retries: this.maxRetries
        }), e = r, r = e + this.chunkSize;
    }
    /**
     * Updates the progress of the file with the handler's progress
     */
  }, {
    key: "updateFileProgress",
    value: function() {
      this.file.progress = this.progress;
    }
    /**
     * Paues the upload process
     * - Stops all active requests
     * - Sets the file not active
     */
  }, {
    key: "pause",
    value: function() {
      this.file.active = !1, this.stopChunks();
    }
    /**
     * Stops all the current chunks
     */
  }, {
    key: "stopChunks",
    value: function() {
      this.chunksUploading.forEach(function(e) {
        e.xhr.abort(), e.active = !1;
      }), this.stopSpeedCalc();
    }
    /**
     * Resumes the file upload
     * - Sets the file active
     * - Starts the following chunks
     */
  }, {
    key: "resume",
    value: function() {
      this.file.active = !0, this.startChunking();
    }
    /**
     * Starts the file upload
     *
     * @returns Promise
     * - resolve  The file was uploaded
     * - reject   The file upload failed
     */
  }, {
    key: "upload",
    value: function() {
      var e = this;
      return this.promise = new Promise(function(r, o) {
        e.resolve = r, e.reject = o;
      }), this.start(), this.promise;
    }
    /**
     * Start phase
     * Sends a request to the backend to initialise the chunks
     */
  }, {
    key: "start",
    value: function() {
      var e = this;
      ra({
        method: "POST",
        headers: Dn(Dn({}, this.headers), {}, {
          "Content-Type": "application/json"
        }),
        url: this.action,
        body: Object.assign(this.startBody, {
          phase: "start",
          mime_type: this.fileType,
          size: this.fileSize,
          name: this.fileName
        })
      }).then(function(r) {
        if (r.status !== "success")
          return e.file.response = r, e.reject("server");
        e.sessionId = r.data.session_id, e.chunkSize = r.data.end_offset, e.createChunks(), e.startChunking();
      }).catch(function(r) {
        e.file.response = r, e.reject("server");
      });
    }
    /**
     * Starts to upload chunks
     */
  }, {
    key: "startChunking",
    value: function() {
      for (var e = 0; e < this.maxActiveChunks; e++)
        this.uploadNextChunk();
      this.startSpeedCalc();
    }
    /**
     * Uploads the next chunk
     * - Won't do anything if the process is paused
     * - Will start finish phase if there are no more chunks to upload
     */
  }, {
    key: "uploadNextChunk",
    value: function() {
      if (this.file.active) {
        if (this.hasChunksToUpload)
          return this.uploadChunk(this.chunksToUpload[0]);
        if (this.chunksUploading.length === 0)
          return this.finish();
      }
    }
    /**
     * Uploads a chunk
     * - Sends the chunk to the backend
     * - Sets the chunk as uploaded if everything went well
     * - Decreases the number of retries if anything went wrong
     * - Fails if there are no more retries
     *
     * @param {Object} chunk
     */
  }, {
    key: "uploadChunk",
    value: function(e) {
      var r = this;
      e.progress = 0, e.active = !0, this.updateFileProgress(), e.xhr = pi({
        method: "POST",
        headers: this.headers,
        url: this.action
      }), e.xhr.upload.addEventListener("progress", function(o) {
        o.lengthComputable && (e.progress = Math.round(o.loaded / o.total * 100));
      }, !1), f3(e.xhr, Object.assign(this.uploadBody, {
        phase: "upload",
        session_id: this.sessionId,
        start_offset: e.startOffset,
        chunk: e.blob
      })).then(function(o) {
        if (e.active = !1, o.status === "success")
          e.uploaded = !0;
        else if (e.retries-- <= 0)
          return r.stopChunks(), r.reject("upload");
        r.uploadNextChunk();
      }).catch(function() {
        if (e.active = !1, e.retries-- <= 0)
          return r.stopChunks(), r.reject("upload");
        r.uploadNextChunk();
      });
    }
    /**
     * Finish phase
     * Sends a request to the backend to finish the process
     */
  }, {
    key: "finish",
    value: function() {
      var e = this;
      this.updateFileProgress(), this.stopSpeedCalc(), ra({
        method: "POST",
        headers: Dn(Dn({}, this.headers), {}, {
          "Content-Type": "application/json"
        }),
        url: this.action,
        body: Object.assign(this.finishBody, {
          phase: "finish",
          session_id: this.sessionId
        })
      }).then(function(r) {
        if (e.file.response = r, r.status !== "success")
          return e.reject("server");
        e.resolve(r);
      }).catch(function(r) {
        e.file.response = r, e.reject("server");
      });
    }
    /**
     * Sets an interval to calculate and
     * set upload speed every 3 seconds
     */
  }, {
    key: "startSpeedCalc",
    value: function() {
      var e = this;
      this.file.speed = 0;
      var r = 0;
      this.speedInterval || (this.speedInterval = window.setInterval(function() {
        var o = e.progress / 100 * e.fileSize;
        e.file.speed = o - r, r = o;
      }, 1e3));
    }
    /**
     * Removes the upload speed interval
     */
  }, {
    key: "stopSpeedCalc",
    value: function() {
      this.speedInterval && window.clearInterval(this.speedInterval), this.speedInterval = null, this.file.speed = 0;
    }
  }]), t;
}(), oa = {
  headers: {},
  action: "",
  minSize: 1048576,
  maxActive: 3,
  maxRetries: 5,
  handler: p3
}, vi = Y({
  props: {
    inputId: {
      type: String
    },
    name: {
      type: String,
      default: "file"
    },
    accept: {
      type: String
    },
    capture: {},
    disabled: {
      default: !1
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    maximum: {
      type: Number
    },
    addIndex: {
      type: [Boolean, Number]
    },
    directory: {
      type: Boolean
    },
    createDirectory: {
      type: Boolean,
      default: !1
    },
    postAction: {
      type: String
    },
    putAction: {
      type: String
    },
    customAction: {
      type: Function
    },
    headers: {
      type: Object,
      default: function() {
        return {};
      }
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    },
    timeout: {
      type: Number,
      default: 0
    },
    drop: {
      type: [Boolean, String, HTMLElement],
      default: function() {
        return !1;
      }
    },
    dropDirectory: {
      type: Boolean,
      default: !0
    },
    size: {
      type: Number,
      default: 0
    },
    extensions: {
      type: [RegExp, String, Array],
      default: function() {
        return [];
      }
    },
    modelValue: {
      type: Array,
      default: function() {
        return [];
      }
    },
    thread: {
      type: Number,
      default: 1
    },
    // Chunk upload enabled
    chunkEnabled: {
      type: Boolean,
      default: !1
    },
    // Chunk upload properties
    chunk: {
      type: Object,
      default: function() {
        return oa;
      }
    }
  },
  emits: ["update:modelValue", "input-filter", "input-file"],
  data: function() {
    return {
      files: this.modelValue,
      features: {
        html5: !0,
        directory: !1,
        drop: !1
      },
      active: !1,
      dropActive: !1,
      uploading: 0,
      destroy: !1,
      maps: {},
      dropElement: null,
      dropTimeout: null,
      reload: !1
    };
  },
  /**
   * mounted
   * @return {[type]} [description]
   */
  mounted: function() {
    var n = this, e = document.createElement("input");
    if (e.type = "file", e.multiple = !0, window.FormData && e.files ? ((typeof e.webkitdirectory == "boolean" || typeof e.directory == "boolean") && (this.features.directory = !0), this.features.html5 && typeof e.ondrop < "u" && (this.features.drop = !0)) : this.features.html5 = !1, this.maps = {}, this.files)
      for (var r = 0; r < this.files.length; r++) {
        var o = this.files[r];
        this.maps[o.id] = o;
      }
    this.$nextTick(function() {
      n.$parent ? (n.$parent.$forceUpdate(), n.$parent.$nextTick(function() {
        n.watchDrop(n.drop);
      })) : n.watchDrop(n.drop);
    });
  },
  /**
   * beforeUnmount
   * @return {[type]} [description]
   */
  beforeUnmount: function() {
    this.destroy = !0, this.active = !1, this.watchDrop(!1), this.watchActive(!1);
  },
  computed: {
    /**
     * uploading 正在上传的线程
     * @return {[type]} [description]
     */
    /**
     * uploaded 文件列表是否全部已上传
     * @return {[type]} [description]
     */
    uploaded: function() {
      for (var n, e = 0; e < this.files.length; e++)
        if (n = this.files[e], n.fileObject && !n.error && !n.success)
          return !1;
      return !0;
    },
    chunkOptions: function() {
      return Object.assign(oa, this.chunk);
    },
    className: function() {
      return ["file-uploads", this.features.html5 ? "file-uploads-html5" : "file-uploads-html4", this.features.directory && this.directory ? "file-uploads-directory" : void 0, this.features.drop && this.drop ? "file-uploads-drop" : void 0, this.disabled ? "file-uploads-disabled" : void 0];
    },
    forId: function() {
      return this.inputId || this.name;
    },
    iMaximum: function() {
      return this.maximum === void 0 ? this.multiple ? 0 : 1 : this.maximum;
    },
    iExtensions: function() {
      if (this.extensions) {
        if (this.extensions instanceof RegExp)
          return this.extensions;
        if (this.extensions.length) {
          var n = [];
          return typeof this.extensions == "string" ? n = this.extensions.split(",") : n = this.extensions, n = n.map(function(e) {
            return e.trim();
          }).filter(function(e) {
            return e;
          }), new RegExp("\\.(" + n.join("|").replace(/\./g, "\\.") + ")$", "i");
        }
      }
    },
    iDirectory: function() {
      if (this.directory && this.features.directory)
        return !0;
    }
  },
  watch: {
    active: function(n) {
      this.watchActive(n);
    },
    dropActive: function(n) {
      this.watchDropActive(n), this.$parent && this.$parent.$forceUpdate();
    },
    drop: function(n) {
      this.watchDrop(n);
    },
    modelValue: function(n) {
      if (this.files !== n) {
        this.files = n;
        var e = this.maps;
        this.maps = {};
        for (var r = 0; r < this.files.length; r++) {
          var o = this.files[r];
          this.maps[o.id] = o;
        }
        for (var a in this.maps) {
          var s = this.maps[a], i = e[a];
          s !== i && this.emitFile(s, i);
        }
        for (var l in e)
          this.maps[l] || this.emitFile(void 0, e[l]);
      }
    }
  },
  methods: {
    newId: function() {
      return Math.random().toString(36).substr(2);
    },
    // 清空
    clear: function() {
      if (this.files.length) {
        var n = this.files;
        this.files = [], this.maps = {}, this.emitInput();
        for (var e = 0; e < n.length; e++)
          this.emitFile(void 0, n[e]);
      }
      return !0;
    },
    // 选择
    get: function(n) {
      return n ? an(n) === "object" ? this.maps[n.id || ""] || !1 : this.maps[n] || !1 : !1;
    },
    // 添加
    add: function(n, e) {
      var r;
      n instanceof Array ? r = n : r = [n], e === void 0 && (e = this.addIndex);
      for (var o = [], a = 0; a < r.length; a++) {
        var s = r[a];
        this.features.html5 && s instanceof Blob && (s = {
          id: "",
          file: s,
          size: s.size,
          // @ts-ignore
          name: s.webkitRelativePath || s.relativePath || s.name || "unknown",
          type: s.type
        }), s = s;
        var i = !1;
        if (s.fileObject === !1 || (s.fileObject || typeof Element < "u" && s.el instanceof HTMLInputElement || typeof Blob < "u" && s.file instanceof Blob) && (i = !0), i && (s = lt(lt({
          fileObject: !0,
          size: -1,
          name: "Filename",
          type: "",
          active: !1,
          error: "",
          success: !1,
          putAction: this.putAction,
          postAction: this.postAction,
          timeout: this.timeout
        }, s), {}, {
          response: {},
          progress: "0.00",
          speed: 0
          // 只读
          // file: undefined,
          // xhr: undefined,
          // el: undefined,
          // iframe: undefined,
        }), s.data = lt(lt({}, this.data), s.data ? s.data : {}), s.headers = lt(lt({}, this.headers), s.headers ? s.headers : {})), s.id || (s.id = this.newId()), !this.emitFilter(s, void 0) && (this.iMaximum > 1 && o.length + this.files.length >= this.iMaximum || (o.push(s), this.iMaximum === 1)))
          break;
      }
      if (o.length) {
        this.iMaximum === 1 && this.clear();
        var l;
        if (e === !0 || e === 0)
          l = o.concat(this.files);
        else if (e) {
          var d;
          l = this.files.concat([]), (d = l).splice.apply(d, [e, 0].concat(cr(o)));
        } else
          l = this.files.concat(o);
        this.files = l;
        var p = 0;
        e === !0 || e === 0 ? p = 0 : e ? e >= 0 ? e + o.length > this.files.length ? p = this.files.length - o.length : p = e : (p = this.files.length - o.length + e, p < 0 && (p = 0)) : p = this.files.length - o.length, o = this.files.slice(p, p + o.length);
        for (var _ = 0; _ < o.length; _++) {
          var h = o[_];
          this.maps[h.id] = h;
        }
        this.emitInput();
        for (var y = 0; y < o.length; y++)
          this.emitFile(o[y], void 0);
        return n instanceof Array ? o : o[0];
      }
    },
    // 添加表单文件
    addInputFile: function(n) {
      var e = this, r = [];
      this.iMaximum;
      var o = n.webkitEntries || n.entries || void 0;
      if (o != null && o.length)
        return this.getFileSystemEntry(o).then(function(l) {
          return e.add(l);
        });
      if (n.files)
        for (var a = 0; a < n.files.length; a++) {
          var s = n.files[a];
          r.push({
            id: "",
            size: s.size,
            // @ts-ignore
            name: s.webkitRelativePath || s.relativePath || s.name,
            type: s.type,
            file: s
          });
        }
      else {
        var i = n.value.replace(/\\/g, "/").split("/");
        (!i || !i.length) && (i = [n.value]), delete n.__vuex__, r.push({
          id: "",
          name: i[i.length - 1],
          el: n
        });
      }
      return Promise.resolve(this.add(r));
    },
    // 添加 DataTransfer
    addDataTransfer: function(n) {
      var e, r = this;
      if (n != null && (e = n.items) !== null && e !== void 0 && e.length) {
        for (var o = [], a = 0; a < n.items.length; a++) {
          var s = n.items[a], i = void 0;
          s.getAsEntry ? i = s.getAsEntry() || s.getAsFile() : s.webkitGetAsEntry ? i = s.webkitGetAsEntry() || s.getAsFile() : i = s.getAsFile(), i && o.push(i);
        }
        return this.getFileSystemEntry(o).then(function(_) {
          return r.add(_);
        });
      }
      var l = this.iMaximum, d = [];
      if (n.files.length) {
        for (var p = 0; p < n.files.length && (d.push(n.files[p]), !(l > 0 && d.length >= l)); p++)
          ;
        return Promise.resolve(this.add(d));
      }
      return Promise.resolve([]);
    },
    // 获得 entrys    
    getFileSystemEntry: function(n) {
      var e = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      return new Promise(function(o) {
        var a = e.iMaximum;
        if (!n) {
          o([]);
          return;
        }
        if (n instanceof Array) {
          var s = [], i = function y($) {
            var k = n[$];
            if (!k || a > 0 && s.length >= a)
              return o(s);
            e.getFileSystemEntry(k, r).then(function(M) {
              s.push.apply(s, cr(M)), y($ + 1);
            });
          };
          i(0);
          return;
        }
        if (n instanceof Blob) {
          o([{
            id: "",
            size: n.size,
            // @ts-ignore
            name: r + n.name,
            type: n.type,
            file: n
          }]);
          return;
        }
        if (n.isFile) {
          var l = n;
          l.file(function(y) {
            o([{
              id: "",
              size: y.size,
              name: r + y.name,
              type: y.type,
              file: y
            }]);
          });
          return;
        }
        if (n.isDirectory && e.dropDirectory) {
          var d = n, p = [];
          e.createDirectory && p.push({
            id: "",
            name: r + d.name,
            size: 0,
            type: "text/directory",
            file: new File([], r + d.name, {
              type: "text/directory"
            })
          });
          var _ = d.createReader(), h = function y() {
            _.readEntries(function($) {
              var k = function M(P) {
                if (!$[P] && P === 0 || a > 0 && p.length >= a)
                  return o(p);
                if (!$[P])
                  return y();
                e.getFileSystemEntry($[P], r + d.name + "/").then(function(D) {
                  p.push.apply(p, cr(D)), M(P + 1);
                });
              };
              k(0);
            });
          };
          h();
          return;
        }
        o([]);
      });
    },
    // 替换
    replace: function(n, e) {
      var r = this.get(n), o = this.get(e);
      if (!r || !o || r === o)
        return !1;
      var a = this.files.concat([]), s = a.indexOf(r), i = a.indexOf(o);
      return s === -1 || i === -1 ? !1 : (a[s] = o, a[i] = r, this.files = a, this.emitInput(), !0);
    },
    // 移除
    remove: function(n) {
      var e = this.get(n);
      if (e) {
        if (this.emitFilter(void 0, e))
          return !1;
        var r = this.files.concat([]), o = r.indexOf(e);
        if (o === -1)
          return console.error("remove", e), !1;
        r.splice(o, 1), this.files = r, delete this.maps[e.id], this.emitInput(), this.emitFile(void 0, e);
      }
      return e;
    },
    // 更新
    update: function(n, e) {
      var r = this.get(n);
      if (r) {
        var o = lt(lt({}, r), e);
        if (r.fileObject && r.active && !o.active && !o.error && !o.success && (o.error = "abort"), this.emitFilter(o, r))
          return !1;
        var a = this.files.concat([]), s = a.indexOf(r);
        return s === -1 ? (console.error("update", r), !1) : (a.splice(s, 1, o), this.files = a, o = this.files[s], delete this.maps[r.id], this.maps[o.id] = o, this.emitInput(), this.emitFile(o, r), o);
      }
      return !1;
    },
    // 预处理 事件 过滤器
    emitFilter: function(n, e) {
      var r = !1;
      return this.$emit("input-filter", n, e, function() {
        var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
        return r = o, r;
      }), r;
    },
    // 处理后 事件 分发
    emitFile: function(n, e) {
      var r, o = this;
      this.$emit("input-file", n, e), (r = n) !== null && r !== void 0 && r.fileObject && n.active && (!e || !e.active) ? (this.uploading++, this.$nextTick(function() {
        setTimeout(function() {
          n && o.upload(n).then(function() {
            var a;
            n && (n = o.get(n) || void 0), (a = n) !== null && a !== void 0 && a.fileObject && o.update(n, {
              active: !1,
              success: !n.error
            });
          }).catch(function(a) {
            n && o.update(n, {
              active: !1,
              success: !1,
              error: a.code || a.error || a.message || a
            });
          });
        }, Math.ceil(Math.random() * 50 + 50));
      })) : (!n || !n.fileObject || !n.active) && e && e.fileObject && e.active && this.uploading--, this.active && (!!n != !!e || n.active !== e.active) && this.watchActive(!0);
    },
    emitInput: function() {
      this.$emit("update:modelValue", this.files);
    },
    // 上传
    upload: function(n) {
      var e = this.get(n);
      if (!e)
        return Promise.reject(new Error("not_exists"));
      if (!e.fileObject)
        return Promise.reject(new Error("file_object"));
      if (e.error)
        return e.error instanceof Error ? Promise.reject(e.error) : Promise.reject(new Error(e.error));
      if (e.success)
        return Promise.resolve(e);
      if (e.name && this.iExtensions && e.type !== "text/directory" && e.name.search(this.iExtensions) === -1)
        return Promise.reject(new Error("extension"));
      if (this.size > 0 && e.size !== void 0 && e.size >= 0 && e.size > this.size && e.type !== "text/directory")
        return Promise.reject(new Error("size"));
      if (this.customAction)
        return this.customAction(e, this);
      if (this.features.html5) {
        if (this.shouldUseChunkUpload(e))
          return this.uploadChunk(e);
        if (e.putAction)
          return this.uploadPut(e);
        if (e.postAction)
          return this.uploadHtml5(e);
      }
      return e.postAction ? this.uploadHtml4(e) : Promise.reject(new Error("No action configured"));
    },
    /**
     * Whether this file should be uploaded using chunk upload or not
     *
     * @param Object file
     */
    shouldUseChunkUpload: function(n) {
      return this.chunkEnabled && !!this.chunkOptions.handler && n.size && n.size > this.chunkOptions.minSize;
    },
    /**
     * Upload a file using Chunk method
     *
     * @param File file
     */
    uploadChunk: function(n) {
      var e = this.chunkOptions.handler;
      return n.chunk = new e(n, this.chunkOptions), n.chunk.upload().then(function(r) {
        return n;
      });
    },
    uploadPut: function(n) {
      var e = [], r;
      for (var o in n.data)
        r = n.data[o], r != null && e.push(encodeURIComponent(o) + "=" + encodeURIComponent(r));
      var a = n.putAction || "", s = e.length ? (a.indexOf("?") === -1 ? "?" : "&") + e.join("&") : "", i = new XMLHttpRequest();
      return i.open("PUT", a + s), this.uploadXhr(i, n, n.file);
    },
    uploadHtml5: function(n) {
      var e = new window.FormData(), r;
      for (var o in n.data)
        r = n.data[o], r && an(r) === "object" && typeof r.toString != "function" ? r instanceof File ? e.append(o, r, r.name) : e.append(o, JSON.stringify(r)) : r != null && e.append(o, r);
      e.append(this.name, n.file, n.name || n.file.name || n.file.filename);
      var a = new XMLHttpRequest();
      return a.open("POST", n.postAction || ""), this.uploadXhr(a, n, e);
    },
    uploadXhr: function(n, e, r) {
      var o = this, a = e, s = 0, i = 0;
      n.upload.onprogress = function(d) {
        if (a && (a = o.get(a), !(!d.lengthComputable || !a || !a.fileObject || !a.active))) {
          var p = Math.round(Date.now() / 1e3);
          p !== s && (s = p, a = o.update(a, {
            progress: (d.loaded / d.total * 100).toFixed(2),
            speed: d.loaded - i
          }), i = d.loaded);
        }
      };
      var l = window.setInterval(function() {
        if (a && (a = o.get(a))) {
          var d;
          if ((d = a) !== null && d !== void 0 && d.fileObject && !a.success && !a.error && a.active)
            return;
        }
        l && (clearInterval(l), l = void 0);
        try {
          n.abort(), n.timeout = 1;
        } catch {
        }
      }, 100);
      return new Promise(function(d, p) {
        if (!a) {
          p(new Error("not_exists"));
          return;
        }
        var _, h = function(k) {
          if (!_) {
            if (_ = !0, l && (clearInterval(l), l = void 0), !a)
              return p(new Error("not_exists"));
            if (a = o.get(a), !a)
              return p(new Error("not_exists"));
            if (!a.fileObject)
              return p(new Error("file_object"));
            if (a.error)
              return a.error instanceof Error ? p(a.error) : p(new Error(a.error));
            if (!a.active)
              return p(new Error("abort"));
            if (a.success)
              return d(a);
            var M = {};
            switch (k.type) {
              case "timeout":
              case "abort":
                M.error = k.type;
                break;
              case "error":
                n.status ? n.status >= 500 ? M.error = "server" : n.status >= 400 && (M.error = "denied") : M.error = "network";
                break;
              default:
                n.status >= 500 ? M.error = "server" : n.status >= 400 ? M.error = "denied" : M.progress = "100.00";
            }
            if (n.responseText) {
              var P = n.getResponseHeader("Content-Type");
              P && P.indexOf("/json") !== -1 ? M.response = JSON.parse(n.responseText) : M.response = n.responseText;
            }
            return a = o.update(a, M), a ? a.error ? a.error instanceof Error ? p(a.error) : p(new Error(a.error)) : d(a) : p(new Error("abort"));
          }
        };
        n.onload = h, n.onerror = h, n.onabort = h, n.ontimeout = h, a.timeout && (n.timeout = a.timeout);
        for (var y in a.headers)
          n.setRequestHeader(y, a.headers[y]);
        a = o.update(a, {
          xhr: n
        }), a && n.send(r);
      });
    },
    uploadHtml4: function(n) {
      var e = this, r = n;
      if (!r)
        return Promise.reject(new Error("not_exists"));
      var o = function(h) {
        h.keyCode === 27 && h.preventDefault();
      }, a = document.createElement("iframe");
      a.id = "upload-iframe-" + r.id, a.name = "upload-iframe-" + r.id, a.src = "about:blank", a.setAttribute("style", "width:1px;height:1px;top:-999em;position:absolute; margin-top:-999em;");
      var s = document.createElement("form");
      s.setAttribute("action", r.postAction || ""), s.name = "upload-form-" + r.id, s.setAttribute("method", "POST"), s.setAttribute("target", "upload-iframe-" + r.id), s.setAttribute("enctype", "multipart/form-data");
      for (var i in r.data) {
        var l = r.data[i];
        if (l && an(l) === "object" && typeof l.toString != "function" && (l = JSON.stringify(l)), l != null) {
          var d = document.createElement("input");
          d.type = "hidden", d.name = i, d.value = l, s.appendChild(d);
        }
      }
      s.appendChild(r.el), document.body.appendChild(a).appendChild(s);
      var p = function() {
        var h, y;
        try {
          a.contentWindow && (y = a.contentWindow.document);
        } catch {
        }
        if (!y)
          try {
            y = a.contentDocument ? a.contentDocument : a.document;
          } catch {
            y = a.document;
          }
        return (h = y) !== null && h !== void 0 && h.body ? y.body.innerHTML : null;
      };
      return new Promise(function(_, h) {
        setTimeout(function() {
          if (!r) {
            h(new Error("not_exists"));
            return;
          }
          if (r = e.update(r, {
            iframe: a
          }), !r)
            return h(new Error("not_exists"));
          var y = window.setInterval(function() {
            r && (r = e.get(r)) && r.fileObject && !r.success && !r.error && r.active || (y && (clearInterval(y), y = void 0), a.onabort({
              type: r ? "abort" : "not_exists"
            }));
          }, 100), $, k = function(P) {
            var D;
            if (!$) {
              if ($ = !0, y && (clearInterval(y), y = void 0), document.body.removeEventListener("keydown", o), !r)
                return h(new Error("not_exists"));
              if (r = e.get(r), !r)
                return h(new Error("not_exists"));
              if (!r.fileObject)
                return h(new Error("file_object"));
              if (r.error)
                return r.error instanceof Error ? h(r.error) : h(new Error(r.error));
              if (!r.active)
                return h(new Error("abort"));
              if (r.success)
                return _(r);
              var U = p(), F = {};
              if (typeof P == "string")
                return h(new Error(P));
              switch (P.type) {
                case "abort":
                  F.error = "abort";
                  break;
                case "error":
                  r.error ? F.error = r.error : U === null ? F.error = "network" : F.error = "denied";
                  break;
                default:
                  r.error ? F.error = r.error : U === null ? F.error = "network" : F.progress = "100.00";
              }
              if (U !== null) {
                if (U && U.substr(0, 1) === "{" && U.substr(U.length - 1, 1) === "}")
                  try {
                    U = JSON.parse(U);
                  } catch {
                  }
                F.response = U;
              }
              return r = e.update(r, F), r ? (D = r) !== null && D !== void 0 && D.error ? r.error instanceof Error ? h(r.error) : h(new Error(r.error)) : _(r) : h(new Error("not_exists"));
            }
          };
          a.onload = k, a.onerror = k, a.onabort = k, document.body.addEventListener("keydown", o), s.submit();
        }, 50);
      }).then(function(_) {
        var h;
        return a == null || (h = a.parentNode) === null || h === void 0 || h.removeChild(a), _;
      }).catch(function(_) {
        var h;
        return a == null || (h = a.parentNode) === null || h === void 0 || h.removeChild(a), _;
      });
    },
    watchActive: function(n) {
      for (var e, r = 0; e = this.files[r]; )
        if (r++, e.fileObject)
          if (n && !this.destroy) {
            if (this.uploading >= this.thread || this.uploading && !this.features.html5)
              break;
            !e.active && !e.error && !e.success && this.update(e, {
              active: !0
            });
          } else
            e.active && this.update(e, {
              active: !1
            });
      this.uploading === 0 && (this.active = !1);
    },
    watchDrop: function(n) {
      var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
      if (this.features.drop && n !== e) {
        if (this.dropElement)
          try {
            document.removeEventListener("dragenter", this.onDocumentDragenter, !1), document.removeEventListener("dragleave", this.onDocumentDragleave, !1), document.removeEventListener("dragover", this.onDocumentDragover, !1), document.removeEventListener("drop", this.onDocumentDrop, !1), this.dropElement.removeEventListener("dragover", this.onDragover, !1), this.dropElement.removeEventListener("drop", this.onDrop, !1);
          } catch {
          }
        var r = null;
        if (n)
          if (typeof n == "string")
            r = document.querySelector(n) || this.$root.$el.querySelector(n);
          else if (n === !0) {
            var o;
            if (r = this.$parent.$el, !r || ((o = r) === null || o === void 0 ? void 0 : o.nodeType) === 8) {
              var a;
              r = this.$root.$el, (!r || ((a = r) === null || a === void 0 ? void 0 : a.nodeType) === 8) && (r = document.body);
            }
          } else
            r = n;
        this.dropElement = r, this.dropElement && (document.addEventListener("dragenter", this.onDocumentDragenter, !1), document.addEventListener("dragleave", this.onDocumentDragleave, !1), document.addEventListener("dragover", this.onDocumentDragover, !1), document.addEventListener("drop", this.onDocumentDrop, !1), this.dropElement.addEventListener("dragover", this.onDragover, !1), this.dropElement.addEventListener("drop", this.onDrop, !1));
      }
    },
    watchDropActive: function(n, e) {
      n !== e && (this.dropTimeout && (clearTimeout(this.dropTimeout), this.dropTimeout = null), n && (this.dropTimeout = setTimeout(this.onDocumentDrop, 1e3)));
    },
    onDocumentDragenter: function(n) {
      var e, r;
      if (!this.dropActive && n.dataTransfer) {
        var o = n.dataTransfer;
        o != null && (e = o.files) !== null && e !== void 0 && e.length ? this.dropActive = !0 : o.types ? o.types.indexOf && o.types.indexOf("Files") !== -1 ? this.dropActive = !0 : (r = o.types) !== null && r !== void 0 && r.contains && o.types.contains("Files") && (this.dropActive = !0) : this.dropActive = !0, this.dropActive && this.watchDropActive(!0);
      }
    },
    onDocumentDragleave: function(n) {
      this.dropActive && (n.target === n.explicitOriginalTarget || !n.fromElement && (n.clientX <= 0 || n.clientY <= 0 || n.clientX >= window.innerWidth || n.clientY >= window.innerHeight)) && (this.dropActive = !1, this.watchDropActive(!1));
    },
    onDocumentDragover: function() {
      this.watchDropActive(!0);
    },
    onDocumentDrop: function() {
      this.dropActive = !1, this.watchDropActive(!1);
    },
    onDragover: function(n) {
      n.preventDefault();
    },
    onDrop: function(n) {
      n.preventDefault(), n.dataTransfer && this.addDataTransfer(n.dataTransfer);
    },
    inputOnChange: async function(n) {
      var e = this;
      if (!(n.target instanceof HTMLInputElement))
        return Promise.reject(new Error("not HTMLInputElement"));
      n.target;
      var r = function(a) {
        return e.reload = !0, e.$nextTick(function() {
          e.reload = !1;
        }), a;
      };
      return this.addInputFile(n.target).then(r).catch(r);
    }
  }
}), v3 = ["for"], h3 = ["name", "id", "accept", "capture", "disabled", "webkitdirectory", "allowdirs", "directory", "multiple"];
function _3(t, n, e, r, o, a) {
  return v(), w("span", {
    class: m(t.className)
  }, [H(t.$slots, "default"), g("label", {
    for: t.forId
  }, null, 8, v3), t.reload ? E("", !0) : (v(), w("input", {
    key: 0,
    ref: "input",
    type: "file",
    name: t.name,
    id: t.forId,
    accept: t.accept,
    capture: t.capture,
    disabled: t.disabled,
    webkitdirectory: t.iDirectory,
    allowdirs: t.iDirectory,
    directory: t.iDirectory,
    multiple: t.multiple && t.features.html5,
    onChange: n[0] || (n[0] = function() {
      return t.inputOnChange && t.inputOnChange.apply(t, arguments);
    })
  }, null, 40, h3))], 2);
}
function m3(t, n) {
  n === void 0 && (n = {});
  var e = n.insertAt;
  if (!(!t || typeof document > "u")) {
    var r = document.head || document.getElementsByTagName("head")[0], o = document.createElement("style");
    o.type = "text/css", e === "top" && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = t : o.appendChild(document.createTextNode(t));
  }
}
var g3 = `
.file-uploads {
  overflow: hidden;
  position: relative;
  text-align: center;
  display: inline-block;
}
.file-uploads.file-uploads-html4 input,
.file-uploads.file-uploads-html5 label {
  /* background fix ie  click */
  background: #fff;
  opacity: 0;
  font-size: 20em;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  width: 100%;
  height: 100%;
}
.file-uploads.file-uploads-html5 input,
.file-uploads.file-uploads-html4 label {
  /* background fix ie  click */
  position: absolute;
  background: rgba(255, 255, 255, 0);
  overflow: hidden;
  position: fixed;
  width: 1px;
  height: 1px;
  z-index: -1;
  opacity: 0;
}
`;
m3(g3);
vi.render = _3;
const b3 = /* @__PURE__ */ g("p", null, [
  /* @__PURE__ */ g("b", null, "Drag and drop"),
  /* @__PURE__ */ Q(" or "),
  /* @__PURE__ */ g("label", { for: "file" }, "browse"),
  /* @__PURE__ */ Q(" to upload file(s) ")
], -1), y3 = /* @__PURE__ */ g("p", null, "Maximum upload size per post: 100MB", -1), w3 = [
  b3,
  y3
], C3 = /* @__PURE__ */ Y({
  __name: "VFileUploader",
  props: /* @__PURE__ */ Vi({
    accept: {},
    error: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(t) {
    const n = Pi(t, "modelValue"), e = ie(null), r = he();
    return (o, a) => {
      var s;
      return v(), w("div", {
        class: m(c(r)["v-file-uploader"])
      }, [
        g("div", {
          class: m([
            c(r)["v-file-uploader__body"],
            {
              [c(r)["v-file-uploader__body--error"]]: !!o.error
            }
          ])
        }, [
          g("div", {
            class: m(c(r)["v-file-uploader__wrapper"])
          }, [
            j(n3, {
              class: m(c(r)["v-file-uploader__upload-icon"])
            }, null, 8, ["class"]),
            g("div", {
              class: m(c(r)["v-file-uploader__content"])
            }, w3, 2)
          ], 2),
          it(g("div", {
            class: m(c(r)["v-file-uploader_overlay"])
          }, " Drop files to upload ", 2), [
            [sn, (s = e.value) == null ? void 0 : s.dropActive]
          ]),
          it(j(c(vi), {
            ref_key: "upload",
            ref: e,
            modelValue: n.value,
            "onUpdate:modelValue": a[0] || (a[0] = (i) => n.value = i),
            accept: o.accept,
            multiple: "",
            drop: "",
            capture: !1,
            "drop-directory": ""
          }, {
            default: ee(() => [
              Q(" Select files ")
            ]),
            _: 1
          }, 8, ["modelValue", "accept"]), [
            [sn, !1]
          ])
        ], 2),
        o.error ? (v(), L(c(ga), {
          key: 0,
          error: o.error
        }, null, 8, ["error"])) : E("", !0)
      ], 2);
    };
  }
}), $3 = {
  "v-file-uploader__body": "_v-file-uploader__body_1bepf_1",
  "v-file-uploader__body--error": "_v-file-uploader__body--error_1bepf_13",
  "v-file-uploader__upload-icon": "_v-file-uploader__upload-icon_1bepf_16",
  "v-file-uploader__wrapper": "_v-file-uploader__wrapper_1bepf_24",
  "v-file-uploader__content": "_v-file-uploader__content_1bepf_36",
  "v-file-uploader_overlay": "_v-file-uploader_overlay_1bepf_57"
}, k3 = {
  $style: $3
}, v5 = /* @__PURE__ */ V(C3, [["__cssModules", k3]]), M3 = {}, D3 = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "16",
  width: "16",
  viewBox: "0 0 16 16"
}, S3 = /* @__PURE__ */ Nn('<g fill="currentColor"><line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" x1="4.5" y1="11.5" x2="11.5" y2="11.5" data-color="color-2"></line> <line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" x1="4.5" y1="8.5" x2="11.5" y2="8.5" data-color="color-2"></line> <line fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" x1="4.5" y1="5.5" x2="6.5" y2="5.5" data-color="color-2"></line> <polygon fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" points="9.5,0.5 1.5,0.5 1.5,15.5 14.5,15.5 14.5,5.5 "></polygon> <polyline fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" points="9.5,0.5 9.5,5.5 14.5,5.5 "></polyline></g>', 1), O3 = [
  S3
];
function T3(t, n) {
  return v(), w("svg", D3, O3);
}
const A3 = /* @__PURE__ */ V(M3, [["render", T3]]), E3 = /* @__PURE__ */ Y({
  __name: "VFileAttachmentField",
  props: {
    fileName: {},
    fileType: {},
    fileTypeOptions: {},
    foreground: { type: Boolean, default: !1 },
    borderless: { type: Boolean, default: !1 },
    showLabels: { type: Boolean, default: !0 },
    appendToBody: { type: Boolean, default: !0 }
  },
  emits: ["update:fileName", "update:fileType"],
  setup(t, { emit: n }) {
    const e = t, r = n, o = I(() => ({
      fileName: {
        required: dr.withMessage("File Name is not valid.", fr)
      },
      fileType: {
        required: dr.withMessage("File Type is not valid.", fr)
      }
    })), a = pa(o, e), s = he();
    return (i, l) => {
      var d, p, _, h;
      return v(), w("div", {
        class: m(c(s)["v-file-attachment"])
      }, [
        j(c(Yn), {
          class: m(c(s)["v-file-attachment__input"]),
          "model-value": i.fileName,
          "prefix-icon": A3,
          label: i.showLabels ? "File Name" : "",
          "show-required-star": i.showLabels,
          foreground: i.foreground,
          borderless: i.borderless,
          "with-error": !!((d = c(a).fileName.$errors[0]) != null && d.$message),
          error: String((p = c(a).fileName.$errors[0]) == null ? void 0 : p.$message),
          "onUpdate:modelValue": l[0] || (l[0] = (y) => r("update:fileName", y))
        }, null, 8, ["class", "model-value", "label", "show-required-star", "foreground", "borderless", "with-error", "error"]),
        j(c(Lr), {
          class: m(c(s)["v-file-attachment__select"]),
          "model-value": i.fileType,
          foreground: i.foreground,
          "show-required-star": i.showLabels,
          label: i.showLabels ? "File Type" : "",
          borderless: i.borderless,
          "append-to-body": i.appendToBody,
          filterable: "",
          searchable: "",
          options: i.fileTypeOptions,
          "with-error": !!((_ = c(a).fileType.$errors[0]) != null && _.$message),
          error: String((h = c(a).fileType.$errors[0]) == null ? void 0 : h.$message),
          "onUpdate:modelValue": l[1] || (l[1] = (y) => r("update:fileType", y))
        }, null, 8, ["class", "model-value", "foreground", "show-required-star", "label", "borderless", "append-to-body", "options", "with-error", "error"])
      ], 2);
    };
  }
}), x3 = {
  "v-file-attachment": "_v-file-attachment_15hww_1",
  "v-file-attachment__select": "_v-file-attachment__select_15hww_13",
  "v-file-attachment__input": "_v-file-attachment__input_15hww_16"
}, I3 = {
  $style: x3
}, h5 = /* @__PURE__ */ V(E3, [["__cssModules", I3]]);
export {
  f5 as VActions,
  yt as VAvatar,
  Z3 as VAvatarGroup,
  ut as VAvatarSizes,
  zn as VBaseField,
  Gr as VBaseModal,
  xn as VButton,
  pr as VButtonSizes,
  An as VButtonTags,
  Hi as VButtonTypes,
  En as VButtonVariants,
  z3 as VCheckbox,
  Rn as VCheckboxSizes,
  La as VChip,
  p5 as VColorPicker,
  c5 as VCreateViewModal,
  W3 as VCurrencyField,
  dl as VDateField,
  U3 as VDatetimeField,
  l5 as VEditableTableItem,
  G3 as VEmailField,
  ga as VError,
  np as VFieldValue,
  h5 as VFileAttachmentField,
  v5 as VFileUploader,
  Yn as VInput,
  ma as VLabel,
  Wn as VMarkedText,
  Mr as VMarkedTextVariants,
  i5 as VMultiSelect,
  va as VNavItem,
  u5 as VNewVersion,
  ka as VNumberField,
  q3 as VPercentField,
  yo as VProfile,
  r5 as VRecordCard,
  t5 as VRecordKanbanCard,
  n5 as VRecordKanbanColumn,
  Lr as VSelect,
  Ht as VShrinkText,
  H3 as VSidebar,
  e5 as VSidebarMobile,
  at as VSkeletonLoader,
  a5 as VSkeletonRecordsPage,
  kr as VSpinner,
  Pt as VSpinnerSizes,
  $r as VSpinnerVariants,
  up as VStatusSelect,
  ha as VStatusSelectAlign,
  _a as VStatusSelectSize,
  X3 as VSupportCenter,
  d5 as VTab,
  o5 as VTable,
  Y3 as VTextarea,
  ft as VTooltip,
  J3 as VTopbar,
  Q3 as VTopbarMobile,
  s5 as VUpdateField,
  K3 as VUserField,
  Ge as V_BASE_FIELD_DEFAULT_PROPS,
  Bn as getUnifiedString
};
